<template>
	<div class="container">		
		<div class="content">
			<div class="header-clear"></div>
			<div class="row">
                <div class="col-12 text-center">
                    <a href="/">
                        <img style="display:inline;"
                            src="../assets/images/logo-white.png"
                            class="header-logo"
                            data-displaymode="Original"
                            alt="logo"
                            title="logo"
                        />
                    </a>
                </div>
            </div>
            <div class="row">
				<div class="text-center col-12">
					<h4 style="color: #fff">Portal del Empleado</h4>
				</div>
			</div>
			<div class="row">
				<div class="panel-loginform">
					<div class="panel panel-info">
						<div v-if="status=='produccion'" class="panel-body log-sec">
							<form
								class="form-horizontal"
								id="formLogin"
								autocomplete="on"
								@submit.prevent="autenticar"
							>
								<div class="validation-summary-errors text-danger">
									<ul>
										<li>{{ textoErrorAutenticacion }}</li>
									</ul>
								</div>
								<div class="input-group">
									<span class="input-group-addon">
										<font-awesome-icon icon="fa-solid fa-user"/>
									</span>
									<input
										class="form-control"
										data-val="true"
										data-val-required="Se requiere usuario"
										id="UserName"
										maxlength="50"
										name="UserName"
										ref="UserName"
										placeholder="DNI/NIE"
										type="text"
										autocomplete="username"
										v-model="usuario"
										required
									/>
								</div>
								<div class="input-group mt-15">
									<span class="input-group-addon">
										<font-awesome-icon icon="fa-solid fa-lock"/>
									</span>

									<input
										class="form-control"
										data-val="true"
										data-val-required="Se requiere contraseña"
										id="Password"
										maxlength="50"
										name="Password"
										placeholder="Contraseña"
										:type="tipoCajaPassword"
										autocomplete="current-password"
										v-model="contrasenia"
										required="required"
									/>
								</div>
								
								<div class="form-group mt-15">
									<div class="pull-left">
										<a href="javascript:void(0)" @click="mostrarOcultarPassword();">Mostrar/Ocultar</a>
									</div>
									<div class="pull-right">
										<router-link to="/solicitud-nueva-contrasenia">¿Olvidó su contraseña?</router-link>
									</div>
								</div>
								<div class="form-group mt-20">
									<!-- Button -->
									<div class="col-sm-12 controls">
										<input
											type="submit"
											:value="(autenticando)?'Comprobando, espere...':'Acceder'"
											class="btn btn-danger"
											:class="{'disabled': autenticando}"
										/>
									</div>
								</div>
							</form>
						</div>
						<div v-if="status=='mantenimiento'" class="panel-body log-sec">
							Estamos realizando <strong>tareas de mantenimiento</strong>. Inténtelo más tarde. <br /><br />Disculpe las molestias.
						</div>
					</div>
				</div>
			</div>

			<!-- Footer -->
			<div class="container-fullscreen footer footer-dark">
				<div class="half-bottom text-center">
					<p class="text-center">
						<img
							src="../assets/images/logo-white.png"
							data-displaymode="Original"
							alt="logo"
							title="logo"
						/>
					</p>
				</div>
				<div class="small-text no-bottom text-center">CASI©2024</div>
			</div>
		</div>
	</div>
	
</template>

<script>
// @ is an alias to /src
//import HelloWorld from "@/components/HelloWorld.vue";

export default {
	name: "HomeView",
	data() {
		return {
			usuario:'',
			contrasenia:'',
			enviado: false,
			tipoCajaPassword: 'password'
		}
	},
	components: {},
	beforeCreate(){
		this.$store.commit('establecerEstadoAutenticacion', false);
		this.$store.commit('establecerTextoErrorAutenticacion', '');
		this.$store.commit('limpiarPerfil');
		this.$store.dispatch('comprobarStatus');
	},
	created(){
		this.avisarCierreSesionApp();
	},
	mounted() {
		document.body.classList.add("bg-login");
		document.body.classList.add("login-page");
		this.$toast.clear();
		this.$refs.UserName.focus();
	},
	methods:{
		autenticar(){
			this.tipoCajaPassword = "password";

			this.$store.dispatch('autenticar',
				{
					usuario: this.usuario.toUpperCase(),
					contrasenia: this.contrasenia
				}
			);
		},
		mostrarOcultarPassword(){
			if(this.tipoCajaPassword === "password") return this.tipoCajaPassword = "text";

			if(this.tipoCajaPassword === "text") return this.tipoCajaPassword = "password";
		},
		avisarCierreSesionApp(){
			//window.parent.postMessage({event: 'endSession'},'*');
			const target = window['cordova_iab'] ??
			window['webkit']?.messageHandlers['cordova_iab'] ??
			window['opener'] ??
			window['parent'] ??
			window;

			const data = JSON.stringify({event: 'endSession'});

			target.postMessage(data, "*");
		}
	},
	computed:{
		textoErrorAutenticacion(){
			return this.$store.state.textoErrorAutenticacion;
		},
		autenticando(){
			return this.$store.state.autenticando;
		},
		status(){
			return this.$store.state.status;
		}
	}
};
</script>

<style scoped>
    /* @import "../assets/styles/login.css"; */
	/* login */

	html {
		font-family: sans-serif;
		-webkit-text-size-adjust: 100%;
		-ms-text-size-adjust: 100%
	}

	body {
		margin: 0
	}

	article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary {
		display: block
	}

	audio,canvas,progress,video {
		display: inline-block;
		vertical-align: baseline
	}

	audio:not([controls]) {
		display: none;
		height: 0
	}

	[hidden],template {
		display: none
	}

	a {
		background-color: transparent
	}

	a:active,a:hover {
		outline: 0
	}

	abbr[title] {
		border-bottom: 1px dotted
	}

	b,strong {
		font-weight: 700
	}

	dfn {
		font-style: italic
	}

	h1 {
		margin: .67em 0;
		font-size: 2em
	}

	mark {
		color: #000;
		background: #ff0
	}

	small {
		font-size: 80%
	}

	sub,sup {
		position: relative;
		font-size: 75%;
		line-height: 0;
		vertical-align: baseline
	}

	sup {
		top: -.5em
	}

	sub {
		bottom: -.25em
	}

	img {
		border: 0
	}

	svg:not(:root) {
		overflow: hidden
	}

	figure {
		margin: 1em 40px
	}

	hr {
		height: 0;
		-webkit-box-sizing: content-box;
		-moz-box-sizing: content-box;
		box-sizing: content-box
	}

	pre {
		overflow: auto
	}

	code,kbd,pre,samp {
		font-family: monospace,monospace;
		font-size: 1em
	}

	button,input,optgroup,select,textarea {
		margin: 0;
		font: inherit;
		color: inherit
	}

	button {
		overflow: visible
	}

	button,select {
		text-transform: none
	}

	button,html input[type="button"],input[type="reset"],input[type="submit"] {
		-webkit-appearance: button;
		appearance: button;
		cursor: pointer
	}

	button[disabled],html input[disabled] {
		cursor: default
	}

	button::-moz-focus-inner,input::-moz-focus-inner {
		padding: 0;
		border: 0
	}

	input {
		line-height: normal
	}

	input[type="checkbox"],input[type="radio"] {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box;
		padding: 0
	}

	input[type="number"]::-webkit-inner-spin-button,input[type="number"]::-webkit-outer-spin-button {
		height: auto
	}

	input[type="search"] {
		-webkit-box-sizing: content-box;
		-moz-box-sizing: content-box;
		box-sizing: content-box;
		-webkit-appearance: textfield;
		appearance: textfield;
	}

	input[type="search"]::-webkit-search-cancel-button,input[type="search"]::-webkit-search-decoration {
		-webkit-appearance: none
	}

	fieldset {
		padding: .35em .625em .75em;
		margin: 0 2px;
		border: 1px solid silver
	}

	legend {
		padding: 0;
		border: 0
	}

	textarea {
		overflow: auto
	}

	optgroup {
		font-weight: 700
	}

	table {
		border-spacing: 0;
		border-collapse: collapse
	}

	td,th {
		padding: 0
	}

	@media print {
		*,:before,:after {
			color: #000!important;
			text-shadow: none!important;
			background: transparent!important;
			-webkit-box-shadow: none!important;
			box-shadow: none!important
		}

		a,a:visited {
			text-decoration: underline
		}

		a[href]:after {
			content: " (" attr(href) ")"
		}

		abbr[title]:after {
			content: " (" attr(title) ")"
		}

		a[href^="#"]:after,a[href^="javascript:"]:after {
			content: ""
		}

		pre,blockquote {
			border: 1px solid #999;
			page-break-inside: avoid
		}

		thead {
			display: table-header-group
		}

		tr,img {
			page-break-inside: avoid
		}

		img {
			max-width: 100%!important
		}

		p,h2,h3 {
			orphans: 3;
			widows: 3
		}

		h2,h3 {
			page-break-after: avoid
		}

		select {
			background: #fff!important
		}

		.navbar {
			display: none
		}

		.btn>.caret,.dropup>.btn>.caret {
			border-top-color: #000!important
		}

		.label {
			border: 1px solid #000
		}

		.table {
			border-collapse: collapse!important
		}

		.table td,.table th {
			background-color: #fff!important
		}

		.table-bordered th,.table-bordered td {
			border: 1px solid #ddd!important
		}
	}
	/*
	@font-face {
		font-family: 'Glyphicons Halflings';
		src: url(fonts/glyphicons-halflings-regular.eot);
		src: url(fonts/glyphicons-halflings-regular.eot?#iefix) format("embedded-opentype"),url(fonts/glyphicons-halflings-regular.woff2) format("woff2"),url(fonts/glyphicons-halflings-regular.woff) format("woff"),url(fonts/glyphicons-halflings-regular.ttf) format("truetype"),url(fonts/glyphicons-halflings-regular.svg#glyphicons_halflingsregular) format("svg")
	}


	.glyphicon {
		position: relative;
		top: 1px;
		display: inline-block;
		font-family: 'Glyphicons Halflings';
		font-style: normal;
		font-weight: 400;
		line-height: 1;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale
	}

	.glyphicon-asterisk:before {
		content: "*"
	}

	.glyphicon-plus:before {
		content: "+"
	}

	.glyphicon-euro:before,.glyphicon-eur:before {
		content: "€"
	}

	.glyphicon-minus:before {
		content: "−"
	}

	.glyphicon-cloud:before {
		content: "☁"
	}

	.glyphicon-envelope:before {
		content: "✉"
	}

	.glyphicon-pencil:before {
		content: "✏"
	}

	.glyphicon-glass:before {
		content: ""
	}

	.glyphicon-music:before {
		content: ""
	}

	.glyphicon-search:before {
		content: ""
	}

	.glyphicon-heart:before {
		content: ""
	}

	.glyphicon-star:before {
		content: ""
	}

	.glyphicon-star-empty:before {
		content: ""
	}

	.glyphicon-user:before {
		content: ""
	}

	.glyphicon-film:before {
		content: ""
	}

	.glyphicon-th-large:before {
		content: ""
	}

	.glyphicon-th:before {
		content: ""
	}

	.glyphicon-th-list:before {
		content: ""
	}

	.glyphicon-ok:before {
		content: ""
	}

	.glyphicon-remove:before {
		content: ""
	}

	.glyphicon-zoom-in:before {
		content: ""
	}

	.glyphicon-zoom-out:before {
		content: ""
	}

	.glyphicon-off:before {
		content: ""
	}

	.glyphicon-signal:before {
		content: ""
	}

	.glyphicon-cog:before {
		content: ""
	}

	.glyphicon-trash:before {
		content: ""
	}

	.glyphicon-home:before {
		content: ""
	}

	.glyphicon-file:before {
		content: ""
	}

	.glyphicon-time:before {
		content: ""
	}

	.glyphicon-road:before {
		content: ""
	}

	.glyphicon-download-alt:before {
		content: ""
	}

	.glyphicon-download:before {
		content: ""
	}

	.glyphicon-upload:before {
		content: ""
	}

	.glyphicon-inbox:before {
		content: ""
	}

	.glyphicon-play-circle:before {
		content: ""
	}

	.glyphicon-repeat:before {
		content: ""
	}

	.glyphicon-refresh:before {
		content: ""
	}

	.glyphicon-list-alt:before {
		content: ""
	}

	.glyphicon-lock:before {
		content: ""
	}

	.glyphicon-flag:before {
		content: ""
	}

	.glyphicon-headphones:before {
		content: ""
	}

	.glyphicon-volume-off:before {
		content: ""
	}

	.glyphicon-volume-down:before {
		content: ""
	}

	.glyphicon-volume-up:before {
		content: ""
	}

	.glyphicon-qrcode:before {
		content: ""
	}

	.glyphicon-barcode:before {
		content: ""
	}

	.glyphicon-tag:before {
		content: ""
	}

	.glyphicon-tags:before {
		content: ""
	}

	.glyphicon-book:before {
		content: ""
	}

	.glyphicon-bookmark:before {
		content: ""
	}

	.glyphicon-print:before {
		content: ""
	}

	.glyphicon-camera:before {
		content: ""
	}

	.glyphicon-font:before {
		content: ""
	}

	.glyphicon-bold:before {
		content: ""
	}

	.glyphicon-italic:before {
		content: ""
	}

	.glyphicon-text-height:before {
		content: ""
	}

	.glyphicon-text-width:before {
		content: ""
	}

	.glyphicon-align-left:before {
		content: ""
	}

	.glyphicon-align-center:before {
		content: ""
	}

	.glyphicon-align-right:before {
		content: ""
	}

	.glyphicon-align-justify:before {
		content: ""
	}

	.glyphicon-list:before {
		content: ""
	}

	.glyphicon-indent-left:before {
		content: ""
	}

	.glyphicon-indent-right:before {
		content: ""
	}

	.glyphicon-facetime-video:before {
		content: ""
	}

	.glyphicon-picture:before {
		content: ""
	}

	.glyphicon-map-marker:before {
		content: ""
	}

	.glyphicon-adjust:before {
		content: ""
	}

	.glyphicon-tint:before {
		content: ""
	}

	.glyphicon-edit:before {
		content: ""
	}

	.glyphicon-share:before {
		content: ""
	}

	.glyphicon-check:before {
		content: ""
	}

	.glyphicon-move:before {
		content: ""
	}

	.glyphicon-step-backward:before {
		content: ""
	}

	.glyphicon-fast-backward:before {
		content: ""
	}

	.glyphicon-backward:before {
		content: ""
	}

	.glyphicon-play:before {
		content: ""
	}

	.glyphicon-pause:before {
		content: ""
	}

	.glyphicon-stop:before {
		content: ""
	}

	.glyphicon-forward:before {
		content: ""
	}

	.glyphicon-fast-forward:before {
		content: ""
	}

	.glyphicon-step-forward:before {
		content: ""
	}

	.glyphicon-eject:before {
		content: ""
	}

	.glyphicon-chevron-left:before {
		content: ""
	}

	.glyphicon-chevron-right:before {
		content: ""
	}

	.glyphicon-plus-sign:before {
		content: ""
	}

	.glyphicon-minus-sign:before {
		content: ""
	}

	.glyphicon-remove-sign:before {
		content: ""
	}

	.glyphicon-ok-sign:before {
		content: ""
	}

	.glyphicon-question-sign:before {
		content: ""
	}

	.glyphicon-info-sign:before {
		content: ""
	}

	.glyphicon-screenshot:before {
		content: ""
	}

	.glyphicon-remove-circle:before {
		content: ""
	}

	.glyphicon-ok-circle:before {
		content: ""
	}

	.glyphicon-ban-circle:before {
		content: ""
	}

	.glyphicon-arrow-left:before {
		content: ""
	}

	.glyphicon-arrow-right:before {
		content: ""
	}

	.glyphicon-arrow-up:before {
		content: ""
	}

	.glyphicon-arrow-down:before {
		content: ""
	}

	.glyphicon-share-alt:before {
		content: ""
	}

	.glyphicon-resize-full:before {
		content: ""
	}

	.glyphicon-resize-small:before {
		content: ""
	}

	.glyphicon-exclamation-sign:before {
		content: ""
	}

	.glyphicon-gift:before {
		content: ""
	}

	.glyphicon-leaf:before {
		content: ""
	}

	.glyphicon-fire:before {
		content: ""
	}

	.glyphicon-eye-open:before {
		content: ""
	}

	.glyphicon-eye-close:before {
		content: ""
	}

	.glyphicon-warning-sign:before {
		content: ""
	}

	.glyphicon-plane:before {
		content: ""
	}

	.glyphicon-calendar:before {
		content: ""
	}

	.glyphicon-random:before {
		content: ""
	}

	.glyphicon-comment:before {
		content: ""
	}

	.glyphicon-magnet:before {
		content: ""
	}

	.glyphicon-chevron-up:before {
		content: ""
	}

	.glyphicon-chevron-down:before {
		content: ""
	}

	.glyphicon-retweet:before {
		content: ""
	}

	.glyphicon-shopping-cart:before {
		content: ""
	}

	.glyphicon-folder-close:before {
		content: ""
	}

	.glyphicon-folder-open:before {
		content: ""
	}

	.glyphicon-resize-vertical:before {
		content: ""
	}

	.glyphicon-resize-horizontal:before {
		content: ""
	}

	.glyphicon-hdd:before {
		content: ""
	}

	.glyphicon-bullhorn:before {
		content: ""
	}

	.glyphicon-bell:before {
		content: ""
	}

	.glyphicon-certificate:before {
		content: ""
	}

	.glyphicon-thumbs-up:before {
		content: ""
	}

	.glyphicon-thumbs-down:before {
		content: ""
	}

	.glyphicon-hand-right:before {
		content: ""
	}

	.glyphicon-hand-left:before {
		content: ""
	}

	.glyphicon-hand-up:before {
		content: ""
	}

	.glyphicon-hand-down:before {
		content: ""
	}

	.glyphicon-circle-arrow-right:before {
		content: ""
	}

	.glyphicon-circle-arrow-left:before {
		content: ""
	}

	.glyphicon-circle-arrow-up:before {
		content: ""
	}

	.glyphicon-circle-arrow-down:before {
		content: ""
	}

	.glyphicon-globe:before {
		content: ""
	}

	.glyphicon-wrench:before {
		content: ""
	}

	.glyphicon-tasks:before {
		content: ""
	}

	.glyphicon-filter:before {
		content: ""
	}

	.glyphicon-briefcase:before {
		content: ""
	}

	.glyphicon-fullscreen:before {
		content: ""
	}

	.glyphicon-dashboard:before {
		content: ""
	}

	.glyphicon-paperclip:before {
		content: ""
	}

	.glyphicon-heart-empty:before {
		content: ""
	}

	.glyphicon-link:before {
		content: ""
	}

	.glyphicon-phone:before {
		content: ""
	}

	.glyphicon-pushpin:before {
		content: ""
	}

	.glyphicon-usd:before {
		content: ""
	}

	.glyphicon-gbp:before {
		content: ""
	}

	.glyphicon-sort:before {
		content: ""
	}

	.glyphicon-sort-by-alphabet:before {
		content: ""
	}

	.glyphicon-sort-by-alphabet-alt:before {
		content: ""
	}

	.glyphicon-sort-by-order:before {
		content: ""
	}

	.glyphicon-sort-by-order-alt:before {
		content: ""
	}

	.glyphicon-sort-by-attributes:before {
		content: ""
	}

	.glyphicon-sort-by-attributes-alt:before {
		content: ""
	}

	.glyphicon-unchecked:before {
		content: ""
	}

	.glyphicon-expand:before {
		content: ""
	}

	.glyphicon-collapse-down:before {
		content: ""
	}

	.glyphicon-collapse-up:before {
		content: ""
	}

	.glyphicon-log-in:before {
		content: ""
	}

	.glyphicon-flash:before {
		content: ""
	}

	.glyphicon-log-out:before {
		content: ""
	}

	.glyphicon-new-window:before {
		content: ""
	}

	.glyphicon-record:before {
		content: ""
	}

	.glyphicon-save:before {
		content: ""
	}

	.glyphicon-open:before {
		content: ""
	}

	.glyphicon-saved:before {
		content: ""
	}

	.glyphicon-import:before {
		content: ""
	}

	.glyphicon-export:before {
		content: ""
	}

	.glyphicon-send:before {
		content: ""
	}

	.glyphicon-floppy-disk:before {
		content: ""
	}

	.glyphicon-floppy-saved:before {
		content: ""
	}

	.glyphicon-floppy-remove:before {
		content: ""
	}

	.glyphicon-floppy-save:before {
		content: ""
	}

	.glyphicon-floppy-open:before {
		content: ""
	}

	.glyphicon-credit-card:before {
		content: ""
	}

	.glyphicon-transfer:before {
		content: ""
	}

	.glyphicon-cutlery:before {
		content: ""
	}

	.glyphicon-header:before {
		content: ""
	}

	.glyphicon-compressed:before {
		content: ""
	}

	.glyphicon-earphone:before {
		content: ""
	}

	.glyphicon-phone-alt:before {
		content: ""
	}

	.glyphicon-tower:before {
		content: ""
	}

	.glyphicon-stats:before {
		content: ""
	}

	.glyphicon-sd-video:before {
		content: ""
	}

	.glyphicon-hd-video:before {
		content: ""
	}

	.glyphicon-subtitles:before {
		content: ""
	}

	.glyphicon-sound-stereo:before {
		content: ""
	}

	.glyphicon-sound-dolby:before {
		content: ""
	}

	.glyphicon-sound-5-1:before {
		content: ""
	}

	.glyphicon-sound-6-1:before {
		content: ""
	}

	.glyphicon-sound-7-1:before {
		content: ""
	}

	.glyphicon-copyright-mark:before {
		content: ""
	}

	.glyphicon-registration-mark:before {
		content: ""
	}

	.glyphicon-cloud-download:before {
		content: ""
	}

	.glyphicon-cloud-upload:before {
		content: ""
	}

	.glyphicon-tree-conifer:before {
		content: ""
	}

	.glyphicon-tree-deciduous:before {
		content: ""
	}

	.glyphicon-cd:before {
		content: ""
	}

	.glyphicon-save-file:before {
		content: ""
	}

	.glyphicon-open-file:before {
		content: ""
	}

	.glyphicon-level-up:before {
		content: ""
	}

	.glyphicon-copy:before {
		content: ""
	}

	.glyphicon-paste:before {
		content: ""
	}

	.glyphicon-alert:before {
		content: ""
	}

	.glyphicon-equalizer:before {
		content: ""
	}

	.glyphicon-king:before {
		content: ""
	}

	.glyphicon-queen:before {
		content: ""
	}

	.glyphicon-pawn:before {
		content: ""
	}

	.glyphicon-bishop:before {
		content: ""
	}

	.glyphicon-knight:before {
		content: ""
	}

	.glyphicon-baby-formula:before {
		content: ""
	}

	.glyphicon-tent:before {
		content: "⛺"
	}

	.glyphicon-blackboard:before {
		content: ""
	}

	.glyphicon-bed:before {
		content: ""
	}

	.glyphicon-apple:before {
		content: ""
	}

	.glyphicon-erase:before {
		content: ""
	}

	.glyphicon-hourglass:before {
		content: "⌛"
	}

	.glyphicon-lamp:before {
		content: ""
	}

	.glyphicon-duplicate:before {
		content: ""
	}

	.glyphicon-piggy-bank:before {
		content: ""
	}

	.glyphicon-scissors:before {
		content: ""
	}

	.glyphicon-bitcoin:before {
		content: ""
	}

	.glyphicon-btc:before {
		content: ""
	}

	.glyphicon-xbt:before {
		content: ""
	}

	.glyphicon-yen:before {
		content: "¥"
	}

	.glyphicon-jpy:before {
		content: "¥"
	}

	.glyphicon-ruble:before {
		content: "₽"
	}

	.glyphicon-rub:before {
		content: "₽"
	}

	.glyphicon-scale:before {
		content: ""
	}

	.glyphicon-ice-lolly:before {
		content: ""
	}

	.glyphicon-ice-lolly-tasted:before {
		content: ""
	}

	.glyphicon-education:before {
		content: ""
	}

	.glyphicon-option-horizontal:before {
		content: ""
	}

	.glyphicon-option-vertical:before {
		content: ""
	}

	.glyphicon-menu-hamburger:before {
		content: ""
	}

	.glyphicon-modal-window:before {
		content: ""
	}

	.glyphicon-oil:before {
		content: ""
	}

	.glyphicon-grain:before {
		content: ""
	}

	.glyphicon-sunglasses:before {
		content: ""
	}

	.glyphicon-text-size:before {
		content: ""
	}

	.glyphicon-text-color:before {
		content: ""
	}

	.glyphicon-text-background:before {
		content: ""
	}

	.glyphicon-object-align-top:before {
		content: ""
	}

	.glyphicon-object-align-bottom:before {
		content: ""
	}

	.glyphicon-object-align-horizontal:before {
		content: ""
	}

	.glyphicon-object-align-left:before {
		content: ""
	}

	.glyphicon-object-align-vertical:before {
		content: ""
	}

	.glyphicon-object-align-right:before {
		content: ""
	}

	.glyphicon-triangle-right:before {
		content: ""
	}

	.glyphicon-triangle-left:before {
		content: ""
	}

	.glyphicon-triangle-bottom:before {
		content: ""
	}

	.glyphicon-triangle-top:before {
		content: ""
	}

	.glyphicon-console:before {
		content: ""
	}

	.glyphicon-superscript:before {
		content: ""
	}

	.glyphicon-subscript:before {
		content: ""
	}

	.glyphicon-menu-left:before {
		content: ""
	}

	.glyphicon-menu-right:before {
		content: ""
	}

	.glyphicon-menu-down:before {
		content: ""
	}

	.glyphicon-menu-up:before {
		content: ""
	}
	*/

	* {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box
	}

	:before,:after {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box
	}

	html {
		font-size: 10px;
		-webkit-tap-highlight-color: rgba(0,0,0,0)
	}

	body {
		font-family: "Segoe UI",Helvetica,Arial,sans-serif;
		font-size: 14px;
		line-height: 1.42857143;
		color: #333;
		background-color: #fff
	}

	input,button,select,textarea {
		font-family: inherit;
		font-size: inherit;
		line-height: inherit
	}

	a {
		color: #337ab7;
		text-decoration: none
	}

	a:hover,a:focus {
		color: #23527c;
		text-decoration: underline
	}

	a:focus {
		outline: thin dotted;
		outline: 5px auto -webkit-focus-ring-color;
		outline-offset: -2px
	}

	figure {
		margin: 0
	}

	img {
		vertical-align: middle
	}

	.img-responsive,.thumbnail>img,.thumbnail a>img,.carousel-inner>.item>img,.carousel-inner>.item>a>img {
		display: block;
		max-width: 100%;
		height: auto
	}

	.img-rounded {
		border-radius: 6px
	}

	.img-thumbnail {
		display: inline-block;
		max-width: 100%;
		height: auto;
		padding: 4px;
		line-height: 1.42857143;
		background-color: #fff;
		border: 1px solid #ddd;
		border-radius: 4px;
		-webkit-transition: all .2s ease-in-out;
		-o-transition: all .2s ease-in-out;
		transition: all .2s ease-in-out
	}

	.img-circle {
		border-radius: 50%
	}

	hr {
		margin-top: 20px;
		margin-bottom: 20px;
		border: 0;
		border-top: 1px solid #eee
	}

	.sr-only {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0,0,0,0);
		border: 0
	}

	.sr-only-focusable:active,.sr-only-focusable:focus {
		position: static;
		width: auto;
		height: auto;
		margin: 0;
		overflow: visible;
		clip: auto
	}

	[role="button"] {
		cursor: pointer
	}

	h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6 {
		font-family: inherit;
		font-weight: 500;
		line-height: 1.1;
		color: inherit
	}

	h1 small,h2 small,h3 small,h4 small,h5 small,h6 small,.h1 small,.h2 small,.h3 small,.h4 small,.h5 small,.h6 small,h1 .small,h2 .small,h3 .small,h4 .small,h5 .small,h6 .small,.h1 .small,.h2 .small,.h3 .small,.h4 .small,.h5 .small,.h6 .small {
		font-weight: 400;
		line-height: 1;
		color: #777
	}

	h1,.h1,h2,.h2,h3,.h3 {
		margin-top: 20px;
		margin-bottom: 10px
	}

	h1 small,.h1 small,h2 small,.h2 small,h3 small,.h3 small,h1 .small,.h1 .small,h2 .small,.h2 .small,h3 .small,.h3 .small {
		font-size: 65%
	}

	h4,.h4,h5,.h5,h6,.h6 {
		margin-top: 10px;
		margin-bottom: 10px
	}

	h4 small,.h4 small,h5 small,.h5 small,h6 small,.h6 small,h4 .small,.h4 .small,h5 .small,.h5 .small,h6 .small,.h6 .small {
		font-size: 75%
	}

	h1,.h1 {
		font-size: 36px
	}

	h2,.h2 {
		font-size: 30px
	}

	h3,.h3 {
		font-size: 24px
	}

	h4,.h4 {
		font-size: 18px
	}

	h5,.h5 {
		font-size: 14px
	}

	h6,.h6 {
		font-size: 12px
	}

	p {
		margin: 0 0 10px
	}

	.lead {
		margin-bottom: 20px;
		font-size: 16px;
		font-weight: 300;
		line-height: 1.4
	}

	@media(min-width: 768px) {
		.lead {
			font-size:21px
		}
	}

	small,.small {
		font-size: 85%
	}

	mark,.mark {
		padding: .2em;
		background-color: #fcf8e3
	}

	.text-left {
		text-align: left
	}

	.text-right {
		text-align: right
	}

	.text-center {
		text-align: center
	}

	.text-justify {
		text-align: justify
	}

	.text-nowrap {
		white-space: nowrap
	}

	.text-lowercase {
		text-transform: lowercase
	}

	.text-uppercase {
		text-transform: uppercase
	}

	.text-capitalize {
		text-transform: capitalize
	}

	.text-muted {
		color: #777
	}

	.text-primary {
		color: #337ab7
	}

	a.text-primary:hover {
		color: #286090
	}

	.text-success {
		color: #3c763d
	}

	a.text-success:hover {
		color: #2b542c
	}

	.text-info {
		color: #31708f
	}

	a.text-info:hover {
		color: #245269
	}

	.text-warning {
		color: #8a6d3b
	}

	a.text-warning:hover {
		color: #66512c
	}

	.text-danger {
		color: #d00
	}

	a.text-danger:hover {
		color: #843534
	}

	.bg-primary {
		color: #fff;
		background-color: #337ab7
	}

	a.bg-primary:hover {
		background-color: #286090
	}

	.bg-success {
		background-color: #dff0d8
	}

	a.bg-success:hover {
		background-color: #c1e2b3
	}

	.bg-info {
		background-color: #d9edf7
	}

	a.bg-info:hover {
		background-color: #afd9ee
	}

	.bg-warning {
		background-color: #fcf8e3
	}

	a.bg-warning:hover {
		background-color: #f7ecb5
	}

	.bg-danger {
		background-color: #f2dede
	}

	a.bg-danger:hover {
		background-color: #e4b9b9
	}

	.page-header {
		padding-bottom: 9px;
		margin: 40px 0 20px;
		border-bottom: 1px solid #eee
	}

	ul,ol {
		margin-top: 0;
		margin-bottom: 10px
	}

	ul ul,ol ul,ul ol,ol ol {
		margin-bottom: 0
	}

	.list-unstyled {
		padding-left: 0;
		list-style: none
	}

	.list-inline {
		padding-left: 0;
		margin-left: -5px;
		list-style: none
	}

	.list-inline>li {
		display: inline-block;
		padding-right: 5px;
		padding-left: 5px
	}

	dl {
		margin-top: 0;
		margin-bottom: 20px
	}

	dt,dd {
		line-height: 1.42857143
	}

	dt {
		font-weight: 700
	}

	dd {
		margin-left: 0
	}

	@media(min-width: 768px) {
		.dl-horizontal dt {
			float:left;
			width: 160px;
			overflow: hidden;
			clear: left;
			text-align: right;
			text-overflow: ellipsis;
			white-space: nowrap
		}

		.dl-horizontal dd {
			margin-left: 180px
		}
	}

	abbr[title],abbr[data-original-title] {
		cursor: help;
		border-bottom: 1px dotted #777
	}

	.initialism {
		font-size: 90%;
		text-transform: uppercase
	}

	blockquote {
		padding: 10px 20px;
		margin: 0 0 20px;
		font-size: 17.5px;
		border-left: 5px solid #eee
	}

	blockquote p:last-child,blockquote ul:last-child,blockquote ol:last-child {
		margin-bottom: 0
	}

	blockquote footer,blockquote small,blockquote .small {
		display: block;
		font-size: 80%;
		line-height: 1.42857143;
		color: #777
	}

	blockquote footer:before,blockquote small:before,blockquote .small:before {
		content: '— '
	}

	.blockquote-reverse,blockquote.pull-right {
		padding-right: 15px;
		padding-left: 0;
		text-align: right;
		border-right: 5px solid #eee;
		border-left: 0
	}

	.blockquote-reverse footer:before,blockquote.pull-right footer:before,.blockquote-reverse small:before,blockquote.pull-right small:before,.blockquote-reverse .small:before,blockquote.pull-right .small:before {
		content: ''
	}

	.blockquote-reverse footer:after,blockquote.pull-right footer:after,.blockquote-reverse small:after,blockquote.pull-right small:after,.blockquote-reverse .small:after,blockquote.pull-right .small:after {
		content: ' —'
	}

	address {
		margin-bottom: 20px;
		font-style: normal;
		line-height: 1.42857143
	}

	code,kbd,pre,samp {
		font-family: Menlo,Monaco,Consolas,"Courier New",monospace
	}

	code {
		padding: 2px 4px;
		font-size: 90%;
		color: #c7254e;
		background-color: #f9f2f4;
		border-radius: 4px
	}

	kbd {
		padding: 2px 4px;
		font-size: 90%;
		color: #fff;
		background-color: #333;
		border-radius: 3px;
		-webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.25);
		box-shadow: inset 0 -1px 0 rgba(0,0,0,.25)
	}

	kbd kbd {
		padding: 0;
		font-size: 100%;
		font-weight: 700;
		-webkit-box-shadow: none;
		box-shadow: none
	}

	pre {
		display: block;
		padding: 9.5px;
		margin: 0 0 10px;
		font-size: 13px;
		line-height: 1.42857143;
		color: #333;
		word-break: break-all;
		word-wrap: break-word;
		background-color: #f5f5f5;
		border: 1px solid #ccc;
		border-radius: 4px
	}

	pre code {
		padding: 0;
		font-size: inherit;
		color: inherit;
		white-space: pre-wrap;
		background-color: transparent;
		border-radius: 0
	}

	.pre-scrollable {
		max-height: 340px;
		overflow-y: scroll
	}

	.container {
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto
	}

	@media(min-width: 768px) {
		.container {
			width:750px
		}
	}

	@media(min-width: 992px) {
		.container {
			width:970px
		}
	}

	@media(min-width: 1200px) {
		.container {
			width:1170px
		}
	}

	.container-fluid {
		padding-right: 15px;
		padding-left: 15px;
		margin-right: auto;
		margin-left: auto
	}

	.row {
		margin-right: -15px;
		margin-left: -15px
	}

	.col-xs-1,.col-sm-1,.col-md-1,.col-lg-1,.col-xs-2,.col-sm-2,.col-md-2,.col-lg-2,.col-xs-3,.col-sm-3,.col-md-3,.col-lg-3,.col-xs-4,.col-sm-4,.col-md-4,.col-lg-4,.col-xs-5,.col-sm-5,.col-md-5,.col-lg-5,.col-xs-6,.col-sm-6,.col-md-6,.col-lg-6,.col-xs-7,.col-sm-7,.col-md-7,.col-lg-7,.col-xs-8,.col-sm-8,.col-md-8,.col-lg-8,.col-xs-9,.col-sm-9,.col-md-9,.col-lg-9,.col-xs-10,.col-sm-10,.col-md-10,.col-lg-10,.col-xs-11,.col-sm-11,.col-md-11,.col-lg-11,.col-xs-12,.col-sm-12,.col-md-12,.col-lg-12 {
		position: relative;
		min-height: 1px;
		padding-right: 15px;
		padding-left: 15px
	}

	.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12 {
		float: left
	}

	.col-xs-12 {
		width: 100%
	}

	.col-xs-11 {
		width: 91.66666667%
	}

	.col-xs-10 {
		width: 83.33333333%
	}

	.col-xs-9 {
		width: 75%
	}

	.col-xs-8 {
		width: 66.66666667%
	}

	.col-xs-7 {
		width: 58.33333333%
	}

	.col-xs-6 {
		width: 50%
	}

	.col-xs-5 {
		width: 41.66666667%
	}

	.col-xs-4 {
		width: 33.33333333%
	}

	.col-xs-3 {
		width: 25%
	}

	.col-xs-2 {
		width: 16.66666667%
	}

	.col-xs-1 {
		width: 8.33333333%
	}

	.col-xs-pull-12 {
		right: 100%
	}

	.col-xs-pull-11 {
		right: 91.66666667%
	}

	.col-xs-pull-10 {
		right: 83.33333333%
	}

	.col-xs-pull-9 {
		right: 75%
	}

	.col-xs-pull-8 {
		right: 66.66666667%
	}

	.col-xs-pull-7 {
		right: 58.33333333%
	}

	.col-xs-pull-6 {
		right: 50%
	}

	.col-xs-pull-5 {
		right: 41.66666667%
	}

	.col-xs-pull-4 {
		right: 33.33333333%
	}

	.col-xs-pull-3 {
		right: 25%
	}

	.col-xs-pull-2 {
		right: 16.66666667%
	}

	.col-xs-pull-1 {
		right: 8.33333333%
	}

	.col-xs-pull-0 {
		right: auto
	}

	.col-xs-push-12 {
		left: 100%
	}

	.col-xs-push-11 {
		left: 91.66666667%
	}

	.col-xs-push-10 {
		left: 83.33333333%
	}

	.col-xs-push-9 {
		left: 75%
	}

	.col-xs-push-8 {
		left: 66.66666667%
	}

	.col-xs-push-7 {
		left: 58.33333333%
	}

	.col-xs-push-6 {
		left: 50%
	}

	.col-xs-push-5 {
		left: 41.66666667%
	}

	.col-xs-push-4 {
		left: 33.33333333%
	}

	.col-xs-push-3 {
		left: 25%
	}

	.col-xs-push-2 {
		left: 16.66666667%
	}

	.col-xs-push-1 {
		left: 8.33333333%
	}

	.col-xs-push-0 {
		left: auto
	}

	.col-xs-offset-12 {
		margin-left: 100%
	}

	.col-xs-offset-11 {
		margin-left: 91.66666667%
	}

	.col-xs-offset-10 {
		margin-left: 83.33333333%
	}

	.col-xs-offset-9 {
		margin-left: 75%
	}

	.col-xs-offset-8 {
		margin-left: 66.66666667%
	}

	.col-xs-offset-7 {
		margin-left: 58.33333333%
	}

	.col-xs-offset-6 {
		margin-left: 50%
	}

	.col-xs-offset-5 {
		margin-left: 41.66666667%
	}

	.col-xs-offset-4 {
		margin-left: 33.33333333%
	}

	.col-xs-offset-3 {
		margin-left: 25%
	}

	.col-xs-offset-2 {
		margin-left: 16.66666667%
	}

	.col-xs-offset-1 {
		margin-left: 8.33333333%
	}

	.col-xs-offset-0 {
		margin-left: 0
	}

	@media(min-width: 768px) {
		.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12 {
			float:left
		}

		.col-sm-12 {
			width: 100%
		}

		.col-sm-11 {
			width: 91.66666667%
		}

		.col-sm-10 {
			width: 83.33333333%
		}

		.col-sm-9 {
			width: 75%
		}

		.col-sm-8 {
			width: 66.66666667%
		}

		.col-sm-7 {
			width: 58.33333333%
		}

		.col-sm-6 {
			width: 50%
		}

		.col-sm-5 {
			width: 41.66666667%
		}

		.col-sm-4 {
			width: 33.33333333%
		}

		.col-sm-3 {
			width: 25%
		}

		.col-sm-2 {
			width: 16.66666667%
		}

		.col-sm-1 {
			width: 8.33333333%
		}

		.col-sm-pull-12 {
			right: 100%
		}

		.col-sm-pull-11 {
			right: 91.66666667%
		}

		.col-sm-pull-10 {
			right: 83.33333333%
		}

		.col-sm-pull-9 {
			right: 75%
		}

		.col-sm-pull-8 {
			right: 66.66666667%
		}

		.col-sm-pull-7 {
			right: 58.33333333%
		}

		.col-sm-pull-6 {
			right: 50%
		}

		.col-sm-pull-5 {
			right: 41.66666667%
		}

		.col-sm-pull-4 {
			right: 33.33333333%
		}

		.col-sm-pull-3 {
			right: 25%
		}

		.col-sm-pull-2 {
			right: 16.66666667%
		}

		.col-sm-pull-1 {
			right: 8.33333333%
		}

		.col-sm-pull-0 {
			right: auto
		}

		.col-sm-push-12 {
			left: 100%
		}

		.col-sm-push-11 {
			left: 91.66666667%
		}

		.col-sm-push-10 {
			left: 83.33333333%
		}

		.col-sm-push-9 {
			left: 75%
		}

		.col-sm-push-8 {
			left: 66.66666667%
		}

		.col-sm-push-7 {
			left: 58.33333333%
		}

		.col-sm-push-6 {
			left: 50%
		}

		.col-sm-push-5 {
			left: 41.66666667%
		}

		.col-sm-push-4 {
			left: 33.33333333%
		}

		.col-sm-push-3 {
			left: 25%
		}

		.col-sm-push-2 {
			left: 16.66666667%
		}

		.col-sm-push-1 {
			left: 8.33333333%
		}

		.col-sm-push-0 {
			left: auto
		}

		.col-sm-offset-12 {
			margin-left: 100%
		}

		.col-sm-offset-11 {
			margin-left: 91.66666667%
		}

		.col-sm-offset-10 {
			margin-left: 83.33333333%
		}

		.col-sm-offset-9 {
			margin-left: 75%
		}

		.col-sm-offset-8 {
			margin-left: 66.66666667%
		}

		.col-sm-offset-7 {
			margin-left: 58.33333333%
		}

		.col-sm-offset-6 {
			margin-left: 50%
		}

		.col-sm-offset-5 {
			margin-left: 41.66666667%
		}

		.col-sm-offset-4 {
			margin-left: 33.33333333%
		}

		.col-sm-offset-3 {
			margin-left: 25%
		}

		.col-sm-offset-2 {
			margin-left: 16.66666667%
		}

		.col-sm-offset-1 {
			margin-left: 8.33333333%
		}

		.col-sm-offset-0 {
			margin-left: 0
		}
	}

	@media(min-width: 992px) {
		.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12 {
			float:left
		}

		.col-md-12 {
			width: 100%
		}

		.col-md-11 {
			width: 91.66666667%
		}

		.col-md-10 {
			width: 83.33333333%
		}

		.col-md-9 {
			width: 75%
		}

		.col-md-8 {
			width: 66.66666667%
		}

		.col-md-7 {
			width: 58.33333333%
		}

		.col-md-6 {
			width: 50%
		}

		.col-md-5 {
			width: 41.66666667%
		}

		.col-md-4 {
			width: 33.33333333%
		}

		.col-md-3 {
			width: 25%
		}

		.col-md-2 {
			width: 16.66666667%
		}

		.col-md-1 {
			width: 8.33333333%
		}

		.col-md-pull-12 {
			right: 100%
		}

		.col-md-pull-11 {
			right: 91.66666667%
		}

		.col-md-pull-10 {
			right: 83.33333333%
		}

		.col-md-pull-9 {
			right: 75%
		}

		.col-md-pull-8 {
			right: 66.66666667%
		}

		.col-md-pull-7 {
			right: 58.33333333%
		}

		.col-md-pull-6 {
			right: 50%
		}

		.col-md-pull-5 {
			right: 41.66666667%
		}

		.col-md-pull-4 {
			right: 33.33333333%
		}

		.col-md-pull-3 {
			right: 25%
		}

		.col-md-pull-2 {
			right: 16.66666667%
		}

		.col-md-pull-1 {
			right: 8.33333333%
		}

		.col-md-pull-0 {
			right: auto
		}

		.col-md-push-12 {
			left: 100%
		}

		.col-md-push-11 {
			left: 91.66666667%
		}

		.col-md-push-10 {
			left: 83.33333333%
		}

		.col-md-push-9 {
			left: 75%
		}

		.col-md-push-8 {
			left: 66.66666667%
		}

		.col-md-push-7 {
			left: 58.33333333%
		}

		.col-md-push-6 {
			left: 50%
		}

		.col-md-push-5 {
			left: 41.66666667%
		}

		.col-md-push-4 {
			left: 33.33333333%
		}

		.col-md-push-3 {
			left: 25%
		}

		.col-md-push-2 {
			left: 16.66666667%
		}

		.col-md-push-1 {
			left: 8.33333333%
		}

		.col-md-push-0 {
			left: auto
		}

		.col-md-offset-12 {
			margin-left: 100%
		}

		.col-md-offset-11 {
			margin-left: 91.66666667%
		}

		.col-md-offset-10 {
			margin-left: 83.33333333%
		}

		.col-md-offset-9 {
			margin-left: 75%
		}

		.col-md-offset-8 {
			margin-left: 66.66666667%
		}

		.col-md-offset-7 {
			margin-left: 58.33333333%
		}

		.col-md-offset-6 {
			margin-left: 50%
		}

		.col-md-offset-5 {
			margin-left: 41.66666667%
		}

		.col-md-offset-4 {
			margin-left: 33.33333333%
		}

		.col-md-offset-3 {
			margin-left: 25%
		}

		.col-md-offset-2 {
			margin-left: 16.66666667%
		}

		.col-md-offset-1 {
			margin-left: 8.33333333%
		}

		.col-md-offset-0 {
			margin-left: 0
		}
	}

	@media(min-width: 1200px) {
		.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12 {
			float:left
		}

		.col-lg-12 {
			width: 100%
		}

		.col-lg-11 {
			width: 91.66666667%
		}

		.col-lg-10 {
			width: 83.33333333%
		}

		.col-lg-9 {
			width: 75%
		}

		.col-lg-8 {
			width: 66.66666667%
		}

		.col-lg-7 {
			width: 58.33333333%
		}

		.col-lg-6 {
			width: 50%
		}

		.col-lg-5 {
			width: 41.66666667%
		}

		.col-lg-4 {
			width: 33.33333333%
		}

		.col-lg-3 {
			width: 25%
		}

		.col-lg-2 {
			width: 16.66666667%
		}

		.col-lg-1 {
			width: 8.33333333%
		}

		.col-lg-pull-12 {
			right: 100%
		}

		.col-lg-pull-11 {
			right: 91.66666667%
		}

		.col-lg-pull-10 {
			right: 83.33333333%
		}

		.col-lg-pull-9 {
			right: 75%
		}

		.col-lg-pull-8 {
			right: 66.66666667%
		}

		.col-lg-pull-7 {
			right: 58.33333333%
		}

		.col-lg-pull-6 {
			right: 50%
		}

		.col-lg-pull-5 {
			right: 41.66666667%
		}

		.col-lg-pull-4 {
			right: 33.33333333%
		}

		.col-lg-pull-3 {
			right: 25%
		}

		.col-lg-pull-2 {
			right: 16.66666667%
		}

		.col-lg-pull-1 {
			right: 8.33333333%
		}

		.col-lg-pull-0 {
			right: auto
		}

		.col-lg-push-12 {
			left: 100%
		}

		.col-lg-push-11 {
			left: 91.66666667%
		}

		.col-lg-push-10 {
			left: 83.33333333%
		}

		.col-lg-push-9 {
			left: 75%
		}

		.col-lg-push-8 {
			left: 66.66666667%
		}

		.col-lg-push-7 {
			left: 58.33333333%
		}

		.col-lg-push-6 {
			left: 50%
		}

		.col-lg-push-5 {
			left: 41.66666667%
		}

		.col-lg-push-4 {
			left: 33.33333333%
		}

		.col-lg-push-3 {
			left: 25%
		}

		.col-lg-push-2 {
			left: 16.66666667%
		}

		.col-lg-push-1 {
			left: 8.33333333%
		}

		.col-lg-push-0 {
			left: auto
		}

		.col-lg-offset-12 {
			margin-left: 100%
		}

		.col-lg-offset-11 {
			margin-left: 91.66666667%
		}

		.col-lg-offset-10 {
			margin-left: 83.33333333%
		}

		.col-lg-offset-9 {
			margin-left: 75%
		}

		.col-lg-offset-8 {
			margin-left: 66.66666667%
		}

		.col-lg-offset-7 {
			margin-left: 58.33333333%
		}

		.col-lg-offset-6 {
			margin-left: 50%
		}

		.col-lg-offset-5 {
			margin-left: 41.66666667%
		}

		.col-lg-offset-4 {
			margin-left: 33.33333333%
		}

		.col-lg-offset-3 {
			margin-left: 25%
		}

		.col-lg-offset-2 {
			margin-left: 16.66666667%
		}

		.col-lg-offset-1 {
			margin-left: 8.33333333%
		}

		.col-lg-offset-0 {
			margin-left: 0
		}
	}

	table {
		background-color: transparent
	}

	caption {
		padding-top: 8px;
		padding-bottom: 8px;
		color: #777;
		text-align: left
	}

	th {
		text-align: left
	}

	.table {
		width: 100%;
		max-width: 100%;
		margin-bottom: 20px
	}

	.table>thead>tr>th,.table>tbody>tr>th,.table>tfoot>tr>th,.table>thead>tr>td,.table>tbody>tr>td,.table>tfoot>tr>td {
		padding: 8px;
		line-height: 1.42857143;
		vertical-align: top
	}

	.table>thead>tr>th {
		vertical-align: bottom
	}

	.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>th,.table>caption+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>td,.table>thead:first-child>tr:first-child>td {
		border-top: 0
	}

	.table>tbody+tbody {
		border-top: 2px solid #ddd
	}

	.table .table {
		background-color: #fff
	}

	.table-condensed>thead>tr>th,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>tbody>tr>td,.table-condensed>tfoot>tr>td {
		padding: 5px
	}

	.table-bordered {
		border: 1px solid #ddd
	}

	.table-bordered>thead>tr>th,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>tbody>tr>td,.table-bordered>tfoot>tr>td {
		border: 1px solid #ddd
	}

	.table-bordered>thead>tr>th,.table-bordered>thead>tr>td {
		border-bottom-width: 2px
	}

	.table-striped>tbody>tr:nth-of-type(odd) {
		background-color: #f9f9f9
	}

	.table-hover>tbody>tr:hover {
		background-color: #f5f5f5
	}

	table col[class*="col-"] {
		position: static;
		display: table-column;
		float: none
	}

	table td[class*="col-"],table th[class*="col-"] {
		position: static;
		display: table-cell;
		float: none
	}

	.table>thead>tr>td.active,.table>tbody>tr>td.active,.table>tfoot>tr>td.active,.table>thead>tr>th.active,.table>tbody>tr>th.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>tbody>tr.active>td,.table>tfoot>tr.active>td,.table>thead>tr.active>th,.table>tbody>tr.active>th,.table>tfoot>tr.active>th {
		background-color: #f5f5f5
	}

	.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover,.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr.active:hover>th {
		background-color: #e8e8e8
	}

	.table>thead>tr>td.success,.table>tbody>tr>td.success,.table>tfoot>tr>td.success,.table>thead>tr>th.success,.table>tbody>tr>th.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>tbody>tr.success>td,.table>tfoot>tr.success>td,.table>thead>tr.success>th,.table>tbody>tr.success>th,.table>tfoot>tr.success>th {
		background-color: #dff0d8
	}

	.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover,.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr.success:hover>th {
		background-color: #d0e9c6
	}

	.table>thead>tr>td.info,.table>tbody>tr>td.info,.table>tfoot>tr>td.info,.table>thead>tr>th.info,.table>tbody>tr>th.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>tbody>tr.info>td,.table>tfoot>tr.info>td,.table>thead>tr.info>th,.table>tbody>tr.info>th,.table>tfoot>tr.info>th {
		background-color: #d9edf7
	}

	.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover,.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr.info:hover>th {
		background-color: #c4e3f3
	}

	.table>thead>tr>td.warning,.table>tbody>tr>td.warning,.table>tfoot>tr>td.warning,.table>thead>tr>th.warning,.table>tbody>tr>th.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>tbody>tr.warning>td,.table>tfoot>tr.warning>td,.table>thead>tr.warning>th,.table>tbody>tr.warning>th,.table>tfoot>tr.warning>th {
		background-color: #fcf8e3
	}

	.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover,.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr.warning:hover>th {
		background-color: #faf2cc
	}

	.table>thead>tr>td.danger,.table>tbody>tr>td.danger,.table>tfoot>tr>td.danger,.table>thead>tr>th.danger,.table>tbody>tr>th.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>tbody>tr.danger>td,.table>tfoot>tr.danger>td,.table>thead>tr.danger>th,.table>tbody>tr.danger>th,.table>tfoot>tr.danger>th {
		background-color: #f2dede
	}

	.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover,.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr.danger:hover>th {
		background-color: #ebcccc
	}

	.table-responsive {
		min-height: .01%;
		overflow-x: auto
	}

	@media screen and (max-width: 767px) {
		.table-responsive {
			width:100%;
			margin-bottom: 15px;
			overflow-y: hidden;
			-ms-overflow-style: -ms-autohiding-scrollbar;
			border: 1px solid #ddd
		}

		.table-responsive>.table {
			margin-bottom: 0
		}

		.table-responsive>.table>thead>tr>th,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tfoot>tr>td {
			white-space: nowrap
		}

		.table-responsive>.table-bordered {
			border: 0
		}

		.table-responsive>.table-bordered>thead>tr>th:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child {
			border-left: 0
		}

		.table-responsive>.table-bordered>thead>tr>th:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child {
			border-right: 0
		}

		.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>th,.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>td {
			border-bottom: 0
		}
	}

	fieldset {
		min-width: 0;
		padding: 0;
		margin: 0;
		border: 0
	}

	legend {
		display: block;
		width: 100%;
		padding: 0;
		margin-bottom: 20px;
		font-size: 21px;
		line-height: inherit;
		color: #333;
		border: 0;
		border-bottom: 1px solid #e5e5e5
	}

	label {
		display: inline-block;
		max-width: 100%;
		margin-bottom: 5px;
		font-weight: 700
	}

	input[type="search"] {
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		box-sizing: border-box
	}

	input[type="radio"],input[type="checkbox"] {
		margin: 4px 0 0;
		margin-top: 1px \9;
		line-height: normal
	}

	input[type="file"] {
		display: block
	}

	input[type="range"] {
		display: block;
		width: 100%
	}

	select[multiple],select[size] {
		height: auto
	}

	input[type="file"]:focus,input[type="radio"]:focus,input[type="checkbox"]:focus {
		outline: thin dotted;
		outline: 5px auto -webkit-focus-ring-color;
		outline-offset: -2px
	}

	output {
		display: block;
		padding-top: 7px;
		font-size: 14px;
		line-height: 1.42857143;
		color: #555
	}

	.form-control {
		display: block;
		width: 100%;
		height: 34px;
		padding: 6px 12px;
		font-size: 14px;
		line-height: 1.42857143;
		color: #555;
		background-color: #fff;
		background-image: none;
		border: 1px solid #ccc;
		border-radius: 4px;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
		-webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
		-o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
		transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s
	}

	.form-control:focus {
		border-color: #66afe9;
		outline: 0;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)
	}

	.form-control::-moz-placeholder {
		color: #999;
		opacity: 1
	}

	.form-control:-ms-input-placeholder {
		color: #999
	}

	.form-control::-webkit-input-placeholder {
		color: #999
	}

	.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control {
		background-color: #eee;
		opacity: 1
	}

	.form-control[disabled],fieldset[disabled] .form-control {
		cursor: not-allowed
	}

	textarea.form-control {
		height: auto
	}

	input[type="search"] {
		-webkit-appearance: none;
		appearance: none;
	}

	@media screen and (-webkit-min-device-pixel-ratio: 0) {
		input[type="date"],input[type="time"],input[type="datetime-local"],input[type="month"] {
			line-height:34px
		}

		input[type="date"].input-sm,input[type="time"].input-sm,input[type="datetime-local"].input-sm,input[type="month"].input-sm,.input-group-sm input[type="date"],.input-group-sm input[type="time"],.input-group-sm input[type="datetime-local"],.input-group-sm input[type="month"] {
			line-height: 30px
		}

		input[type="date"].input-lg,input[type="time"].input-lg,input[type="datetime-local"].input-lg,input[type="month"].input-lg,.input-group-lg input[type="date"],.input-group-lg input[type="time"],.input-group-lg input[type="datetime-local"],.input-group-lg input[type="month"] {
			line-height: 46px
		}
	}

	.form-group {
		margin-bottom: 15px
	}

	.radio,.checkbox {
		position: relative;
		display: block;
		margin-top: 10px;
		margin-bottom: 10px
	}

	.radio label,.checkbox label {
		min-height: 20px;
		padding-left: 20px;
		margin-bottom: 0;
		font-weight: 400;
		cursor: pointer
	}

	.radio input[type="radio"],.radio-inline input[type="radio"],.checkbox input[type="checkbox"],.checkbox-inline input[type="checkbox"] {
		position: absolute;
		margin-top: 4px \9;
		margin-left: -20px
	}

	.radio+.radio,.checkbox+.checkbox {
		margin-top: -5px
	}

	.radio-inline,.checkbox-inline {
		position: relative;
		display: inline-block;
		padding-left: 20px;
		margin-bottom: 0;
		font-weight: 400;
		vertical-align: middle;
		cursor: pointer
	}

	.radio-inline+.radio-inline,.checkbox-inline+.checkbox-inline {
		margin-top: 0;
		margin-left: 10px
	}

	input[type="radio"][disabled],input[type="checkbox"][disabled],input[type="radio"].disabled,input[type="checkbox"].disabled,fieldset[disabled] input[type="radio"],fieldset[disabled] input[type="checkbox"] {
		cursor: not-allowed
	}

	.radio-inline.disabled,.checkbox-inline.disabled,fieldset[disabled] .radio-inline,fieldset[disabled] .checkbox-inline {
		cursor: not-allowed
	}

	.radio.disabled label,.checkbox.disabled label,fieldset[disabled] .radio label,fieldset[disabled] .checkbox label {
		cursor: not-allowed
	}

	.form-control-static {
		min-height: 34px;
		padding-top: 7px;
		padding-bottom: 7px;
		margin-bottom: 0
	}

	.form-control-static.input-lg,.form-control-static.input-sm {
		padding-right: 0;
		padding-left: 0
	}

	.input-sm {
		height: 30px;
		padding: 5px 10px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 3px
	}

	select.input-sm {
		height: 30px;
		line-height: 30px
	}

	textarea.input-sm,select[multiple].input-sm {
		height: auto
	}

	.form-group-sm .form-control {
		height: 30px;
		padding: 5px 10px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 3px
	}

	select.form-group-sm .form-control {
		height: 30px;
		line-height: 30px
	}

	textarea.form-group-sm .form-control,select[multiple].form-group-sm .form-control {
		height: auto
	}

	.form-group-sm .form-control-static {
		height: 30px;
		min-height: 32px;
		padding: 5px 10px;
		font-size: 12px;
		line-height: 1.5
	}

	.input-lg {
		height: 46px;
		padding: 10px 16px;
		font-size: 18px;
		line-height: 1.3333333;
		border-radius: 6px
	}

	select.input-lg {
		height: 46px;
		line-height: 46px
	}

	textarea.input-lg,select[multiple].input-lg {
		height: auto
	}

	.form-group-lg .form-control {
		height: 46px;
		padding: 10px 16px;
		font-size: 18px;
		line-height: 1.3333333;
		border-radius: 6px
	}

	select.form-group-lg .form-control {
		height: 46px;
		line-height: 46px
	}

	textarea.form-group-lg .form-control,select[multiple].form-group-lg .form-control {
		height: auto
	}

	.form-group-lg .form-control-static {
		height: 46px;
		min-height: 38px;
		padding: 10px 16px;
		font-size: 18px;
		line-height: 1.3333333
	}

	.has-feedback {
		position: relative
	}

	.has-feedback .form-control {
		padding-right: 42.5px
	}

	.form-control-feedback {
		position: absolute;
		top: 0;
		right: 0;
		z-index: 2;
		display: block;
		width: 34px;
		height: 34px;
		line-height: 34px;
		text-align: center;
		pointer-events: none
	}

	.input-lg+.form-control-feedback {
		width: 46px;
		height: 46px;
		line-height: 46px
	}

	.input-sm+.form-control-feedback {
		width: 30px;
		height: 30px;
		line-height: 30px
	}

	.has-success .help-block,.has-success .control-label,.has-success .radio,.has-success .checkbox,.has-success .radio-inline,.has-success .checkbox-inline,.has-success.radio label,.has-success.checkbox label,.has-success.radio-inline label,.has-success.checkbox-inline label {
		color: #3c763d
	}

	.has-success .form-control {
		border-color: #3c763d;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
	}

	.has-success .form-control:focus {
		border-color: #2b542c;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168;
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168
	}

	.has-success .input-group-addon {
		color: #3c763d;
		background-color: #dff0d8;
		border-color: #3c763d
	}

	.has-success .form-control-feedback {
		color: #3c763d
	}

	.has-warning .help-block,.has-warning .control-label,.has-warning .radio,.has-warning .checkbox,.has-warning .radio-inline,.has-warning .checkbox-inline,.has-warning.radio label,.has-warning.checkbox label,.has-warning.radio-inline label,.has-warning.checkbox-inline label {
		color: #8a6d3b
	}

	.has-warning .form-control {
		border-color: #8a6d3b;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
	}

	.has-warning .form-control:focus {
		border-color: #66512c;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b;
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b
	}

	.has-warning .input-group-addon {
		color: #8a6d3b;
		background-color: #fcf8e3;
		border-color: #8a6d3b
	}

	.has-warning .form-control-feedback {
		color: #8a6d3b
	}

	.has-error .help-block,.has-error .control-label,.has-error .radio,.has-error .checkbox,.has-error .radio-inline,.has-error .checkbox-inline,.has-error.radio label,.has-error.checkbox label,.has-error.radio-inline label,.has-error.checkbox-inline label {
		color: #a94442
	}

	.has-error .form-control {
		border-color: #a94442;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075)
	}

	.has-error .form-control:focus {
		border-color: #843534;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483;
		box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483
	}

	.has-error .input-group-addon {
		color: #a94442;
		background-color: #f2dede;
		border-color: #a94442
	}

	.has-error .form-control-feedback {
		color: #a94442
	}

	.has-feedback label~.form-control-feedback {
		top: 25px
	}

	.has-feedback label.sr-only~.form-control-feedback {
		top: 0
	}

	.help-block {
		display: block;
		margin-top: 5px;
		margin-bottom: 10px;
		color: #737373
	}

	@media(min-width: 768px) {
		.form-inline .form-group {
			display:inline-block;
			margin-bottom: 0;
			vertical-align: middle
		}

		.form-inline .form-control {
			display: inline-block;
			width: auto;
			vertical-align: middle
		}

		.form-inline .form-control-static {
			display: inline-block
		}

		.form-inline .input-group {
			display: inline-table;
			vertical-align: middle
		}

		.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn,.form-inline .input-group .form-control {
			width: auto
		}

		.form-inline .input-group>.form-control {
			width: 100%
		}

		.form-inline .control-label {
			margin-bottom: 0;
			vertical-align: middle
		}

		.form-inline .radio,.form-inline .checkbox {
			display: inline-block;
			margin-top: 0;
			margin-bottom: 0;
			vertical-align: middle
		}

		.form-inline .radio label,.form-inline .checkbox label {
			padding-left: 0
		}

		.form-inline .radio input[type="radio"],.form-inline .checkbox input[type="checkbox"] {
			position: relative;
			margin-left: 0
		}

		.form-inline .has-feedback .form-control-feedback {
			top: 0
		}
	}

	.form-horizontal .radio,.form-horizontal .checkbox,.form-horizontal .radio-inline,.form-horizontal .checkbox-inline {
		padding-top: 7px;
		margin-top: 0;
		margin-bottom: 0
	}

	.form-horizontal .radio,.form-horizontal .checkbox {
		min-height: 27px
	}

	.form-horizontal .form-group {
		margin-right: -15px;
		margin-left: -15px
	}

	@media(min-width: 768px) {
		.form-horizontal .control-label {
			padding-top:7px;
			margin-bottom: 0;
			text-align: right
		}
	}

	.form-horizontal .has-feedback .form-control-feedback {
		right: 15px
	}

	@media(min-width: 768px) {
		.form-horizontal .form-group-lg .control-label {
			padding-top:14.333333px
		}
	}

	@media(min-width: 768px) {
		.form-horizontal .form-group-sm .control-label {
			padding-top:6px
		}
	}

	.btn {
		display: inline-block;
		padding: 6px 12px;
		margin-bottom: 0;
		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: center;
		white-space: nowrap;
		vertical-align: middle;
		-ms-touch-action: manipulation;
		touch-action: manipulation;
		cursor: pointer;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		background-image: none;
		border: 1px solid transparent;
		border-radius: 4px
	}

	.btn:focus,.btn:active:focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn.active.focus {
		outline: thin dotted;
		outline: 5px auto -webkit-focus-ring-color;
		outline-offset: -2px
	}

	.btn:hover,.btn:focus,.btn.focus {
		color: #333;
		text-decoration: none
	}

	.btn:active,.btn.active {
		background-image: none;
		outline: 0;
		-webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
		box-shadow: inset 0 3px 5px rgba(0,0,0,.125)
	}

	.btn.disabled,.btn[disabled],fieldset[disabled] .btn {
		pointer-events: none;
		cursor: not-allowed;
		filter: alpha(opacity=65);
		-webkit-box-shadow: none;
		box-shadow: none;
		opacity: .65
	}

	.btn-default {
		color: #333;
		background-color: #fff;
		border-color: #ccc
	}

	.btn-default:hover,.btn-default:focus,.btn-default.focus,.btn-default:active,.btn-default.active,.open>.dropdown-toggle.btn-default {
		color: #333;
		background-color: #e6e6e6;
		border-color: #adadad
	}

	.btn-default:active,.btn-default.active,.open>.dropdown-toggle.btn-default {
		background-image: none
	}

	.btn-default.disabled,.btn-default[disabled],fieldset[disabled] .btn-default,.btn-default.disabled:hover,.btn-default[disabled]:hover,fieldset[disabled] .btn-default:hover,.btn-default.disabled:focus,.btn-default[disabled]:focus,fieldset[disabled] .btn-default:focus,.btn-default.disabled.focus,.btn-default[disabled].focus,fieldset[disabled] .btn-default.focus,.btn-default.disabled:active,.btn-default[disabled]:active,fieldset[disabled] .btn-default:active,.btn-default.disabled.active,.btn-default[disabled].active,fieldset[disabled] .btn-default.active {
		background-color: #fff;
		border-color: #ccc
	}

	.btn-default .badge {
		color: #fff;
		background-color: #333
	}

	.btn-primary {
		color: #fff;
		background-color: #337ab7;
		border-color: #2e6da4
	}

	.btn-primary:hover,.btn-primary:focus,.btn-primary.focus,.btn-primary:active,.btn-primary.active,.open>.dropdown-toggle.btn-primary {
		color: #fff;
		background-color: #286090;
		border-color: #204d74
	}

	.btn-primary:active,.btn-primary.active,.open>.dropdown-toggle.btn-primary {
		background-image: none
	}

	.btn-primary.disabled,.btn-primary[disabled],fieldset[disabled] .btn-primary,.btn-primary.disabled:hover,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary:hover,.btn-primary.disabled:focus,.btn-primary[disabled]:focus,fieldset[disabled] .btn-primary:focus,.btn-primary.disabled.focus,.btn-primary[disabled].focus,fieldset[disabled] .btn-primary.focus,.btn-primary.disabled:active,.btn-primary[disabled]:active,fieldset[disabled] .btn-primary:active,.btn-primary.disabled.active,.btn-primary[disabled].active,fieldset[disabled] .btn-primary.active {
		background-color: #337ab7;
		border-color: #2e6da4
	}

	.btn-primary .badge {
		color: #337ab7;
		background-color: #fff
	}

	.btn-success {
		color: #fff;
		background-color: #5cb85c;
		border-color: #4cae4c
	}

	.btn-success:hover,.btn-success:focus,.btn-success.focus,.btn-success:active,.btn-success.active,.open>.dropdown-toggle.btn-success {
		color: #fff;
		background-color: #449d44;
		border-color: #398439
	}

	.btn-success:active,.btn-success.active,.open>.dropdown-toggle.btn-success {
		background-image: none
	}

	.btn-success.disabled,.btn-success[disabled],fieldset[disabled] .btn-success,.btn-success.disabled:hover,.btn-success[disabled]:hover,fieldset[disabled] .btn-success:hover,.btn-success.disabled:focus,.btn-success[disabled]:focus,fieldset[disabled] .btn-success:focus,.btn-success.disabled.focus,.btn-success[disabled].focus,fieldset[disabled] .btn-success.focus,.btn-success.disabled:active,.btn-success[disabled]:active,fieldset[disabled] .btn-success:active,.btn-success.disabled.active,.btn-success[disabled].active,.btn-success .badge {
		color: #5cb85c;
		background-color: #fff
	}

	.btn-info {
		color: #fff;
		background-color: #e63331;
		border-color: #46b8da
	}

	.btn-info:hover,.btn-info:focus,.btn-info.focus,.btn-info:active,.btn-info.active,.open>.dropdown-toggle.btn-info {
		color: #fff;
		background-color: #31b0d5;
		border-color: #269abc
	}

	.btn-info:active,.btn-info.active,.open>.dropdown-toggle.btn-info {
		background-image: none
	}

	.btn-info.disabled,.btn-info[disabled],fieldset[disabled] .btn-info,.btn-info.disabled:hover,.btn-info[disabled]:hover,fieldset[disabled] .btn-info:hover,.btn-info.disabled:focus,.btn-info[disabled]:focus,fieldset[disabled] .btn-info:focus,.btn-info.disabled.focus,.btn-info[disabled].focus,fieldset[disabled] .btn-info.focus,.btn-info.disabled:active,.btn-info[disabled]:active,fieldset[disabled] .btn-info:active,.btn-info.disabled.active,.btn-info[disabled].active,fieldset[disabled] .btn-info.active {
		background-color: #e63331;
		border-color: #46b8da
	}

	.btn-info .badge {
		color: #e63331;
		background-color: #fff
	}

	.btn-warning {
		color: #fff;
		background-color: #f0ad4e;
		border-color: #eea236
	}

	.btn-warning:hover,.btn-warning:focus,.btn-warning.focus,.btn-warning:active,.btn-warning.active,.open>.dropdown-toggle.btn-warning {
		color: #fff;
		background-color: #ec971f;
		border-color: #d58512
	}

	.btn-warning:active,.btn-warning.active,.open>.dropdown-toggle.btn-warning {
		background-image: none
	}

	.btn-warning.disabled,.btn-warning[disabled],fieldset[disabled] .btn-warning,.btn-warning.disabled:hover,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning:hover,.btn-warning.disabled:focus,.btn-warning[disabled]:focus,fieldset[disabled] .btn-warning:focus,.btn-warning.disabled.focus,.btn-warning[disabled].focus,fieldset[disabled] .btn-warning.focus,.btn-warning.disabled:active,.btn-warning[disabled]:active,fieldset[disabled] .btn-warning:active,.btn-warning.disabled.active,.btn-warning[disabled].active,fieldset[disabled] .btn-warning.active {
		background-color: #f0ad4e;
		border-color: #eea236
	}

	.btn-warning .badge {
		color: #f0ad4e;
		background-color: #fff
	}

	.btn-danger {
		color: #fff;
		background-color: #d9534f;
		border-color: #d43f3a
	}

	.btn-danger:hover,.btn-danger:focus,.btn-danger.focus,.btn-danger:active,.btn-danger.active,.open>.dropdown-toggle.btn-danger {
		color: #fff;
		background-color: #c9302c;
		border-color: #ac2925
	}

	.btn-danger:active,.btn-danger.active,.open>.dropdown-toggle.btn-danger {
		background-image: none
	}

	.btn-danger.disabled,.btn-danger[disabled],fieldset[disabled] .btn-danger,.btn-danger.disabled:hover,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger:hover,.btn-danger.disabled:focus,.btn-danger[disabled]:focus,fieldset[disabled] .btn-danger:focus,.btn-danger.disabled.focus,.btn-danger[disabled].focus,fieldset[disabled] .btn-danger.focus,.btn-danger.disabled:active,.btn-danger[disabled]:active,fieldset[disabled] .btn-danger:active,.btn-danger.disabled.active,.btn-danger[disabled].active,fieldset[disabled] .btn-danger.active {
		background-color: #d9534f;
		border-color: #d43f3a
	}

	.btn-danger .badge {
		color: #d9534f;
		background-color: #fff
	}

	.btn-link {
		font-weight: 400;
		color: #337ab7;
		border-radius: 0
	}

	.btn-link,.btn-link:active,.btn-link.active,.btn-link[disabled],fieldset[disabled] .btn-link {
		background-color: transparent;
		-webkit-box-shadow: none;
		box-shadow: none
	}

	.btn-link,.btn-link:hover,.btn-link:focus,.btn-link:active {
		border-color: transparent
	}

	.btn-link:hover,.btn-link:focus {
		color: #23527c;
		text-decoration: underline;
		background-color: transparent
	}

	.btn-link[disabled]:hover,fieldset[disabled] .btn-link:hover,.btn-link[disabled]:focus,fieldset[disabled] .btn-link:focus {
		color: #777;
		text-decoration: none
	}

	.btn-lg,.btn-group-lg>.btn {
		padding: 10px 16px;
		font-size: 18px;
		line-height: 1.3333333;
		border-radius: 6px
	}

	.btn-sm,.btn-group-sm>.btn {
		padding: 5px 10px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 3px
	}

	.btn-xs,.btn-group-xs>.btn {
		padding: 1px 5px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 3px
	}

	.btn-block {
		display: block;
		width: 100%
	}

	.btn-block+.btn-block {
		margin-top: 5px
	}

	input[type="submit"].btn-block,input[type="reset"].btn-block,input[type="button"].btn-block {
		width: 100%
	}

	.fade {
		opacity: 0;
		-webkit-transition: opacity .15s linear;
		-o-transition: opacity .15s linear;
		transition: opacity .15s linear
	}

	.fade.in {
		opacity: 1
	}

	.collapse {
		display: none
	}

	.collapse.in {
		display: block
	}

	tr.collapse.in {
		display: table-row
	}

	tbody.collapse.in {
		display: table-row-group
	}

	.collapsing {
		position: relative;
		height: 0;
		overflow: hidden;
		-webkit-transition-timing-function: ease;
		-o-transition-timing-function: ease;
		transition-timing-function: ease;
		-webkit-transition-duration: .35s;
		-o-transition-duration: .35s;
		transition-duration: .35s;
		-webkit-transition-property: height,visibility;
		-o-transition-property: height,visibility;
		transition-property: height,visibility
	}

	.caret {
		display: inline-block;
		width: 0;
		height: 0;
		margin-left: 2px;
		vertical-align: middle;
		border-top: 4px dashed;
		border-right: 4px solid transparent;
		border-left: 4px solid transparent
	}

	.dropup,.dropdown {
		position: relative
	}

	.dropdown-toggle:focus {
		outline: 0
	}

	.dropdown-menu {
		position: absolute;
		top: 100%;
		left: 0;
		z-index: 1000;
		display: none;
		float: left;
		min-width: 160px;
		padding: 5px 0;
		margin: 2px 0 0;
		font-size: 14px;
		text-align: left;
		list-style: none;
		background-color: #fff;
		-webkit-background-clip: padding-box;
		background-clip: padding-box;
		border: 1px solid #ccc;
		border: 1px solid rgba(0,0,0,.15);
		border-radius: 4px;
		-webkit-box-shadow: 0 6px 12px rgba(0,0,0,.175);
		box-shadow: 0 6px 12px rgba(0,0,0,.175)
	}

	.dropdown-menu.pull-right {
		right: 0;
		left: auto
	}

	.dropdown-menu .divider {
		height: 1px;
		margin: 9px 0;
		overflow: hidden;
		background-color: #e5e5e5
	}

	.dropdown-menu>li>a {
		display: block;
		padding: 3px 20px;
		clear: both;
		font-weight: 400;
		line-height: 1.42857143;
		color: #333;
		white-space: nowrap
	}

	.dropdown-menu>li>a:hover,.dropdown-menu>li>a:focus {
		color: #262626;
		text-decoration: none;
		background-color: #f5f5f5
	}

	.dropdown-menu>.active>a,.dropdown-menu>.active>a:hover,.dropdown-menu>.active>a:focus {
		color: #fff;
		text-decoration: none;
		background-color: #337ab7;
		outline: 0
	}

	.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:hover,.dropdown-menu>.disabled>a:focus {
		color: #777
	}

	.dropdown-menu>.disabled>a:hover,.dropdown-menu>.disabled>a:focus {
		text-decoration: none;
		cursor: not-allowed;
		background-color: transparent;
		background-image: none;
		filter: progid:DXImageTransform.Microsoft.gradient(enabled=false)
	}

	.open>.dropdown-menu {
		display: block
	}

	.open>a {
		outline: 0
	}

	.dropdown-menu-right {
		right: 0;
		left: auto
	}

	.dropdown-menu-left {
		right: auto;
		left: 0
	}

	.dropdown-header {
		display: block;
		padding: 3px 20px;
		font-size: 12px;
		line-height: 1.42857143;
		color: #777;
		white-space: nowrap
	}

	.dropdown-backdrop {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 990
	}

	.pull-right>.dropdown-menu {
		right: 0;
		left: auto
	}

	.dropup .caret,.navbar-fixed-bottom .dropdown .caret {
		content: "";
		border-top: 0;
		border-bottom: 4px solid
	}

	.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu {
		top: auto;
		bottom: 100%;
		margin-bottom: 2px
	}

	@media(min-width: 768px) {
		.navbar-right .dropdown-menu {
			right:0;
			left: auto
		}

		.navbar-right .dropdown-menu-left {
			right: auto;
			left: 0
		}
	}

	.btn-group,.btn-group-vertical {
		position: relative;
		display: inline-block;
		vertical-align: middle
	}

	.btn-group>.btn,.btn-group-vertical>.btn {
		position: relative;
		float: left
	}

	.btn-group>.btn:hover,.btn-group-vertical>.btn:hover,.btn-group>.btn:focus,.btn-group-vertical>.btn:focus,.btn-group>.btn:active,.btn-group-vertical>.btn:active,.btn-group>.btn.active,.btn-group-vertical>.btn.active {
		z-index: 2
	}

	.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group {
		margin-left: -1px
	}

	.btn-toolbar {
		margin-left: -5px
	}

	.btn-toolbar .btn-group,.btn-toolbar .input-group {
		float: left
	}

	.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group {
		margin-left: 5px
	}

	.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle) {
		border-radius: 0
	}

	.btn-group>.btn:first-child {
		margin-left: 0
	}

	.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle) {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0
	}

	.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0
	}

	.btn-group>.btn-group {
		float: left
	}

	.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn {
		border-radius: 0
	}

	.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0
	}

	.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0
	}

	.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle {
		outline: 0
	}

	.btn-group>.btn+.dropdown-toggle {
		padding-right: 8px;
		padding-left: 8px
	}

	.btn-group>.btn-lg+.dropdown-toggle {
		padding-right: 12px;
		padding-left: 12px
	}

	.btn-group.open .dropdown-toggle {
		-webkit-box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
		box-shadow: inset 0 3px 5px rgba(0,0,0,.125)
	}

	.btn-group.open .dropdown-toggle.btn-link {
		-webkit-box-shadow: none;
		box-shadow: none
	}

	.btn .caret {
		margin-left: 0
	}

	.btn-lg .caret {
		border-width: 5px 5px 0;
		border-bottom-width: 0
	}

	.dropup .btn-lg .caret {
		border-width: 0 5px 5px
	}

	.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn {
		display: block;
		float: none;
		width: 100%;
		max-width: 100%
	}

	.btn-group-vertical>.btn-group>.btn {
		float: none
	}

	.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group {
		margin-top: -1px;
		margin-left: 0
	}

	.btn-group-vertical>.btn:not(:first-child):not(:last-child) {
		border-radius: 0
	}

	.btn-group-vertical>.btn:first-child:not(:last-child) {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0
	}

	.btn-group-vertical>.btn:last-child:not(:first-child) {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-bottom-left-radius: 4px
	}

	.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn {
		border-radius: 0
	}

	.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle {
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0
	}

	.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child {
		border-top-left-radius: 0;
		border-top-right-radius: 0
	}

	.btn-group-justified {
		display: table;
		width: 100%;
		table-layout: fixed;
		border-collapse: separate
	}

	.btn-group-justified>.btn,.btn-group-justified>.btn-group {
		display: table-cell;
		float: none;
		width: 1%
	}

	.btn-group-justified>.btn-group .btn {
		width: 100%
	}

	.btn-group-justified>.btn-group .dropdown-menu {
		left: auto
	}

	[data-toggle="buttons"]>.btn input[type="radio"],[data-toggle="buttons"]>.btn-group>.btn input[type="radio"],[data-toggle="buttons"]>.btn input[type="checkbox"],[data-toggle="buttons"]>.btn-group>.btn input[type="checkbox"] {
		position: absolute;
		clip: rect(0,0,0,0);
		pointer-events: none
	}

	.input-group {
		position: relative;
		display: table;
		border-collapse: separate
	}

	.input-group[class*="col-"] {
		float: none;
		padding-right: 0;
		padding-left: 0
	}

	.input-group .form-control {
		position: relative;
		z-index: 2;
		float: left;
		width: 100%;
		margin-bottom: 0
	}

	.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn {
		height: 46px;
		padding: 10px 16px;
		font-size: 18px;
		line-height: 1.3333333;
		border-radius: 6px
	}

	select.input-group-lg>.form-control,select.input-group-lg>.input-group-addon,select.input-group-lg>.input-group-btn>.btn {
		height: 46px;
		line-height: 46px
	}

	textarea.input-group-lg>.form-control,textarea.input-group-lg>.input-group-addon,textarea.input-group-lg>.input-group-btn>.btn,select[multiple].input-group-lg>.form-control,select[multiple].input-group-lg>.input-group-addon,select[multiple].input-group-lg>.input-group-btn>.btn {
		height: auto
	}

	.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn {
		height: 30px;
		padding: 5px 10px;
		font-size: 12px;
		line-height: 1.5;
		border-radius: 3px
	}

	select.input-group-sm>.form-control,select.input-group-sm>.input-group-addon,select.input-group-sm>.input-group-btn>.btn {
		height: 30px;
		line-height: 30px
	}

	textarea.input-group-sm>.form-control,textarea.input-group-sm>.input-group-addon,textarea.input-group-sm>.input-group-btn>.btn,select[multiple].input-group-sm>.form-control,select[multiple].input-group-sm>.input-group-addon,select[multiple].input-group-sm>.input-group-btn>.btn {
		height: auto
	}

	.input-group-addon,.input-group-btn,.input-group .form-control {
		display: table-cell
	}

	.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child) {
		border-radius: 0
	}

	.input-group-addon,.input-group-btn {
		width: 1%;
		white-space: nowrap;
		vertical-align: middle
	}

	.input-group-addon {
		padding: 6px 12px;
		font-size: 14px;
		font-weight: 400;
		line-height: 1;
		color: #555;
		text-align: center;
		background-color: #eee;
		border: 1px solid #ccc;
		border-radius: 4px
	}

	.input-group-addon.input-sm {
		padding: 5px 10px;
		font-size: 12px;
		border-radius: 3px
	}

	.input-group-addon.input-lg {
		padding: 10px 16px;
		font-size: 18px;
		border-radius: 6px
	}

	.input-group-addon input[type="radio"],.input-group-addon input[type="checkbox"] {
		margin-top: 0
	}

	.input-group .form-control:first-child,.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group-btn:last-child>.btn-group:not(:last-child)>.btn {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0
	}

	.input-group-addon:first-child {
		border-right: 0
	}

	.input-group .form-control:last-child,.input-group-addon:last-child,.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:first-child>.btn-group:not(:first-child)>.btn {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0
	}

	.input-group-addon:last-child {
		border-left: 0
	}

	.input-group-btn {
		position: relative;
		font-size: 0;
		white-space: nowrap
	}

	.input-group-btn>.btn {
		position: relative
	}

	.input-group-btn>.btn+.btn {
		margin-left: -1px
	}

	.input-group-btn>.btn:hover,.input-group-btn>.btn:focus,.input-group-btn>.btn:active {
		z-index: 2
	}

	.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group {
		margin-right: -1px
	}

	.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group {
		margin-left: -1px
	}

	.nav {
		padding-left: 0;
		margin-bottom: 0;
		list-style: none
	}

	.nav>li {
		position: relative;
		display: block
	}

	.nav>li>a {
		position: relative;
		display: block;
		padding: 10px 15px
	}

	.nav>li>a:hover,.nav>li>a:focus {
		text-decoration: none;
		background-color: #eee
	}

	.nav>li.disabled>a {
		color: #777
	}

	.nav>li.disabled>a:hover,.nav>li.disabled>a:focus {
		color: #777;
		text-decoration: none;
		cursor: not-allowed;
		background-color: transparent
	}

	.nav .open>a,.nav .open>a:hover,.nav .open>a:focus {
		background-color: #eee;
		border-color: #337ab7
	}

	.nav .nav-divider {
		height: 1px;
		margin: 9px 0;
		overflow: hidden;
		background-color: #e5e5e5
	}

	.nav>li>a>img {
		max-width: none
	}

	.nav-tabs {
		border-bottom: 1px solid #ddd
	}

	.nav-tabs>li {
		float: left;
		margin-bottom: -1px
	}

	.nav-tabs>li>a {
		margin-right: 2px;
		line-height: 1.42857143;
		border: 1px solid transparent;
		border-radius: 4px 4px 0 0
	}

	.nav-tabs>li>a:hover {
		border-color: #eee #eee #ddd
	}

	.nav-tabs>li.active>a,.nav-tabs>li.active>a:hover,.nav-tabs>li.active>a:focus {
		color: #555;
		cursor: default;
		background-color: #fff;
		border: 1px solid #ddd;
		border-bottom-color: transparent
	}

	.nav-tabs.nav-justified {
		width: 100%;
		border-bottom: 0
	}

	.nav-tabs.nav-justified>li {
		float: none
	}

	.nav-tabs.nav-justified>li>a {
		margin-bottom: 5px;
		text-align: center
	}

	.nav-tabs.nav-justified>.dropdown .dropdown-menu {
		top: auto;
		left: auto
	}

	@media(min-width: 768px) {
		.nav-tabs.nav-justified>li {
			display:table-cell;
			width: 1%
		}

		.nav-tabs.nav-justified>li>a {
			margin-bottom: 0
		}
	}

	.nav-tabs.nav-justified>li>a {
		margin-right: 0;
		border-radius: 4px
	}

	.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a:focus {
		border: 1px solid #ddd
	}

	@media(min-width: 768px) {
		.nav-tabs.nav-justified>li>a {
			border-bottom:1px solid #ddd;
			border-radius: 4px 4px 0 0
		}

		.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a:focus {
			border-bottom-color: #fff
		}
	}

	.nav-pills>li {
		float: left
	}

	.nav-pills>li>a {
		border-radius: 4px
	}

	.nav-pills>li+li {
		margin-left: 2px
	}

	.nav-pills>li.active>a,.nav-pills>li.active>a:hover,.nav-pills>li.active>a:focus {
		color: #fff;
		background-color: #337ab7
	}

	.nav-stacked>li {
		float: none
	}

	.nav-stacked>li+li {
		margin-top: 2px;
		margin-left: 0
	}

	.nav-justified {
		width: 100%
	}

	.nav-justified>li {
		float: none
	}

	.nav-justified>li>a {
		margin-bottom: 5px;
		text-align: center
	}

	.nav-justified>.dropdown .dropdown-menu {
		top: auto;
		left: auto
	}

	@media(min-width: 768px) {
		.nav-justified>li {
			display:table-cell;
			width: 1%
		}

		.nav-justified>li>a {
			margin-bottom: 0
		}
	}

	.nav-tabs-justified {
		border-bottom: 0
	}

	.nav-tabs-justified>li>a {
		margin-right: 0;
		border-radius: 4px
	}

	.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {
		border: 1px solid #ddd
	}

	@media(min-width: 768px) {
		.nav-tabs-justified>li>a {
			border-bottom:1px solid #ddd;
			border-radius: 4px 4px 0 0
		}

		.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:hover,.nav-tabs-justified>.active>a:focus {
			border-bottom-color: #fff
		}
	}

	.tab-content>.tab-pane {
		display: none
	}

	.tab-content>.active {
		display: block
	}

	.nav-tabs .dropdown-menu {
		margin-top: -1px;
		border-top-left-radius: 0;
		border-top-right-radius: 0
	}

	.navbar {
		position: relative;
		min-height: 50px;
		margin-bottom: 20px;
		border: 1px solid transparent
	}

	@media(min-width: 768px) {
		.navbar {
			border-radius:4px
		}
	}

	@media(min-width: 768px) {
		.navbar-header {
			float:left
		}
	}

	.navbar-collapse {
		padding-right: 15px;
		padding-left: 15px;
		overflow-x: visible;
		-webkit-overflow-scrolling: touch;
		border-top: 1px solid transparent;
		-webkit-box-shadow: inset 0 1px 0 rgba(255,255,255,.1);
		box-shadow: inset 0 1px 0 rgba(255,255,255,.1)
	}

	.navbar-collapse.in {
		overflow-y: auto
	}

	@media(min-width: 768px) {
		.navbar-collapse {
			width:auto;
			border-top: 0;
			-webkit-box-shadow: none;
			box-shadow: none
		}

		.navbar-collapse.collapse {
			display: block!important;
			height: auto!important;
			padding-bottom: 0;
			overflow: visible!important
		}

		.navbar-collapse.in {
			overflow-y: visible
		}

		.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {
			padding-right: 0;
			padding-left: 0
		}
	}

	.navbar-fixed-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {
		max-height: 340px
	}

	@media(max-device-width: 480px)and (orientation:landscape) {
		.navbar-fixed-top .navbar-collapse,.navbar-fixed-bottom .navbar-collapse {
			max-height:200px
		}
	}

	.container>.navbar-header,.container-fluid>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-collapse {
		margin-right: -15px;
		margin-left: -15px
	}

	@media(min-width: 768px) {
		.container>.navbar-header,.container-fluid>.navbar-header,.container>.navbar-collapse,.container-fluid>.navbar-collapse {
			margin-right:0;
			margin-left: 0
		}
	}

	.navbar-static-top {
		z-index: 1000;
		border-width: 0 0 1px
	}

	@media(min-width: 768px) {
		.navbar-static-top {
			border-radius:0
		}
	}

	.navbar-fixed-top,.navbar-fixed-bottom {
		position: fixed;
		right: 0;
		left: 0;
		z-index: 1030
	}

	@media(min-width: 768px) {
		.navbar-fixed-top,.navbar-fixed-bottom {
			border-radius:0
		}
	}

	.navbar-fixed-top {
		top: 0;
		border-width: 0 0 1px
	}

	.navbar-fixed-bottom {
		bottom: 0;
		margin-bottom: 0;
		border-width: 1px 0 0
	}

	.navbar-brand {
		float: left;
		height: 50px;
		padding: 15px;
		font-size: 18px;
		line-height: 20px
	}

	.navbar-brand:hover,.navbar-brand:focus {
		text-decoration: none
	}

	.navbar-brand>img {
		display: block
	}

	@media(min-width: 768px) {
		.navbar>.container .navbar-brand,.navbar>.container-fluid .navbar-brand {
			margin-left:-15px
		}
	}

	.navbar-toggle {
		position: relative;
		float: right;
		padding: 9px 10px;
		margin-top: 8px;
		margin-right: 15px;
		margin-bottom: 8px;
		background-color: transparent;
		background-image: none;
		border: 1px solid transparent;
		border-radius: 4px
	}

	.navbar-toggle:focus {
		outline: 0
	}

	.navbar-toggle .icon-bar {
		display: block;
		width: 22px;
		height: 2px;
		border-radius: 1px
	}

	.navbar-toggle .icon-bar+.icon-bar {
		margin-top: 4px
	}

	@media(min-width: 768px) {
		.navbar-toggle {
			display:none
		}
	}

	.navbar-nav {
		margin: 7.5px -15px
	}

	.navbar-nav>li>a {
		padding-top: 10px;
		padding-bottom: 10px;
		line-height: 20px
	}

	@media(max-width: 767px) {
		.navbar-nav .open .dropdown-menu {
			position:static;
			float: none;
			width: auto;
			margin-top: 0;
			background-color: transparent;
			border: 0;
			-webkit-box-shadow: none;
			box-shadow: none
		}

		.navbar-nav .open .dropdown-menu>li>a,.navbar-nav .open .dropdown-menu .dropdown-header {
			padding: 5px 15px 5px 25px
		}

		.navbar-nav .open .dropdown-menu>li>a {
			line-height: 20px
		}

		.navbar-nav .open .dropdown-menu>li>a:hover,.navbar-nav .open .dropdown-menu>li>a:focus {
			background-image: none
		}
	}

	@media(min-width: 768px) {
		.navbar-nav {
			float:left;
			margin: 0
		}

		.navbar-nav>li {
			float: left
		}

		.navbar-nav>li>a {
			padding-top: 15px;
			padding-bottom: 15px
		}
	}

	.navbar-form {
		padding: 10px 15px;
		border-top: 1px solid transparent;
		border-bottom: 1px solid transparent;
		-webkit-box-shadow: inset 0 1px 0 rgba(255,255,255,.1),0 1px 0 rgba(255,255,255,.1);
		box-shadow: inset 0 1px 0 rgba(255,255,255,.1),0 1px 0 rgba(255,255,255,.1);
		margin: 8px -15px
	}

	@media(min-width: 768px) {
		.navbar-form .form-group {
			display:inline-block;
			margin-bottom: 0;
			vertical-align: middle
		}

		.navbar-form .form-control {
			display: inline-block;
			width: auto;
			vertical-align: middle
		}

		.navbar-form .form-control-static {
			display: inline-block
		}

		.navbar-form .input-group {
			display: inline-table;
			vertical-align: middle
		}

		.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn,.navbar-form .input-group .form-control {
			width: auto
		}

		.navbar-form .input-group>.form-control {
			width: 100%
		}

		.navbar-form .control-label {
			margin-bottom: 0;
			vertical-align: middle
		}

		.navbar-form .radio,.navbar-form .checkbox {
			display: inline-block;
			margin-top: 0;
			margin-bottom: 0;
			vertical-align: middle
		}

		.navbar-form .radio label,.navbar-form .checkbox label {
			padding-left: 0
		}

		.navbar-form .radio input[type="radio"],.navbar-form .checkbox input[type="checkbox"] {
			position: relative;
			margin-left: 0
		}

		.navbar-form .has-feedback .form-control-feedback {
			top: 0
		}
	}

	@media(max-width: 767px) {
		.navbar-form .form-group {
			margin-bottom:5px
		}

		.navbar-form .form-group:last-child {
			margin-bottom: 0
		}
	}

	@media(min-width: 768px) {
		.navbar-form {
			width:auto;
			padding-top: 0;
			padding-bottom: 0;
			margin-right: 0;
			margin-left: 0;
			border: 0;
			-webkit-box-shadow: none;
			box-shadow: none
		}
	}

	.navbar-nav>li>.dropdown-menu {
		margin-top: 0;
		border-top-left-radius: 0;
		border-top-right-radius: 0
	}

	.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu {
		margin-bottom: 0;
		border-top-left-radius: 4px;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0
	}

	.navbar-btn {
		margin-top: 8px;
		margin-bottom: 8px
	}

	.navbar-btn.btn-sm {
		margin-top: 10px;
		margin-bottom: 10px
	}

	.navbar-btn.btn-xs {
		margin-top: 14px;
		margin-bottom: 14px
	}

	.navbar-text {
		margin-top: 15px;
		margin-bottom: 15px
	}

	@media(min-width: 768px) {
		.navbar-text {
			float:left;
			margin-right: 15px;
			margin-left: 15px
		}
	}

	@media(min-width: 768px) {
		.navbar-left {
			float:left!important
		}

		.navbar-right {
			float: right!important;
			margin-right: -15px
		}

		.navbar-right~.navbar-right {
			margin-right: 0
		}
	}

	.navbar-default {
		background-color: #f8f8f8;
		border-color: #e7e7e7
	}

	.navbar-default .navbar-brand {
		color: #777
	}

	.navbar-default .navbar-brand:hover,.navbar-default .navbar-brand:focus {
		color: #5e5e5e;
		background-color: transparent
	}

	.navbar-default .navbar-text {
		color: #777
	}

	.navbar-default .navbar-nav>li>a {
		color: #777
	}

	.navbar-default .navbar-nav>li>a:hover,.navbar-default .navbar-nav>li>a:focus {
		color: #333;
		background-color: transparent
	}

	.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:hover,.navbar-default .navbar-nav>.active>a:focus {
		color: #555;
		background-color: #e7e7e7
	}

	.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:hover,.navbar-default .navbar-nav>.disabled>a:focus {
		color: #ccc;
		background-color: transparent
	}

	.navbar-default .navbar-toggle {
		border-color: #ddd
	}

	.navbar-default .navbar-toggle:hover,.navbar-default .navbar-toggle:focus {
		background-color: #ddd
	}

	.navbar-default .navbar-toggle .icon-bar {
		background-color: #888
	}

	.navbar-default .navbar-collapse,.navbar-default .navbar-form {
		border-color: #e7e7e7
	}

	.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:hover,.navbar-default .navbar-nav>.open>a:focus {
		color: #555;
		background-color: #e7e7e7
	}

	@media(max-width: 767px) {
		.navbar-default .navbar-nav .open .dropdown-menu>li>a {
			color:#777
		}

		.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus {
			color: #333;
			background-color: transparent
		}

		.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus {
			color: #555;
			background-color: #e7e7e7
		}

		.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus {
			color: #ccc;
			background-color: transparent
		}
	}

	.navbar-default .navbar-link {
		color: #777
	}

	.navbar-default .navbar-link:hover {
		color: #333
	}

	.navbar-default .btn-link {
		color: #777
	}

	.navbar-default .btn-link:hover,.navbar-default .btn-link:focus {
		color: #333
	}

	.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:hover,.navbar-default .btn-link[disabled]:focus,fieldset[disabled] .navbar-default .btn-link:focus {
		color: #ccc
	}

	.navbar-inverse {
		background-color: #222;
		border-color: #080808
	}

	.navbar-inverse .navbar-brand {
		color: #9d9d9d
	}

	.navbar-inverse .navbar-brand:hover,.navbar-inverse .navbar-brand:focus {
		color: #fff;
		background-color: transparent
	}

	.navbar-inverse .navbar-text {
		color: #9d9d9d
	}

	.navbar-inverse .navbar-nav>li>a {
		color: #9d9d9d
	}

	.navbar-inverse .navbar-nav>li>a:hover,.navbar-inverse .navbar-nav>li>a:focus {
		color: #fff;
		background-color: transparent
	}

	.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:hover,.navbar-inverse .navbar-nav>.active>a:focus {
		color: #fff;
		background-color: #080808
	}

	.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:hover,.navbar-inverse .navbar-nav>.disabled>a:focus {
		color: #444;
		background-color: transparent
	}

	.navbar-inverse .navbar-toggle {
		border-color: #333
	}

	.navbar-inverse .navbar-toggle:hover,.navbar-inverse .navbar-toggle:focus {
		background-color: #333
	}

	.navbar-inverse .navbar-toggle .icon-bar {
		background-color: #fff
	}

	.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form {
		border-color: #101010
	}

	.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:hover,.navbar-inverse .navbar-nav>.open>a:focus {
		color: #fff;
		background-color: #080808
	}

	@media(max-width: 767px) {
		.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header {
			border-color:#080808
		}

		.navbar-inverse .navbar-nav .open .dropdown-menu .divider {
			background-color: #080808
		}

		.navbar-inverse .navbar-nav .open .dropdown-menu>li>a {
			color: #9d9d9d
		}

		.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus {
			color: #fff;
			background-color: transparent
		}

		.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus {
			color: #fff;
			background-color: #080808
		}

		.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus {
			color: #444;
			background-color: transparent
		}
	}

	.navbar-inverse .navbar-link {
		color: #9d9d9d
	}

	.navbar-inverse .navbar-link:hover {
		color: #fff
	}

	.navbar-inverse .btn-link {
		color: #9d9d9d
	}

	.navbar-inverse .btn-link:hover,.navbar-inverse .btn-link:focus {
		color: #fff
	}

	.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:hover,.navbar-inverse .btn-link[disabled]:focus,fieldset[disabled] .navbar-inverse .btn-link:focus {
		color: #444
	}

	.breadcrumb {
		padding: 8px 15px;
		margin-bottom: 20px;
		list-style: none;
		background-color: #f5f5f5;
		border-radius: 4px
	}

	.breadcrumb>li {
		display: inline-block
	}

	.breadcrumb>li+li:before {
		padding: 0 5px;
		color: #ccc;
		content: "/ "
	}

	.breadcrumb>.active {
		color: #777
	}

	.pagination {
		display: inline-block;
		padding-left: 0;
		margin: 20px 0;
		border-radius: 4px
	}

	.pagination>li {
		display: inline
	}

	.pagination>li>a,.pagination>li>span {
		position: relative;
		float: left;
		padding: 6px 12px;
		margin-left: -1px;
		line-height: 1.42857143;
		color: #337ab7;
		text-decoration: none;
		background-color: #fff;
		border: 1px solid #ddd
	}

	.pagination>li:first-child>a,.pagination>li:first-child>span {
		margin-left: 0;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px
	}

	.pagination>li:last-child>a,.pagination>li:last-child>span {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px
	}

	.pagination>li>a:hover,.pagination>li>span:hover,.pagination>li>a:focus,.pagination>li>span:focus {
		color: #23527c;
		background-color: #eee;
		border-color: #ddd
	}

	.pagination>.active>a,.pagination>.active>span,.pagination>.active>a:hover,.pagination>.active>span:hover,.pagination>.active>a:focus,.pagination>.active>span:focus {
		z-index: 2;
		color: #fff;
		cursor: default;
		background-color: #337ab7;
		border-color: #337ab7
	}

	.pagination>.disabled>span,.pagination>.disabled>span:hover,.pagination>.disabled>span:focus,.pagination>.disabled>a,.pagination>.disabled>a:hover,.pagination>.disabled>a:focus {
		color: #777;
		cursor: not-allowed;
		background-color: #fff;
		border-color: #ddd
	}

	.pagination-lg>li>a,.pagination-lg>li>span {
		padding: 10px 16px;
		font-size: 18px
	}

	.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span {
		border-top-left-radius: 6px;
		border-bottom-left-radius: 6px
	}

	.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span {
		border-top-right-radius: 6px;
		border-bottom-right-radius: 6px
	}

	.pagination-sm>li>a,.pagination-sm>li>span {
		padding: 5px 10px;
		font-size: 12px
	}

	.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span {
		border-top-left-radius: 3px;
		border-bottom-left-radius: 3px
	}

	.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span {
		border-top-right-radius: 3px;
		border-bottom-right-radius: 3px
	}

	.pager {
		padding-left: 0;
		margin: 20px 0;
		text-align: center;
		list-style: none
	}

	.pager li {
		display: inline
	}

	.pager li>a,.pager li>span {
		display: inline-block;
		padding: 5px 14px;
		background-color: #fff;
		border: 1px solid #ddd;
		border-radius: 15px
	}

	.pager li>a:hover,.pager li>a:focus {
		text-decoration: none;
		background-color: #eee
	}

	.pager .next>a,.pager .next>span {
		float: right
	}

	.pager .previous>a,.pager .previous>span {
		float: left
	}

	.pager .disabled>a,.pager .disabled>a:hover,.pager .disabled>a:focus,.pager .disabled>span {
		color: #777;
		cursor: not-allowed;
		background-color: #fff
	}

	.label {
		display: inline;
		padding: .2em .6em .3em;
		font-size: 75%;
		font-weight: 700;
		line-height: 1;
		color: #fff;
		text-align: center;
		white-space: nowrap;
		vertical-align: baseline;
		border-radius: .25em
	}

	a.label:hover,a.label:focus {
		color: #fff;
		text-decoration: none;
		cursor: pointer
	}

	.label:empty {
		display: none
	}

	.btn .label {
		position: relative;
		top: -1px
	}

	.label-default {
		background-color: #777
	}

	.label-default[href]:hover,.label-default[href]:focus {
		background-color: #5e5e5e
	}

	.label-primary {
		background-color: #337ab7
	}

	.label-primary[href]:hover,.label-primary[href]:focus {
		background-color: #286090
	}

	.label-success {
		background-color: #5cb85c
	}

	.label-success[href]:hover,.label-success[href]:focus {
		background-color: #449d44
	}

	.label-info {
		background-color: #e63331
	}

	.label-info[href]:hover,.label-info[href]:focus {
		background-color: #31b0d5
	}

	.label-warning {
		background-color: #f0ad4e
	}

	.label-warning[href]:hover,.label-warning[href]:focus {
		background-color: #ec971f
	}

	.label-danger {
		background-color: #d9534f
	}

	.label-danger[href]:hover,.label-danger[href]:focus {
		background-color: #c9302c
	}

	.badge {
		display: inline-block;
		min-width: 10px;
		padding: 3px 7px;
		font-size: 12px;
		font-weight: 700;
		line-height: 1;
		color: #fff;
		text-align: center;
		white-space: nowrap;
		vertical-align: baseline;
		background-color: #777;
		border-radius: 10px
	}

	.badge:empty {
		display: none
	}

	.btn .badge {
		position: relative;
		top: -1px
	}

	.btn-xs .badge,.btn-group-xs>.btn .badge {
		top: 0;
		padding: 1px 5px
	}

	a.badge:hover,a.badge:focus {
		color: #fff;
		text-decoration: none;
		cursor: pointer
	}

	.list-group-item.active>.badge,.nav-pills>.active>a>.badge {
		color: #337ab7;
		background-color: #fff
	}

	.list-group-item>.badge {
		float: right
	}

	.list-group-item>.badge+.badge {
		margin-right: 5px
	}

	.nav-pills>li>a>.badge {
		margin-left: 3px
	}

	.jumbotron {
		padding: 30px 15px;
		margin-bottom: 30px;
		color: inherit;
		background-color: #eee
	}

	.jumbotron h1,.jumbotron .h1 {
		color: inherit
	}

	.jumbotron p {
		margin-bottom: 15px;
		font-size: 21px;
		font-weight: 200
	}

	.jumbotron>hr {
		border-top-color: #d5d5d5
	}

	.container .jumbotron,.container-fluid .jumbotron {
		border-radius: 6px
	}

	.jumbotron .container {
		max-width: 100%
	}

	@media screen and (min-width: 768px) {
		.jumbotron {
			padding:48px 0
		}

		.container .jumbotron,.container-fluid .jumbotron {
			padding-right: 60px;
			padding-left: 60px
		}

		.jumbotron h1,.jumbotron .h1 {
			font-size: 63px
		}
	}

	.thumbnail {
		display: block;
		padding: 4px;
		margin-bottom: 20px;
		line-height: 1.42857143;
		background-color: #fff;
		border: 1px solid #ddd;
		border-radius: 4px;
		-webkit-transition: border .2s ease-in-out;
		-o-transition: border .2s ease-in-out;
		transition: border .2s ease-in-out
	}

	.thumbnail>img,.thumbnail a>img {
		margin-right: auto;
		margin-left: auto
	}

	a.thumbnail:hover,a.thumbnail:focus,a.thumbnail.active {
		border-color: #337ab7
	}

	.thumbnail .caption {
		padding: 9px;
		color: #333
	}

	.alert {
		padding: 15px;
		margin-bottom: 20px;
		border: 1px solid transparent;
		border-radius: 4px
	}

	.alert h4 {
		margin-top: 0;
		color: inherit
	}

	.alert .alert-link {
		font-weight: 700
	}

	.alert>p,.alert>ul {
		margin-bottom: 0
	}

	.alert>p+p {
		margin-top: 5px
	}

	.alert-dismissable,.alert-dismissible {
		padding-right: 35px
	}

	.alert-dismissable .close,.alert-dismissible .close {
		position: relative;
		top: -2px;
		right: -21px;
		color: inherit
	}

	.alert-success {
		color: #3c763d;
		background-color: #dff0d8;
		border-color: #d6e9c6
	}

	.alert-success hr {
		border-top-color: #c9e2b3
	}

	.alert-success .alert-link {
		color: #2b542c
	}

	.alert-info {
		color: #31708f;
		background-color: #d9edf7;
		border-color: #bce8f1
	}

	.alert-info hr {
		border-top-color: #a6e1ec
	}

	.alert-info .alert-link {
		color: #245269
	}

	.alert-warning {
		color: #8a6d3b;
		background-color: #fcf8e3;
		border-color: #faebcc
	}

	.alert-warning hr {
		border-top-color: #f7e1b5
	}

	.alert-warning .alert-link {
		color: #66512c
	}

	.alert-danger {
		color: #a94442;
		background-color: #f2dede;
		border-color: #ebccd1
	}

	.alert-danger hr {
		border-top-color: #e4b9c0
	}

	.alert-danger .alert-link {
		color: #843534
	}

	@-webkit-keyframes progress-bar-stripes {
		from {
			background-position: 40px 0
		}

		to {
			background-position: 0 0
		}
	}

	@-o-keyframes progress-bar-stripes {
		from {
			background-position: 40px 0
		}

		to {
			background-position: 0 0
		}
	}

	@keyframes progress-bar-stripes {
		from {
			background-position: 40px 0
		}

		to {
			background-position: 0 0
		}
	}

	.progress {
		height: 20px;
		margin-bottom: 20px;
		overflow: hidden;
		background-color: #f5f5f5;
		border-radius: 4px;
		-webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
		box-shadow: inset 0 1px 2px rgba(0,0,0,.1)
	}

	.progress-bar {
		float: left;
		width: 0;
		height: 100%;
		font-size: 12px;
		line-height: 20px;
		color: #fff;
		text-align: center;
		background-color: #337ab7;
		-webkit-box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
		box-shadow: inset 0 -1px 0 rgba(0,0,0,.15);
		-webkit-transition: width .6s ease;
		-o-transition: width .6s ease;
		transition: width .6s ease
	}

	.progress-striped .progress-bar,.progress-bar-striped {
		background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: -o-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		-webkit-background-size: 40px 40px;
		background-size: 40px 40px
	}

	.progress.active .progress-bar,.progress-bar.active {
		-webkit-animation: progress-bar-stripes 2s linear infinite;
		-o-animation: progress-bar-stripes 2s linear infinite;
		animation: progress-bar-stripes 2s linear infinite
	}

	.progress-bar-success {
		background-color: #5cb85c
	}

	.progress-striped .progress-bar-success {
		background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: -o-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)
	}

	.progress-bar-info {
		background-color: #e63331
	}

	.progress-striped .progress-bar-info {
		background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: -o-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)
	}

	.progress-bar-warning {
		background-color: #f0ad4e
	}

	.progress-striped .progress-bar-warning {
		background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: -o-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)
	}

	.progress-bar-danger {
		background-color: #d9534f
	}

	.progress-striped .progress-bar-danger {
		background-image: -webkit-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: -o-linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent);
		background-image: linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)
	}

	.media {
		margin-top: 15px
	}

	.media:first-child {
		margin-top: 0
	}

	.media,.media-body {
		overflow: hidden;
		zoom:1}

	.media-body {
		width: 10000px
	}

	.media-object {
		display: block
	}

	.media-right,.media>.pull-right {
		padding-left: 10px
	}

	.media-left,.media>.pull-left {
		padding-right: 10px
	}

	.media-left,.media-right,.media-body {
		display: table-cell;
		vertical-align: top
	}

	.media-middle {
		vertical-align: middle
	}

	.media-bottom {
		vertical-align: bottom
	}

	.media-heading {
		margin-top: 0;
		margin-bottom: 5px
	}

	.media-list {
		padding-left: 0;
		list-style: none
	}

	.list-group {
		padding-left: 0;
		margin-bottom: 20px
	}

	.list-group-item {
		position: relative;
		display: block;
		padding: 10px 15px;
		margin-bottom: -1px;
		background-color: #fff;
		border: 1px solid #ddd
	}

	.list-group-item:first-child {
		border-top-left-radius: 4px;
		border-top-right-radius: 4px
	}

	.list-group-item:last-child {
		margin-bottom: 0;
		border-bottom-right-radius: 4px;
		border-bottom-left-radius: 4px
	}

	a.list-group-item {
		color: #555
	}

	a.list-group-item .list-group-item-heading {
		color: #333
	}

	a.list-group-item:hover,a.list-group-item:focus {
		color: #555;
		text-decoration: none;
		background-color: #f5f5f5
	}

	.list-group-item.disabled,.list-group-item.disabled:hover,.list-group-item.disabled:focus {
		color: #777;
		cursor: not-allowed;
		background-color: #eee
	}

	.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading {
		color: inherit
	}

	.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text {
		color: #777
	}

	.list-group-item.active,.list-group-item.active:hover,.list-group-item.active:focus {
		z-index: 2;
		color: #fff;
		background-color: #337ab7;
		border-color: #337ab7
	}

	.list-group-item.active .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>.small {
		color: inherit
	}

	.list-group-item.active .list-group-item-text,.list-group-item.active:hover .list-group-item-text,.list-group-item.active:focus .list-group-item-text {
		color: #c7ddef
	}

	.list-group-item-success {
		color: #3c763d;
		background-color: #dff0d8
	}

	a.list-group-item-success {
		color: #3c763d
	}

	a.list-group-item-success .list-group-item-heading {
		color: inherit
	}

	a.list-group-item-success:hover,a.list-group-item-success:focus {
		color: #3c763d;
		background-color: #d0e9c6
	}

	a.list-group-item-success.active,a.list-group-item-success.active:hover,a.list-group-item-success.active:focus {
		color: #fff;
		background-color: #3c763d;
		border-color: #3c763d
	}

	.list-group-item-info {
		color: #31708f;
		background-color: #d9edf7
	}

	a.list-group-item-info {
		color: #31708f
	}

	a.list-group-item-info .list-group-item-heading {
		color: inherit
	}

	a.list-group-item-info:hover,a.list-group-item-info:focus {
		color: #31708f;
		background-color: #c4e3f3
	}

	a.list-group-item-info.active,a.list-group-item-info.active:hover,a.list-group-item-info.active:focus {
		color: #fff;
		background-color: #31708f;
		border-color: #31708f
	}

	.list-group-item-warning {
		color: #8a6d3b;
		background-color: #fcf8e3
	}

	a.list-group-item-warning {
		color: #8a6d3b
	}

	a.list-group-item-warning .list-group-item-heading {
		color: inherit
	}

	a.list-group-item-warning:hover,a.list-group-item-warning:focus {
		color: #8a6d3b;
		background-color: #faf2cc
	}

	a.list-group-item-warning.active,a.list-group-item-warning.active:hover,a.list-group-item-warning.active:focus {
		color: #fff;
		background-color: #8a6d3b;
		border-color: #8a6d3b
	}

	.list-group-item-danger {
		color: #a94442;
		background-color: #f2dede
	}

	a.list-group-item-danger {
		color: #a94442
	}

	a.list-group-item-danger .list-group-item-heading {
		color: inherit
	}

	a.list-group-item-danger:hover,a.list-group-item-danger:focus {
		color: #a94442;
		background-color: #ebcccc
	}

	a.list-group-item-danger.active,a.list-group-item-danger.active:hover,a.list-group-item-danger.active:focus {
		color: #fff;
		background-color: #a94442;
		border-color: #a94442
	}

	.list-group-item-heading {
		margin-top: 0;
		margin-bottom: 5px
	}

	.list-group-item-text {
		margin-bottom: 0;
		line-height: 1.3
	}

	.panel {
		margin-bottom: 20px;
		background-color: #fff;
		border: 1px solid transparent;
		border-radius: 4px;
		-webkit-box-shadow: 0 1px 1px rgba(0,0,0,.05);
		box-shadow: 0 1px 1px rgba(0,0,0,.05)
	}

	.panel-body {
		padding: 15px
	}

	.panel-heading {
		padding: 10px 15px;
		border-bottom: 1px solid transparent;
		border-top-left-radius: 3px;
		border-top-right-radius: 3px
	}

	.panel-heading>.dropdown .dropdown-toggle {
		color: inherit
	}

	.panel-title {
		margin-top: 0;
		margin-bottom: 0;
		font-size: 16px;
		color: inherit
	}

	.panel-title>a,.panel-title>small,.panel-title>.small,.panel-title>small>a,.panel-title>.small>a {
		color: inherit
	}

	.panel-footer {
		padding: 10px 15px;
		background-color: #f5f5f5;
		border-top: 1px solid #ddd;
		border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px
	}

	.panel>.list-group,.panel>.panel-collapse>.list-group {
		margin-bottom: 0
	}

	.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item {
		border-width: 1px 0;
		border-radius: 0
	}

	.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child {
		border-top: 0;
		border-top-left-radius: 3px;
		border-top-right-radius: 3px
	}

	.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child {
		border-bottom: 0;
		border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px
	}

	.panel-heading+.list-group .list-group-item:first-child {
		border-top-width: 0
	}

	.list-group+.panel-footer {
		border-top-width: 0
	}

	.panel>.table,.panel>.table-responsive>.table,.panel>.panel-collapse>.table {
		margin-bottom: 0
	}

	.panel>.table caption,.panel>.table-responsive>.table caption,.panel>.panel-collapse>.table caption {
		padding-right: 15px;
		padding-left: 15px
	}

	.panel>.table:first-child,.panel>.table-responsive:first-child>.table:first-child {
		border-top-left-radius: 3px;
		border-top-right-radius: 3px
	}

	.panel>.table:first-child>thead:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child {
		border-top-left-radius: 3px;
		border-top-right-radius: 3px
	}

	.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child {
		border-top-left-radius: 3px
	}

	.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child {
		border-top-right-radius: 3px
	}

	.panel>.table:last-child,.panel>.table-responsive:last-child>.table:last-child {
		border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px
	}

	.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child {
		border-bottom-right-radius: 3px;
		border-bottom-left-radius: 3px
	}

	.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child {
		border-bottom-left-radius: 3px
	}

	.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child {
		border-bottom-right-radius: 3px
	}

	.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body {
		border-top: 1px solid #ddd
	}

	.panel>.table>tbody:first-child>tr:first-child th,.panel>.table>tbody:first-child>tr:first-child td {
		border-top: 0
	}

	.panel>.table-bordered,.panel>.table-responsive>.table-bordered {
		border: 0
	}

	.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child {
		border-left: 0
	}

	.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child {
		border-right: 0
	}

	.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th {
		border-bottom: 0
	}

	.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th {
		border-bottom: 0
	}

	.panel>.table-responsive {
		margin-bottom: 0;
		border: 0
	}

	.panel-group {
		margin-bottom: 20px
	}

	.panel-group .panel {
		margin-bottom: 0;
		border-radius: 4px
	}

	.panel-group .panel+.panel {
		margin-top: 5px
	}

	.panel-group .panel-heading {
		border-bottom: 0
	}

	.panel-group .panel-heading+.panel-collapse>.panel-body,.panel-group .panel-heading+.panel-collapse>.list-group {
		border-top: 1px solid #ddd
	}

	.panel-group .panel-footer {
		border-top: 0
	}

	.panel-group .panel-footer+.panel-collapse .panel-body {
		border-bottom: 1px solid #ddd
	}

	.panel-default {
		border-color: #ddd
	}

	.panel-default>.panel-heading {
		color: #333;
		background-color: #f5f5f5;
		border-color: #ddd
	}

	.panel-default>.panel-heading+.panel-collapse>.panel-body {
		border-top-color: #ddd
	}

	.panel-default>.panel-heading .badge {
		color: #f5f5f5;
		background-color: #333
	}

	.panel-default>.panel-footer+.panel-collapse>.panel-body {
		border-bottom-color: #ddd
	}

	.panel-primary {
		border-color: #337ab7
	}

	.panel-primary>.panel-heading {
		color: #fff;
		background-color: #337ab7;
		border-color: #337ab7
	}

	.panel-primary>.panel-heading+.panel-collapse>.panel-body {
		border-top-color: #337ab7
	}

	.panel-primary>.panel-heading .badge {
		color: #337ab7;
		background-color: #fff
	}

	.panel-primary>.panel-footer+.panel-collapse>.panel-body {
		border-bottom-color: #337ab7
	}

	.panel-success {
		border-color: #d6e9c6
	}

	.panel-success>.panel-heading {
		color: #3c763d;
		background-color: #dff0d8;
		border-color: #d6e9c6
	}

	.panel-success>.panel-heading+.panel-collapse>.panel-body {
		border-top-color: #d6e9c6
	}

	.panel-success>.panel-heading .badge {
		color: #dff0d8;
		background-color: #3c763d
	}

	.panel-success>.panel-footer+.panel-collapse>.panel-body {
		border-bottom-color: #d6e9c6
	}

	.panel-info {
		border-color: #bce8f1
	}

	.panel-info>.panel-heading {
		color: #31708f;
		background-color: #d9edf7;
		border-color: #bce8f1
	}

	.panel-info>.panel-heading+.panel-collapse>.panel-body {
		border-top-color: #bce8f1
	}

	.panel-info>.panel-heading .badge {
		color: #d9edf7;
		background-color: #31708f
	}

	.panel-info>.panel-footer+.panel-collapse>.panel-body {
		border-bottom-color: #bce8f1
	}

	.panel-warning {
		border-color: #faebcc
	}

	.panel-warning>.panel-heading {
		color: #8a6d3b;
		background-color: #fcf8e3;
		border-color: #faebcc
	}

	.panel-warning>.panel-heading+.panel-collapse>.panel-body {
		border-top-color: #faebcc
	}

	.panel-warning>.panel-heading .badge {
		color: #fcf8e3;
		background-color: #8a6d3b
	}

	.panel-warning>.panel-footer+.panel-collapse>.panel-body {
		border-bottom-color: #faebcc
	}

	.panel-danger {
		border-color: #ebccd1
	}

	.panel-danger>.panel-heading {
		color: #a94442;
		background-color: #f2dede;
		border-color: #ebccd1
	}

	.panel-danger>.panel-heading+.panel-collapse>.panel-body {
		border-top-color: #ebccd1
	}

	.panel-danger>.panel-heading .badge {
		color: #f2dede;
		background-color: #a94442
	}

	.panel-danger>.panel-footer+.panel-collapse>.panel-body {
		border-bottom-color: #ebccd1
	}

	.embed-responsive {
		position: relative;
		display: block;
		height: 0;
		padding: 0;
		overflow: hidden
	}

	.embed-responsive .embed-responsive-item,.embed-responsive iframe,.embed-responsive embed,.embed-responsive object,.embed-responsive video {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 100%;
		border: 0
	}

	.embed-responsive-16by9 {
		padding-bottom: 56.25%
	}

	.embed-responsive-4by3 {
		padding-bottom: 75%
	}

	.well {
		min-height: 20px;
		padding: 19px;
		margin-bottom: 20px;
		background-color: #f5f5f5;
		border: 1px solid #e3e3e3;
		border-radius: 4px;
		-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.05);
		box-shadow: inset 0 1px 1px rgba(0,0,0,.05)
	}

	.well blockquote {
		border-color: #ddd;
		border-color: rgba(0,0,0,.15)
	}

	.well-lg {
		padding: 24px;
		border-radius: 6px
	}

	.well-sm {
		padding: 9px;
		border-radius: 3px
	}

	.close {
		float: right;
		font-size: 21px;
		font-weight: 700;
		line-height: 1;
		color: #000;
		text-shadow: 0 1px 0 #fff;
		filter: alpha(opacity=20);
		opacity: .2
	}

	.close:hover,.close:focus {
		color: #000;
		text-decoration: none;
		cursor: pointer;
		filter: alpha(opacity=50);
		opacity: .5
	}

	button.close {
		-webkit-appearance: none;
		appearance: none;
		padding: 0;
		cursor: pointer;
		background: transparent;
		border: 0
	}

	.modal-open {
		overflow: hidden
	}

	.modal {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 1050;
		display: none;
		overflow: hidden;
		-webkit-overflow-scrolling: touch;
		outline: 0
	}

	.modal.fade .modal-dialog {
		-webkit-transition: -webkit-transform .3s ease-out;
		-o-transition: -o-transform .3s ease-out;
		transition: transform .3s ease-out;
		-webkit-transform: translate(0,-25%);
		-ms-transform: translate(0,-25%);
		-o-transform: translate(0,-25%);
		transform: translate(0,-25%)
	}

	.modal.in .modal-dialog {
		-webkit-transform: translate(0,0);
		-ms-transform: translate(0,0);
		-o-transform: translate(0,0);
		transform: translate(0,0)
	}

	.modal-open .modal {
		overflow-x: hidden;
		overflow-y: auto
	}

	.modal-dialog {
		position: relative;
		width: auto;
		margin: 10px
	}

	.modal-content {
		position: relative;
		background-color: #fff;
		-webkit-background-clip: padding-box;
		background-clip: padding-box;
		border: 1px solid #999;
		border: 1px solid rgba(0,0,0,.2);
		border-radius: 6px;
		outline: 0;
		-webkit-box-shadow: 0 3px 9px rgba(0,0,0,.5);
		box-shadow: 0 3px 9px rgba(0,0,0,.5)
	}

	.modal-backdrop {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: -1!important;
		background-color: #000
	}

	.modal-backdrop.fade {
		filter: alpha(opacity=0);
		opacity: 0
	}

	.modal-backdrop.in {
		filter: alpha(opacity=50);
		opacity: .5
	}

	.modal-header {
		min-height: 16.42857143px;
		padding: 15px;
		border-bottom: 1px solid #e5e5e5
	}

	.modal-header .close {
		margin-top: -2px
	}

	.modal-title {
		margin: 0;
		line-height: 1.42857143
	}

	.modal-body {
		position: relative;
		padding: 15px
	}

	.modal-footer {
		padding: 15px;
		text-align: right;
		border-top: 1px solid #e5e5e5
	}

	.modal-footer .btn+.btn {
		margin-bottom: 0;
		margin-left: 5px
	}

	.modal-footer .btn-group .btn+.btn {
		margin-left: -1px
	}

	.modal-footer .btn-block+.btn-block {
		margin-left: 0
	}

	.modal-scrollbar-measure {
		position: absolute;
		top: -9999px;
		width: 50px;
		height: 50px;
		overflow: scroll
	}

	@media(min-width: 768px) {
		.modal-dialog {
			width:600px;
			margin: 30px auto
		}

		.modal-content {
			-webkit-box-shadow: 0 5px 15px rgba(0,0,0,.5);
			box-shadow: 0 5px 15px rgba(0,0,0,.5)
		}

		.modal-sm {
			width: 300px
		}
	}

	@media(min-width: 992px) {
		.modal-lg {
			width:900px
		}
	}

	.tooltip {
		position: absolute;
		z-index: 1070;
		display: block;
		font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
		font-size: 12px;
		font-weight: 400;
		line-height: 1.4;
		filter: alpha(opacity=0);
		opacity: 0
	}

	.tooltip.in {
		filter: alpha(opacity=90);
		opacity: .9
	}

	.tooltip.top {
		padding: 5px 0;
		margin-top: -3px
	}

	.tooltip.right {
		padding: 0 5px;
		margin-left: 3px
	}

	.tooltip.bottom {
		padding: 5px 0;
		margin-top: 3px
	}

	.tooltip.left {
		padding: 0 5px;
		margin-left: -3px
	}

	.tooltip-inner {
		max-width: 200px;
		padding: 3px 8px;
		color: #fff;
		text-align: center;
		text-decoration: none;
		background-color: #000;
		border-radius: 4px
	}

	.tooltip-arrow {
		position: absolute;
		width: 0;
		height: 0;
		border-color: transparent;
		border-style: solid
	}

	.tooltip.top .tooltip-arrow {
		bottom: 0;
		left: 50%;
		margin-left: -5px;
		border-width: 5px 5px 0;
		border-top-color: #000
	}

	.tooltip.top-left .tooltip-arrow {
		right: 5px;
		bottom: 0;
		margin-bottom: -5px;
		border-width: 5px 5px 0;
		border-top-color: #000
	}

	.tooltip.top-right .tooltip-arrow {
		bottom: 0;
		left: 5px;
		margin-bottom: -5px;
		border-width: 5px 5px 0;
		border-top-color: #000
	}

	.tooltip.right .tooltip-arrow {
		top: 50%;
		left: 0;
		margin-top: -5px;
		border-width: 5px 5px 5px 0;
		border-right-color: #000
	}

	.tooltip.left .tooltip-arrow {
		top: 50%;
		right: 0;
		margin-top: -5px;
		border-width: 5px 0 5px 5px;
		border-left-color: #000
	}

	.tooltip.bottom .tooltip-arrow {
		top: 0;
		left: 50%;
		margin-left: -5px;
		border-width: 0 5px 5px;
		border-bottom-color: #000
	}

	.tooltip.bottom-left .tooltip-arrow {
		top: 0;
		right: 5px;
		margin-top: -5px;
		border-width: 0 5px 5px;
		border-bottom-color: #000
	}

	.tooltip.bottom-right .tooltip-arrow {
		top: 0;
		left: 5px;
		margin-top: -5px;
		border-width: 0 5px 5px;
		border-bottom-color: #000
	}

	.popover {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1060;
		display: none;
		max-width: 276px;
		padding: 1px;
		font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
		font-size: 14px;
		font-weight: 400;
		line-height: 1.42857143;
		text-align: left;
		white-space: normal;
		background-color: #fff;
		-webkit-background-clip: padding-box;
		background-clip: padding-box;
		border: 1px solid #ccc;
		border: 1px solid rgba(0,0,0,.2);
		border-radius: 6px;
		-webkit-box-shadow: 0 5px 10px rgba(0,0,0,.2);
		box-shadow: 0 5px 10px rgba(0,0,0,.2)
	}

	.popover.top {
		margin-top: -10px
	}

	.popover.right {
		margin-left: 10px
	}

	.popover.bottom {
		margin-top: 10px
	}

	.popover.left {
		margin-left: -10px
	}

	.popover-title {
		padding: 8px 14px;
		margin: 0;
		font-size: 14px;
		background-color: #f7f7f7;
		border-bottom: 1px solid #ebebeb;
		border-radius: 5px 5px 0 0
	}

	.popover-content {
		padding: 9px 14px
	}

	.popover>.arrow,.popover>.arrow:after {
		position: absolute;
		display: block;
		width: 0;
		height: 0;
		border-color: transparent;
		border-style: solid
	}

	.popover>.arrow {
		border-width: 11px
	}

	.popover>.arrow:after {
		content: "";
		border-width: 10px
	}

	.popover.top>.arrow {
		bottom: -11px;
		left: 50%;
		margin-left: -11px;
		border-top-color: #999;
		border-top-color: rgba(0,0,0,.25);
		border-bottom-width: 0
	}

	.popover.top>.arrow:after {
		bottom: 1px;
		margin-left: -10px;
		content: " ";
		border-top-color: #fff;
		border-bottom-width: 0
	}

	.popover.right>.arrow {
		top: 50%;
		left: -11px;
		margin-top: -11px;
		border-right-color: #999;
		border-right-color: rgba(0,0,0,.25);
		border-left-width: 0
	}

	.popover.right>.arrow:after {
		bottom: -10px;
		left: 1px;
		content: " ";
		border-right-color: #fff;
		border-left-width: 0
	}

	.popover.bottom>.arrow {
		top: -11px;
		left: 50%;
		margin-left: -11px;
		border-top-width: 0;
		border-bottom-color: #999;
		border-bottom-color: rgba(0,0,0,.25)
	}

	.popover.bottom>.arrow:after {
		top: 1px;
		margin-left: -10px;
		content: " ";
		border-top-width: 0;
		border-bottom-color: #fff
	}

	.popover.left>.arrow {
		top: 50%;
		right: -11px;
		margin-top: -11px;
		border-right-width: 0;
		border-left-color: #999;
		border-left-color: rgba(0,0,0,.25)
	}

	.popover.left>.arrow:after {
		right: 1px;
		bottom: -10px;
		content: " ";
		border-right-width: 0;
		border-left-color: #fff
	}

	.carousel {
		position: relative
	}

	.carousel-inner {
		position: relative;
		width: 100%;
		overflow: hidden
	}

	.carousel-inner>.item {
		position: relative;
		display: none;
		-webkit-transition: .6s ease-in-out left;
		-o-transition: .6s ease-in-out left;
		transition: .6s ease-in-out left
	}

	.carousel-inner>.item>img,.carousel-inner>.item>a>img {
		line-height: 1
	}

	@media all and (transform-3d),(-webkit-transform-3d) {
		.carousel-inner>.item {
			-webkit-transition: -webkit-transform .6s ease-in-out;
			-o-transition: -o-transform .6s ease-in-out;
			transition: transform .6s ease-in-out;
			-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
			-webkit-perspective: 1000;
			perspective: 1000px
		}

		.carousel-inner>.item.next,.carousel-inner>.item.active.right {
			left: 0;
			-webkit-transform: translate3d(100%,0,0);
			transform: translate3d(100%,0,0)
		}

		.carousel-inner>.item.prev,.carousel-inner>.item.active.left {
			left: 0;
			-webkit-transform: translate3d(-100%,0,0);
			transform: translate3d(-100%,0,0)
		}

		.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right,.carousel-inner>.item.active {
			left: 0;
			-webkit-transform: translate3d(0,0,0);
			transform: translate3d(0,0,0)
		}
	}

	.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev {
		display: block
	}

	.carousel-inner>.active {
		left: 0
	}

	.carousel-inner>.next,.carousel-inner>.prev {
		position: absolute;
		top: 0;
		width: 100%
	}

	.carousel-inner>.next {
		left: 100%
	}

	.carousel-inner>.prev {
		left: -100%
	}

	.carousel-inner>.next.left,.carousel-inner>.prev.right {
		left: 0
	}

	.carousel-inner>.active.left {
		left: -100%
	}

	.carousel-inner>.active.right {
		left: 100%
	}

	.carousel-control {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		width: 15%;
		font-size: 20px;
		color: #fff;
		text-align: center;
		text-shadow: 0 1px 2px rgba(0,0,0,.6);
		filter: alpha(opacity=50);
		opacity: .5
	}

	.carousel-control.left {
		background-image: -webkit-linear-gradient(left,rgba(0,0,0,.5) 0%,rgba(0,0,0,.0001) 100%);
		background-image: -o-linear-gradient(left,rgba(0,0,0,.5) 0%,rgba(0,0,0,.0001) 100%);
		background-image: -webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.5)),to(rgba(0,0,0,.0001)));
		background-image: linear-gradient(to right,rgba(0,0,0,.5) 0%,rgba(0,0,0,.0001) 100%);
		filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000',endColorstr='#00000000',GradientType=1);
		background-repeat: repeat-x
	}

	.carousel-control.right {
		right: 0;
		left: auto;
		background-image: -webkit-linear-gradient(left,rgba(0,0,0,.0001) 0%,rgba(0,0,0,.5) 100%);
		background-image: -o-linear-gradient(left,rgba(0,0,0,.0001) 0%,rgba(0,0,0,.5) 100%);
		background-image: -webkit-gradient(linear,left top,right top,from(rgba(0,0,0,.0001)),to(rgba(0,0,0,.5)));
		background-image: linear-gradient(to right,rgba(0,0,0,.0001) 0%,rgba(0,0,0,.5) 100%);
		filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000',endColorstr='#80000000',GradientType=1);
		background-repeat: repeat-x
	}

	.carousel-control:hover,.carousel-control:focus {
		color: #fff;
		text-decoration: none;
		filter: alpha(opacity=90);
		outline: 0;
		opacity: .9
	}

	.carousel-control .icon-prev,.carousel-control .icon-next,.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right {
		position: absolute;
		top: 50%;
		z-index: 5;
		display: inline-block
	}

	.carousel-control .icon-prev,.carousel-control .glyphicon-chevron-left {
		left: 50%;
		margin-left: -10px
	}

	.carousel-control .icon-next,.carousel-control .glyphicon-chevron-right {
		right: 50%;
		margin-right: -10px
	}

	.carousel-control .icon-prev,.carousel-control .icon-next {
		width: 20px;
		height: 20px;
		margin-top: -10px;
		font-family: serif;
		line-height: 1
	}

	.carousel-control .icon-prev:before {
		content: '‹'
	}

	.carousel-control .icon-next:before {
		content: '›'
	}

	.carousel-indicators {
		position: absolute;
		bottom: 10px;
		left: 50%;
		z-index: 15;
		width: 60%;
		padding-left: 0;
		margin-left: -30%;
		text-align: center;
		list-style: none
	}

	.carousel-indicators li {
		display: inline-block;
		width: 10px;
		height: 10px;
		margin: 1px;
		text-indent: -999px;
		cursor: pointer;
		background-color: #000 \9;
		background-color: rgba(0,0,0,0);
		border: 1px solid #fff;
		border-radius: 10px
	}

	.carousel-indicators .active {
		width: 12px;
		height: 12px;
		margin: 0;
		background-color: #fff
	}

	.carousel-caption {
		position: absolute;
		right: 15%;
		bottom: 20px;
		left: 15%;
		z-index: 10;
		padding-top: 20px;
		padding-bottom: 20px;
		color: #fff;
		text-align: center;
		text-shadow: 0 1px 2px rgba(0,0,0,.6)
	}

	.carousel-caption .btn {
		text-shadow: none
	}

	@media screen and (min-width: 768px) {
		.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-prev,.carousel-control .icon-next {
			width:30px;
			height: 30px;
			margin-top: -15px;
			font-size: 30px
		}

		.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev {
			margin-left: -15px
		}

		.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next {
			margin-right: -15px
		}

		.carousel-caption {
			right: 20%;
			left: 20%;
			padding-bottom: 30px
		}

		.carousel-indicators {
			bottom: 20px
		}
	}

	.clearfix:before,.clearfix:after,.dl-horizontal dd:before,.dl-horizontal dd:after,.container:before,.container:after,.container-fluid:before,.container-fluid:after,.row:before,.row:after,.form-horizontal .form-group:before,.form-horizontal .form-group:after,.btn-toolbar:before,.btn-toolbar:after,.btn-group-vertical>.btn-group:before,.btn-group-vertical>.btn-group:after,.nav:before,.nav:after,.navbar:before,.navbar:after,.navbar-header:before,.navbar-header:after,.navbar-collapse:before,.navbar-collapse:after,.pager:before,.pager:after,.panel-body:before,.panel-body:after,.modal-footer:before,.modal-footer:after {
		display: table;
		content: " "
	}

	.clearfix:after,.dl-horizontal dd:after,.container:after,.container-fluid:after,.row:after,.form-horizontal .form-group:after,.btn-toolbar:after,.btn-group-vertical>.btn-group:after,.nav:after,.navbar:after,.navbar-header:after,.navbar-collapse:after,.pager:after,.panel-body:after,.modal-footer:after {
		clear: both
	}

	.center-block {
		display: block;
		margin-right: auto;
		margin-left: auto
	}

	.pull-right {
		float: right!important
	}

	.pull-left {
		float: left!important
	}

	.hide {
		display: none!important
	}

	.show {
		display: block!important
	}

	.invisible {
		visibility: hidden
	}

	.text-hide {
		font: 0/0 a;
		color: transparent;
		text-shadow: none;
		background-color: transparent;
		border: 0
	}

	.hidden {
		display: none!important
	}

	.affix {
		position: fixed
	}

	.visible-xs,.visible-sm,.visible-md,.visible-lg {
		display: none!important
	}

	.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block {
		display: none!important
	}

	@media(max-width: 767px) {
		.visible-xs {
			display:block!important
		}

		table.visible-xs {
			display: table
		}

		tr.visible-xs {
			display: table-row!important
		}

		th.visible-xs,td.visible-xs {
			display: table-cell!important
		}
	}

	@media(max-width: 767px) {
		.visible-xs-block {
			display:block!important
		}
	}

	@media(max-width: 767px) {
		.visible-xs-inline {
			display:inline!important
		}
	}

	@media(max-width: 767px) {
		.visible-xs-inline-block {
			display:inline-block!important
		}
	}

	@media(min-width: 768px)and (max-width:991px) {
		.visible-sm {
			display:block!important
		}

		table.visible-sm {
			display: table
		}

		tr.visible-sm {
			display: table-row!important
		}

		th.visible-sm,td.visible-sm {
			display: table-cell!important
		}

		.visible-sm-block {
			display: block!important
		}

		.visible-sm-inline {
			display: inline!important
		}

		.visible-sm-inline-block {
			display: inline-block!important
		}
	}

	@media(min-width: 992px)and (max-width:1199px) {
		.visible-md {
			display:block!important
		}

		table.visible-md {
			display: table
		}

		tr.visible-md {
			display: table-row!important
		}

		th.visible-md,td.visible-md {
			display: table-cell!important
		}

		.visible-md-block {
			display: block!important
		}

		.visible-md-inline {
			display: inline!important
		}

		.visible-md-inline-block {
			display: inline-block!important
		}
	}

	@media(min-width: 1200px) {
		.visible-lg {
			display:block!important
		}

		table.visible-lg {
			display: table
		}

		tr.visible-lg {
			display: table-row!important
		}

		th.visible-lg,td.visible-lg {
			display: table-cell!important
		}
	}

	@media(min-width: 1200px) {
		.visible-lg-block {
			display:block!important
		}
	}

	@media(min-width: 1200px) {
		.visible-lg-inline {
			display:inline!important
		}
	}

	@media(min-width: 1200px) {
		.visible-lg-inline-block {
			display:inline-block!important
		}
	}

	@media(max-width: 767px) {
		.hidden-xs {
			display:none!important
		}
	}

	@media(min-width: 768px)and (max-width:991px) {
		.hidden-sm {
			display:none!important
		}
	}

	@media(min-width: 992px)and (max-width:1199px) {
		.hidden-md {
			display:none!important
		}
	}

	@media(min-width: 1200px) {
		.hidden-lg {
			display:none!important
		}
	}

	.visible-print {
		display: none!important
	}

	@media print {
		.visible-print {
			display: block!important
		}

		table.visible-print {
			display: table
		}

		tr.visible-print {
			display: table-row!important
		}

		th.visible-print,td.visible-print {
			display: table-cell!important
		}
	}

	.visible-print-block {
		display: none!important
	}

	@media print {
		.visible-print-block {
			display: block!important
		}
	}

	.visible-print-inline {
		display: none!important
	}

	@media print {
		.visible-print-inline {
			display: inline!important
		}
	}

	.visible-print-inline-block {
		display: none!important
	}

	@media print {
		.visible-print-inline-block {
			display: inline-block!important
		}
	}

	@media print {
		.hidden-print {
			display: none!important
		}
	}

	@-webkit-keyframes fa-spin {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg)
		}

		100% {
			-webkit-transform: rotate(359deg);
			transform: rotate(359deg)
		}
	}

	@keyframes fa-spin {
		0% {
			-webkit-transform: rotate(0deg);
			transform: rotate(0deg)
		}

		100% {
			-webkit-transform: rotate(359deg);
			transform: rotate(359deg)
		}
	}

	.fa-rotate-90 {
		filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
		-webkit-transform: rotate(90deg);
		-ms-transform: rotate(90deg);
		transform: rotate(90deg)
	}

	.fa-rotate-180 {
		filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
		-webkit-transform: rotate(180deg);
		-ms-transform: rotate(180deg);
		transform: rotate(180deg)
	}

	.fa-rotate-270 {
		filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
		-webkit-transform: rotate(270deg);
		-ms-transform: rotate(270deg);
		transform: rotate(270deg)
	}

	.fa-flip-horizontal {
		filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0,mirror=1);
		-webkit-transform: scale(-1,1);
		-ms-transform: scale(-1,1);
		transform: scale(-1,1)
	}

	.fa-flip-vertical {
		filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2,mirror=1);
		-webkit-transform: scale(1,-1);
		-ms-transform: scale(1,-1);
		transform: scale(1,-1)
	}

	:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-flip-horizontal,:root .fa-flip-vertical {
		filter: none
	}

	.fa-stack {
		position: relative;
		display: inline-block;
		width: 2em;
		height: 2em;
		line-height: 2em;
		vertical-align: middle
	}

	.fa-stack-1x,.fa-stack-2x {
		position: absolute;
		left: 0;
		width: 100%;
		text-align: center
	}

	.fa-stack-1x {
		line-height: inherit
	}

	.fa-stack-2x {
		font-size: 2em
	}

	.fa-inverse {
		color: #fff
	}

	.fa-glass:before {
		content: ""
	}

	.fa-music:before {
		content: ""
	}

	.fa-search:before {
		content: ""
	}

	.fa-envelope-o:before {
		content: ""
	}

	.fa-heart:before {
		content: ""
	}

	.fa-star:before {
		content: ""
	}

	.fa-star-o:before {
		content: ""
	}

	.fa-user:before {
		content: ""
	}

	.fa-film:before {
		content: ""
	}

	.fa-th-large:before {
		content: ""
	}

	.fa-th:before {
		content: ""
	}

	.fa-th-list:before {
		content: ""
	}

	.fa-check:before {
		content: ""
	}

	.fa-remove:before,.fa-close:before,.fa-times:before {
		content: ""
	}

	.fa-search-plus:before {
		content: ""
	}

	.fa-search-minus:before {
		content: ""
	}

	.fa-power-off:before {
		content: ""
	}

	.fa-signal:before {
		content: ""
	}

	.fa-gear:before,.fa-cog:before {
		content: ""
	}

	.fa-trash-o:before {
		content: ""
	}

	.fa-home:before {
		content: ""
	}

	.fa-file-o:before {
		content: ""
	}

	.fa-clock-o:before {
		content: ""
	}

	.fa-road:before {
		content: ""
	}

	.fa-download:before {
		content: ""
	}

	.fa-arrow-circle-o-down:before {
		content: ""
	}

	.fa-arrow-circle-o-up:before {
		content: ""
	}

	.fa-inbox:before {
		content: ""
	}

	.fa-play-circle-o:before {
		content: ""
	}

	.fa-rotate-right:before,.fa-repeat:before {
		content: ""
	}

	.fa-refresh:before {
		content: ""
	}

	.fa-list-alt:before {
		content: ""
	}

	.fa-lock:before {
		content: ""
	}

	.fa-flag:before {
		content: ""
	}

	.fa-headphones:before {
		content: ""
	}

	.fa-volume-off:before {
		content: ""
	}

	.fa-volume-down:before {
		content: ""
	}

	.fa-volume-up:before {
		content: ""
	}

	.fa-qrcode:before {
		content: ""
	}

	.fa-barcode:before {
		content: ""
	}

	.fa-tag:before {
		content: ""
	}

	.fa-tags:before {
		content: ""
	}

	.fa-book:before {
		content: ""
	}

	.fa-bookmark:before {
		content: ""
	}

	.fa-print:before {
		content: ""
	}

	.fa-camera:before {
		content: ""
	}

	.fa-font:before {
		content: ""
	}

	.fa-bold:before {
		content: ""
	}

	.fa-italic:before {
		content: ""
	}

	.fa-text-height:before {
		content: ""
	}

	.fa-text-width:before {
		content: ""
	}

	.fa-align-left:before {
		content: ""
	}

	.fa-align-center:before {
		content: ""
	}

	.fa-align-right:before {
		content: ""
	}

	.fa-align-justify:before {
		content: ""
	}

	.fa-list:before {
		content: ""
	}

	.fa-dedent:before,.fa-outdent:before {
		content: ""
	}

	.fa-indent:before {
		content: ""
	}

	.fa-video-camera:before {
		content: ""
	}

	.fa-photo:before,.fa-image:before,.fa-picture-o:before {
		content: ""
	}

	.fa-pencil:before {
		content: ""
	}

	.fa-map-marker:before {
		content: ""
	}

	.fa-adjust:before {
		content: ""
	}

	.fa-tint:before {
		content: ""
	}

	.fa-edit:before,.fa-pencil-square-o:before {
		content: ""
	}

	.fa-share-square-o:before {
		content: ""
	}

	.fa-check-square-o:before {
		content: ""
	}

	.fa-arrows:before {
		content: ""
	}

	.fa-step-backward:before {
		content: ""
	}

	.fa-fast-backward:before {
		content: ""
	}

	.fa-backward:before {
		content: ""
	}

	.fa-play:before {
		content: ""
	}

	.fa-pause:before {
		content: ""
	}

	.fa-stop:before {
		content: ""
	}

	.fa-forward:before {
		content: ""
	}

	.fa-fast-forward:before {
		content: ""
	}

	.fa-step-forward:before {
		content: ""
	}

	.fa-eject:before {
		content: ""
	}

	.fa-chevron-left:before {
		content: ""
	}

	.fa-chevron-right:before {
		content: ""
	}

	.fa-plus-circle:before {
		content: ""
	}

	.fa-minus-circle:before {
		content: ""
	}

	.fa-times-circle:before {
		content: ""
	}

	.fa-check-circle:before {
		content: ""
	}

	.fa-question-circle:before {
		content: ""
	}

	.fa-info-circle:before {
		content: ""
	}

	.fa-crosshairs:before {
		content: ""
	}

	.fa-times-circle-o:before {
		content: ""
	}

	.fa-check-circle-o:before {
		content: ""
	}

	.fa-ban:before {
		content: ""
	}

	.fa-arrow-left:before {
		content: ""
	}

	.fa-arrow-right:before {
		content: ""
	}

	.fa-arrow-up:before {
		content: ""
	}

	.fa-arrow-down:before {
		content: ""
	}

	.fa-mail-forward:before,.fa-share:before {
		content: ""
	}

	.fa-expand:before {
		content: ""
	}

	.fa-compress:before {
		content: ""
	}

	.fa-plus:before {
		content: ""
	}

	.fa-minus:before {
		content: ""
	}

	.fa-asterisk:before {
		content: ""
	}

	.fa-exclamation-circle:before {
		content: ""
	}

	.fa-gift:before {
		content: ""
	}

	.fa-leaf:before {
		content: ""
	}

	.fa-fire:before {
		content: ""
	}

	.fa-eye:before {
		content: ""
	}

	.fa-eye-slash:before {
		content: ""
	}

	.fa-warning:before,.fa-exclamation-triangle:before {
		content: ""
	}

	.fa-plane:before {
		content: ""
	}

	.fa-calendar:before {
		content: ""
	}

	.fa-random:before {
		content: ""
	}

	.fa-comment:before {
		content: ""
	}

	.fa-magnet:before {
		content: ""
	}

	.fa-chevron-up:before {
		content: ""
	}

	.fa-chevron-down:before {
		content: ""
	}

	.fa-retweet:before {
		content: ""
	}

	.fa-shopping-cart:before {
		content: ""
	}

	.fa-folder:before {
		content: ""
	}

	.fa-folder-open:before {
		content: ""
	}

	.fa-arrows-v:before {
		content: ""
	}

	.fa-arrows-h:before {
		content: ""
	}

	.fa-bar-chart-o:before,.fa-bar-chart:before {
		content: ""
	}

	.fa-twitter-square:before {
		content: ""
	}

	.fa-facebook-square:before {
		content: ""
	}

	.fa-camera-retro:before {
		content: ""
	}

	.fa-key:before {
		content: ""
	}

	.fa-gears:before,.fa-cogs:before {
		content: ""
	}

	.fa-comments:before {
		content: ""
	}

	.fa-thumbs-o-up:before {
		content: ""
	}

	.fa-thumbs-o-down:before {
		content: ""
	}

	.fa-star-half:before {
		content: ""
	}

	.fa-heart-o:before {
		content: ""
	}

	.fa-sign-out:before {
		content: ""
	}

	.fa-linkedin-square:before {
		content: ""
	}

	.fa-thumb-tack:before {
		content: ""
	}

	.fa-external-link:before {
		content: ""
	}

	.fa-sign-in:before {
		content: ""
	}

	.fa-trophy:before {
		content: ""
	}

	.fa-github-square:before {
		content: ""
	}

	.fa-upload:before {
		content: ""
	}

	.fa-lemon-o:before {
		content: ""
	}

	.fa-phone:before {
		content: ""
	}

	.fa-square-o:before {
		content: ""
	}

	.fa-bookmark-o:before {
		content: ""
	}

	.fa-phone-square:before {
		content: ""
	}

	.fa-twitter:before {
		content: ""
	}

	.fa-facebook-f:before,.fa-facebook:before {
		content: ""
	}

	.fa-github:before {
		content: ""
	}

	.fa-unlock:before {
		content: ""
	}

	.fa-credit-card:before {
		content: ""
	}

	.fa-feed:before,.fa-rss:before {
		content: ""
	}

	.fa-hdd-o:before {
		content: ""
	}

	.fa-bullhorn:before {
		content: ""
	}

	.fa-bell:before {
		content: ""
	}

	.fa-certificate:before {
		content: ""
	}

	.fa-hand-o-right:before {
		content: ""
	}

	.fa-hand-o-left:before {
		content: ""
	}

	.fa-hand-o-up:before {
		content: ""
	}

	.fa-hand-o-down:before {
		content: ""
	}

	.fa-arrow-circle-left:before {
		content: ""
	}

	.fa-arrow-circle-right:before {
		content: ""
	}

	.fa-arrow-circle-up:before {
		content: ""
	}

	.fa-arrow-circle-down:before {
		content: ""
	}

	.fa-globe:before {
		content: ""
	}

	.fa-wrench:before {
		content: ""
	}

	.fa-tasks:before {
		content: ""
	}

	.fa-filter:before {
		content: ""
	}

	.fa-briefcase:before {
		content: ""
	}

	.fa-arrows-alt:before {
		content: ""
	}

	.fa-group:before,.fa-users:before {
		content: ""
	}

	.fa-chain:before,.fa-link:before {
		content: ""
	}

	.fa-cloud:before {
		content: ""
	}

	.fa-flask:before {
		content: ""
	}

	.fa-cut:before,.fa-scissors:before {
		content: ""
	}

	.fa-copy:before,.fa-files-o:before {
		content: ""
	}

	.fa-paperclip:before {
		content: ""
	}

	.fa-save:before,.fa-floppy-o:before {
		content: ""
	}

	.fa-square:before {
		content: ""
	}

	.fa-navicon:before,.fa-reorder:before,.fa-bars:before {
		content: ""
	}

	.fa-list-ul:before {
		content: ""
	}

	.fa-list-ol:before {
		content: ""
	}

	.fa-strikethrough:before {
		content: ""
	}

	.fa-underline:before {
		content: ""
	}

	.fa-table:before {
		content: ""
	}

	.fa-magic:before {
		content: ""
	}

	.fa-truck:before {
		content: ""
	}

	.fa-pinterest:before {
		content: ""
	}

	.fa-pinterest-square:before {
		content: ""
	}

	.fa-google-plus-square:before {
		content: ""
	}

	.fa-google-plus:before {
		content: ""
	}

	.fa-money:before {
		content: ""
	}

	.fa-caret-down:before {
		content: ""
	}

	.fa-caret-up:before {
		content: ""
	}

	.fa-caret-left:before {
		content: ""
	}

	.fa-caret-right:before {
		content: ""
	}

	.fa-columns:before {
		content: ""
	}

	.fa-unsorted:before,.fa-sort:before {
		content: ""
	}

	.fa-sort-down:before,.fa-sort-desc:before {
		content: ""
	}

	.fa-sort-up:before,.fa-sort-asc:before {
		content: ""
	}

	.fa-envelope:before {
		content: ""
	}

	.fa-linkedin:before {
		content: ""
	}

	.fa-rotate-left:before,.fa-undo:before {
		content: ""
	}

	.fa-legal:before,.fa-gavel:before {
		content: ""
	}

	.fa-dashboard:before,.fa-tachometer:before {
		content: ""
	}

	.fa-comment-o:before {
		content: ""
	}

	.fa-comments-o:before {
		content: ""
	}

	.fa-flash:before,.fa-bolt:before {
		content: ""
	}

	.fa-sitemap:before {
		content: ""
	}

	.fa-umbrella:before {
		content: ""
	}

	.fa-paste:before,.fa-clipboard:before {
		content: ""
	}

	.fa-lightbulb-o:before {
		content: ""
	}

	.fa-exchange:before {
		content: ""
	}

	.fa-cloud-download:before {
		content: ""
	}

	.fa-cloud-upload:before {
		content: ""
	}

	.fa-user-md:before {
		content: ""
	}

	.fa-stethoscope:before {
		content: ""
	}

	.fa-suitcase:before {
		content: ""
	}

	.fa-bell-o:before {
		content: ""
	}

	.fa-coffee:before {
		content: ""
	}

	.fa-cutlery:before {
		content: ""
	}

	.fa-file-text-o:before {
		content: ""
	}

	.fa-building-o:before {
		content: ""
	}

	.fa-hospital-o:before {
		content: ""
	}

	.fa-ambulance:before {
		content: ""
	}

	.fa-medkit:before {
		content: ""
	}

	.fa-fighter-jet:before {
		content: ""
	}

	.fa-beer:before {
		content: ""
	}

	.fa-h-square:before {
		content: ""
	}

	.fa-plus-square:before {
		content: ""
	}

	.fa-angle-double-left:before {
		content: ""
	}

	.fa-angle-double-right:before {
		content: ""
	}

	.fa-angle-double-up:before {
		content: ""
	}

	.fa-angle-double-down:before {
		content: ""
	}

	.fa-angle-left:before {
		content: ""
	}

	.fa-angle-right:before {
		content: ""
	}

	.fa-angle-up:before {
		content: ""
	}

	.fa-angle-down:before {
		content: ""
	}

	.fa-desktop:before {
		content: ""
	}

	.fa-laptop:before {
		content: ""
	}

	.fa-tablet:before {
		content: ""
	}

	.fa-mobile-phone:before,.fa-mobile:before {
		content: ""
	}

	.fa-circle-o:before {
		content: ""
	}

	.fa-quote-left:before {
		content: ""
	}

	.fa-quote-right:before {
		content: ""
	}

	.fa-spinner:before {
		content: ""
	}

	.fa-circle:before {
		content: ""
	}

	.fa-mail-reply:before,.fa-reply:before {
		content: ""
	}

	.fa-github-alt:before {
		content: ""
	}

	.fa-folder-o:before {
		content: ""
	}

	.fa-folder-open-o:before {
		content: ""
	}

	.fa-smile-o:before {
		content: ""
	}

	.fa-frown-o:before {
		content: ""
	}

	.fa-meh-o:before {
		content: ""
	}

	.fa-gamepad:before {
		content: ""
	}

	.fa-keyboard-o:before {
		content: ""
	}

	.fa-flag-o:before {
		content: ""
	}

	.fa-flag-checkered:before {
		content: ""
	}

	.fa-terminal:before {
		content: ""
	}

	.fa-code:before {
		content: ""
	}

	.fa-mail-reply-all:before,.fa-reply-all:before {
		content: ""
	}

	.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before {
		content: ""
	}

	.fa-location-arrow:before {
		content: ""
	}

	.fa-crop:before {
		content: ""
	}

	.fa-code-fork:before {
		content: ""
	}

	.fa-unlink:before,.fa-chain-broken:before {
		content: ""
	}

	.fa-question:before {
		content: ""
	}

	.fa-info:before {
		content: ""
	}

	.fa-exclamation:before {
		content: ""
	}

	.fa-superscript:before {
		content: ""
	}

	.fa-subscript:before {
		content: ""
	}

	.fa-eraser:before {
		content: ""
	}

	.fa-puzzle-piece:before {
		content: ""
	}

	.fa-microphone:before {
		content: ""
	}

	.fa-microphone-slash:before {
		content: ""
	}

	.fa-shield:before {
		content: ""
	}

	.fa-calendar-o:before {
		content: ""
	}

	.fa-fire-extinguisher:before {
		content: ""
	}

	.fa-rocket:before {
		content: ""
	}

	.fa-maxcdn:before {
		content: ""
	}

	.fa-chevron-circle-left:before {
		content: ""
	}

	.fa-chevron-circle-right:before {
		content: ""
	}

	.fa-chevron-circle-up:before {
		content: ""
	}

	.fa-chevron-circle-down:before {
		content: ""
	}

	.fa-html5:before {
		content: ""
	}

	.fa-css3:before {
		content: ""
	}

	.fa-anchor:before {
		content: ""
	}

	.fa-unlock-alt:before {
		content: ""
	}

	.fa-bullseye:before {
		content: ""
	}

	.fa-ellipsis-h:before {
		content: ""
	}

	.fa-ellipsis-v:before {
		content: ""
	}

	.fa-rss-square:before {
		content: ""
	}

	.fa-play-circle:before {
		content: ""
	}

	.fa-ticket:before {
		content: ""
	}

	.fa-minus-square:before {
		content: ""
	}

	.fa-minus-square-o:before {
		content: ""
	}

	.fa-level-up:before {
		content: ""
	}

	.fa-level-down:before {
		content: ""
	}

	.fa-check-square:before {
		content: ""
	}

	.fa-pencil-square:before {
		content: ""
	}

	.fa-external-link-square:before {
		content: ""
	}

	.fa-share-square:before {
		content: ""
	}

	.fa-compass:before {
		content: ""
	}

	.fa-toggle-down:before,.fa-caret-square-o-down:before {
		content: ""
	}

	.fa-toggle-up:before,.fa-caret-square-o-up:before {
		content: ""
	}

	.fa-toggle-right:before,.fa-caret-square-o-right:before {
		content: ""
	}

	.fa-euro:before,.fa-eur:before {
		content: ""
	}

	.fa-gbp:before {
		content: ""
	}

	.fa-dollar:before,.fa-usd:before {
		content: ""
	}

	.fa-rupee:before,.fa-inr:before {
		content: ""
	}

	.fa-cny:before,.fa-rmb:before,.fa-yen:before,.fa-jpy:before {
		content: ""
	}

	.fa-ruble:before,.fa-rouble:before,.fa-rub:before {
		content: ""
	}

	.fa-won:before,.fa-krw:before {
		content: ""
	}

	.fa-bitcoin:before,.fa-btc:before {
		content: ""
	}

	.fa-file:before {
		content: ""
	}

	.fa-file-text:before {
		content: ""
	}

	.fa-sort-alpha-asc:before {
		content: ""
	}

	.fa-sort-alpha-desc:before {
		content: ""
	}

	.fa-sort-amount-asc:before {
		content: ""
	}

	.fa-sort-amount-desc:before {
		content: ""
	}

	.fa-sort-numeric-asc:before {
		content: ""
	}

	.fa-sort-numeric-desc:before {
		content: ""
	}

	.fa-thumbs-up:before {
		content: ""
	}

	.fa-thumbs-down:before {
		content: ""
	}

	.fa-youtube-square:before {
		content: ""
	}

	.fa-youtube:before {
		content: ""
	}

	.fa-xing:before {
		content: ""
	}

	.fa-xing-square:before {
		content: ""
	}

	.fa-youtube-play:before {
		content: ""
	}

	.fa-dropbox:before {
		content: ""
	}

	.fa-stack-overflow:before {
		content: ""
	}

	.fa-instagram:before {
		content: ""
	}

	.fa-flickr:before {
		content: ""
	}

	.fa-adn:before {
		content: ""
	}

	.fa-bitbucket:before {
		content: ""
	}

	.fa-bitbucket-square:before {
		content: ""
	}

	.fa-tumblr:before {
		content: ""
	}

	.fa-tumblr-square:before {
		content: ""
	}

	.fa-long-arrow-down:before {
		content: ""
	}

	.fa-long-arrow-up:before {
		content: ""
	}

	.fa-long-arrow-left:before {
		content: ""
	}

	.fa-long-arrow-right:before {
		content: ""
	}

	.fa-apple:before {
		content: ""
	}

	.fa-windows:before {
		content: ""
	}

	.fa-android:before {
		content: ""
	}

	.fa-linux:before {
		content: ""
	}

	.fa-dribbble:before {
		content: ""
	}

	.fa-skype:before {
		content: ""
	}

	.fa-foursquare:before {
		content: ""
	}

	.fa-trello:before {
		content: ""
	}

	.fa-female:before {
		content: ""
	}

	.fa-male:before {
		content: ""
	}

	.fa-gittip:before,.fa-gratipay:before {
		content: ""
	}

	.fa-sun-o:before {
		content: ""
	}

	.fa-moon-o:before {
		content: ""
	}

	.fa-archive:before {
		content: ""
	}

	.fa-bug:before {
		content: ""
	}

	.fa-vk:before {
		content: ""
	}

	.fa-weibo:before {
		content: ""
	}

	.fa-renren:before {
		content: ""
	}

	.fa-pagelines:before {
		content: ""
	}

	.fa-stack-exchange:before {
		content: ""
	}

	.fa-arrow-circle-o-right:before {
		content: ""
	}

	.fa-arrow-circle-o-left:before {
		content: ""
	}

	.fa-toggle-left:before,.fa-caret-square-o-left:before {
		content: ""
	}

	.fa-dot-circle-o:before {
		content: ""
	}

	.fa-wheelchair:before {
		content: ""
	}

	.fa-vimeo-square:before {
		content: ""
	}

	.fa-turkish-lira:before,.fa-try:before {
		content: ""
	}

	.fa-plus-square-o:before {
		content: ""
	}

	.fa-space-shuttle:before {
		content: ""
	}

	.fa-slack:before {
		content: ""
	}

	.fa-envelope-square:before {
		content: ""
	}

	.fa-wordpress:before {
		content: ""
	}

	.fa-openid:before {
		content: ""
	}

	.fa-institution:before,.fa-bank:before,.fa-university:before {
		content: ""
	}

	.fa-mortar-board:before,.fa-graduation-cap:before {
		content: ""
	}

	.fa-yahoo:before {
		content: ""
	}

	.fa-google:before {
		content: ""
	}

	.fa-reddit:before {
		content: ""
	}

	.fa-reddit-square:before {
		content: ""
	}

	.fa-stumbleupon-circle:before {
		content: ""
	}

	.fa-stumbleupon:before {
		content: ""
	}

	.fa-delicious:before {
		content: ""
	}

	.fa-digg:before {
		content: ""
	}

	.fa-pied-piper:before {
		content: ""
	}

	.fa-pied-piper-alt:before {
		content: ""
	}

	.fa-drupal:before {
		content: ""
	}

	.fa-joomla:before {
		content: ""
	}

	.fa-language:before {
		content: ""
	}

	.fa-fax:before {
		content: ""
	}

	.fa-building:before {
		content: ""
	}

	.fa-child:before {
		content: ""
	}

	.fa-paw:before {
		content: ""
	}

	.fa-spoon:before {
		content: ""
	}

	.fa-cube:before {
		content: ""
	}

	.fa-cubes:before {
		content: ""
	}

	.fa-behance:before {
		content: ""
	}

	.fa-behance-square:before {
		content: ""
	}

	.fa-steam:before {
		content: ""
	}

	.fa-steam-square:before {
		content: ""
	}

	.fa-recycle:before {
		content: ""
	}

	.fa-automobile:before,.fa-car:before {
		content: ""
	}

	.fa-cab:before,.fa-taxi:before {
		content: ""
	}

	.fa-tree:before {
		content: ""
	}

	.fa-spotify:before {
		content: ""
	}

	.fa-deviantart:before {
		content: ""
	}

	.fa-soundcloud:before {
		content: ""
	}

	.fa-database:before {
		content: ""
	}

	.fa-file-pdf-o:before {
		content: ""
	}

	.fa-file-word-o:before {
		content: ""
	}

	.fa-file-excel-o:before {
		content: ""
	}

	.fa-file-powerpoint-o:before {
		content: ""
	}

	.fa-file-photo-o:before,.fa-file-picture-o:before,.fa-file-image-o:before {
		content: ""
	}

	.fa-file-zip-o:before,.fa-file-archive-o:before {
		content: ""
	}

	.fa-file-sound-o:before,.fa-file-audio-o:before {
		content: ""
	}

	.fa-file-movie-o:before,.fa-file-video-o:before {
		content: ""
	}

	.fa-file-code-o:before {
		content: ""
	}

	.fa-vine:before {
		content: ""
	}

	.fa-codepen:before {
		content: ""
	}

	.fa-jsfiddle:before {
		content: ""
	}

	.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-saver:before,.fa-support:before,.fa-life-ring:before {
		content: ""
	}

	.fa-circle-o-notch:before {
		content: ""
	}

	.fa-ra:before,.fa-rebel:before {
		content: ""
	}

	.fa-ge:before,.fa-empire:before {
		content: ""
	}

	.fa-git-square:before {
		content: ""
	}

	.fa-git:before {
		content: ""
	}

	.fa-y-combinator-square:before,.fa-yc-square:before,.fa-hacker-news:before {
		content: ""
	}

	.fa-tencent-weibo:before {
		content: ""
	}

	.fa-qq:before {
		content: ""
	}

	.fa-wechat:before,.fa-weixin:before {
		content: ""
	}

	.fa-send:before,.fa-paper-plane:before {
		content: ""
	}

	.fa-send-o:before,.fa-paper-plane-o:before {
		content: ""
	}

	.fa-history:before {
		content: ""
	}

	.fa-circle-thin:before {
		content: ""
	}

	.fa-header:before {
		content: ""
	}

	.fa-paragraph:before {
		content: ""
	}

	.fa-sliders:before {
		content: ""
	}

	.fa-share-alt:before {
		content: ""
	}

	.fa-share-alt-square:before {
		content: ""
	}

	.fa-bomb:before {
		content: ""
	}

	.fa-soccer-ball-o:before,.fa-futbol-o:before {
		content: ""
	}

	.fa-tty:before {
		content: ""
	}

	.fa-binoculars:before {
		content: ""
	}

	.fa-plug:before {
		content: ""
	}

	.fa-slideshare:before {
		content: ""
	}

	.fa-twitch:before {
		content: ""
	}

	.fa-yelp:before {
		content: ""
	}

	.fa-newspaper-o:before {
		content: ""
	}

	.fa-wifi:before {
		content: ""
	}

	.fa-calculator:before {
		content: ""
	}

	.fa-paypal:before {
		content: ""
	}

	.fa-google-wallet:before {
		content: ""
	}

	.fa-cc-visa:before {
		content: ""
	}

	.fa-cc-mastercard:before {
		content: ""
	}

	.fa-cc-discover:before {
		content: ""
	}

	.fa-cc-amex:before {
		content: ""
	}

	.fa-cc-paypal:before {
		content: ""
	}

	.fa-cc-stripe:before {
		content: ""
	}

	.fa-bell-slash:before {
		content: ""
	}

	.fa-bell-slash-o:before {
		content: ""
	}

	.fa-trash:before {
		content: ""
	}

	.fa-copyright:before {
		content: ""
	}

	.fa-at:before {
		content: ""
	}

	.fa-eyedropper:before {
		content: ""
	}

	.fa-paint-brush:before {
		content: ""
	}

	.fa-birthday-cake:before {
		content: ""
	}

	.fa-area-chart:before {
		content: ""
	}

	.fa-pie-chart:before {
		content: ""
	}

	.fa-line-chart:before {
		content: ""
	}

	.fa-lastfm:before {
		content: ""
	}

	.fa-lastfm-square:before {
		content: ""
	}

	.fa-toggle-off:before {
		content: ""
	}

	.fa-toggle-on:before {
		content: ""
	}

	.fa-bicycle:before {
		content: ""
	}

	.fa-bus:before {
		content: ""
	}

	.fa-ioxhost:before {
		content: ""
	}

	.fa-angellist:before {
		content: ""
	}

	.fa-cc:before {
		content: ""
	}

	.fa-shekel:before,.fa-sheqel:before,.fa-ils:before {
		content: ""
	}

	.fa-meanpath:before {
		content: ""
	}

	.fa-buysellads:before {
		content: ""
	}

	.fa-connectdevelop:before {
		content: ""
	}

	.fa-dashcube:before {
		content: ""
	}

	.fa-forumbee:before {
		content: ""
	}

	.fa-leanpub:before {
		content: ""
	}

	.fa-sellsy:before {
		content: ""
	}

	.fa-shirtsinbulk:before {
		content: ""
	}

	.fa-simplybuilt:before {
		content: ""
	}

	.fa-skyatlas:before {
		content: ""
	}

	.fa-cart-plus:before {
		content: ""
	}

	.fa-cart-arrow-down:before {
		content: ""
	}

	.fa-diamond:before {
		content: ""
	}

	.fa-ship:before {
		content: ""
	}

	.fa-user-secret:before {
		content: ""
	}

	.fa-motorcycle:before {
		content: ""
	}

	.fa-street-view:before {
		content: ""
	}

	.fa-heartbeat:before {
		content: ""
	}

	.fa-venus:before {
		content: ""
	}

	.fa-mars:before {
		content: ""
	}

	.fa-mercury:before {
		content: ""
	}

	.fa-intersex:before,.fa-transgender:before {
		content: ""
	}

	.fa-transgender-alt:before {
		content: ""
	}

	.fa-venus-double:before {
		content: ""
	}

	.fa-mars-double:before {
		content: ""
	}

	.fa-venus-mars:before {
		content: ""
	}

	.fa-mars-stroke:before {
		content: ""
	}

	.fa-mars-stroke-v:before {
		content: ""
	}

	.fa-mars-stroke-h:before {
		content: ""
	}

	.fa-neuter:before {
		content: ""
	}

	.fa-genderless:before {
		content: ""
	}

	.fa-facebook-official:before {
		content: ""
	}

	.fa-pinterest-p:before {
		content: ""
	}

	.fa-whatsapp:before {
		content: ""
	}

	.fa-server:before {
		content: ""
	}

	.fa-user-plus:before {
		content: ""
	}

	.fa-user-times:before {
		content: ""
	}

	.fa-hotel:before,.fa-bed:before {
		content: ""
	}

	.fa-viacoin:before {
		content: ""
	}

	.fa-train:before {
		content: ""
	}

	.fa-subway:before {
		content: ""
	}

	.fa-medium:before {
		content: ""
	}

	.fa-yc:before,.fa-y-combinator:before {
		content: ""
	}

	.fa-optin-monster:before {
		content: ""
	}

	.fa-opencart:before {
		content: ""
	}

	.fa-expeditedssl:before {
		content: ""
	}

	.fa-battery-4:before,.fa-battery-full:before {
		content: ""
	}

	.fa-battery-3:before,.fa-battery-three-quarters:before {
		content: ""
	}

	.fa-battery-2:before,.fa-battery-half:before {
		content: ""
	}

	.fa-battery-1:before,.fa-battery-quarter:before {
		content: ""
	}

	.fa-battery-0:before,.fa-battery-empty:before {
		content: ""
	}

	.fa-mouse-pointer:before {
		content: ""
	}

	.fa-i-cursor:before {
		content: ""
	}

	.fa-object-group:before {
		content: ""
	}

	.fa-object-ungroup:before {
		content: ""
	}

	.fa-sticky-note:before {
		content: ""
	}

	.fa-sticky-note-o:before {
		content: ""
	}

	.fa-cc-jcb:before {
		content: ""
	}

	.fa-cc-diners-club:before {
		content: ""
	}

	.fa-clone:before {
		content: ""
	}

	.fa-balance-scale:before {
		content: ""
	}

	.fa-hourglass-o:before {
		content: ""
	}

	.fa-hourglass-1:before,.fa-hourglass-start:before {
		content: ""
	}

	.fa-hourglass-2:before,.fa-hourglass-half:before {
		content: ""
	}

	.fa-hourglass-3:before,.fa-hourglass-end:before {
		content: ""
	}

	.fa-hourglass:before {
		content: ""
	}

	.fa-hand-grab-o:before,.fa-hand-rock-o:before {
		content: ""
	}

	.fa-hand-stop-o:before,.fa-hand-paper-o:before {
		content: ""
	}

	.fa-hand-scissors-o:before {
		content: ""
	}

	.fa-hand-lizard-o:before {
		content: ""
	}

	.fa-hand-spock-o:before {
		content: ""
	}

	.fa-hand-pointer-o:before {
		content: ""
	}

	.fa-hand-peace-o:before {
		content: ""
	}

	.fa-trademark:before {
		content: ""
	}

	.fa-registered:before {
		content: ""
	}

	.fa-creative-commons:before {
		content: ""
	}

	.fa-gg:before {
		content: ""
	}

	.fa-gg-circle:before {
		content: ""
	}

	.fa-tripadvisor:before {
		content: ""
	}

	.fa-odnoklassniki:before {
		content: ""
	}

	.fa-odnoklassniki-square:before {
		content: ""
	}

	.fa-get-pocket:before {
		content: ""
	}

	.fa-wikipedia-w:before {
		content: ""
	}

	.fa-safari:before {
		content: ""
	}

	.fa-chrome:before {
		content: ""
	}

	.fa-firefox:before {
		content: ""
	}

	.fa-opera:before {
		content: ""
	}

	.fa-internet-explorer:before {
		content: ""
	}

	.fa-tv:before,.fa-television:before {
		content: ""
	}

	.fa-contao:before {
		content: ""
	}

	.fa-500px:before {
		content: ""
	}

	.fa-amazon:before {
		content: ""
	}

	.fa-calendar-plus-o:before {
		content: ""
	}

	.fa-calendar-minus-o:before {
		content: ""
	}

	.fa-calendar-times-o:before {
		content: ""
	}

	.fa-calendar-check-o:before {
		content: ""
	}

	.fa-industry:before {
		content: ""
	}

	.fa-map-pin:before {
		content: ""
	}

	.fa-map-signs:before {
		content: ""
	}

	.fa-map-o:before {
		content: ""
	}

	.fa-map:before {
		content: ""
	}

	.fa-commenting:before {
		content: ""
	}

	.fa-commenting-o:before {
		content: ""
	}

	.fa-houzz:before {
		content: ""
	}

	.fa-vimeo:before {
		content: ""
	}

	.fa-black-tie:before {
		content: ""
	}

	.fa-fonticons:before {
		content: ""
	}

	.fa-reddit-alien:before {
		content: ""
	}

	.fa-edge:before {
		content: ""
	}

	.fa-credit-card-alt:before {
		content: ""
	}

	.fa-codiepie:before {
		content: ""
	}

	.fa-modx:before {
		content: ""
	}

	.fa-fort-awesome:before {
		content: ""
	}

	.fa-usb:before {
		content: ""
	}

	.fa-product-hunt:before {
		content: ""
	}

	.fa-mixcloud:before {
		content: ""
	}

	.fa-scribd:before {
		content: ""
	}

	.fa-pause-circle:before {
		content: ""
	}

	.fa-pause-circle-o:before {
		content: ""
	}

	.fa-stop-circle:before {
		content: ""
	}

	.fa-stop-circle-o:before {
		content: ""
	}

	.fa-shopping-bag:before {
		content: ""
	}

	.fa-shopping-basket:before {
		content: ""
	}

	.fa-hashtag:before {
		content: ""
	}

	.fa-bluetooth:before {
		content: ""
	}

	.fa-bluetooth-b:before {
		content: ""
	}

	.fa-percent:before {
		content: ""
	}

	body {
		font-size: 14px;
		font-family: "Segoe UI",Helvetica,Arial,sans-serif;
		line-height: 130%
	}

	@media screen and (min-width: 769px) {
		h1 {
			font-size:24px
		}

		h2 {
			font-size: 20px
		}

		h3 {
			font-size: 18px
		}
	}

	@media screen and (max-width: 768px) {
		h1 {
			font-size:20px
		}

		h2 {
			font-size: 18px
		}

		h3 {
			font-size: 16px
		}
	}

	a,a:hover,a:visited,a:focus {
		color: #292929
	}

	input:-webkit-autofill {
		-webkit-box-shadow: 0 0 0 1000px #fff inset
	}

	.btn:active,.btn.active {
		-webkit-box-shadow: none;
		box-shadow: none
	}

	.btn:focus,.btn:active:focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn.active.focus {
		outline: none;
		outline-offset: 0
	}

	hr {
		margin-top: 0!important
	}

	.color-white {
		color: #fff!important
	}

	.small-text {
		font-size: .8em
	}

	.help-left {
		left: 25px!important
	}

	.left {
		margin-left: 20px
	}

	.right {
		margin-right: 25px!important
	}

	.mb-20 {
		margin-bottom: 20px!important
	}

	.mb-25 {
		margin-bottom: 25px!important
	}

	.mt-0 {
		margin-top: 0!important
	}

	.mt-15 {
		margin-top: 15px!important
	}

	.mt-20 {
		margin-top: 20px!important
	}

	.mt-30 {
		margin-top: 30px!important
	}

	@media screen and (min-width: 992px) {
		.mt-lg-0 {
			margin-top:0
		}

		.mt-lg-15 {
			margin-top: 15px!important
		}

		.mt-lg-20 {
			margin-top: 20px!important
		}

		.mt-lg-30 {
			margin-top: 30px!important
		}

		.mb-lg-20 {
			margin-bottom: 20px!important
		}

		.mb-lg-25 {
			margin-bottom: 25px!important
		}
	}

	.card-img-top {
		border-top-left-radius: calc(.25rem - 1px);
		border-top-right-radius: calc(.25rem - 1px)
	}

	.modal-dialog {
		left: 0;
		right: 0;
		top: 35%
	}

	.container-mb-15 {
		margin-bottom: 150px
	}

	.divAttachment input[type="file"] {
		margin: 8px 0
	}

	.btn {
		border-radius: 0;
		-webkit-border-radius: 0;
		-moz-border-radius: 0;
		padding: 8px 20px
	}

	.btn-loadmore {
		background-color: #000!important;
		border: none
	}

	.btn-loadmore:hover {
		background-color: #000!important;
		border: none
	}

	.btn-lg,.btn-group-lg>.btn {
		padding: 20px 0;
		font-size: 18px;
		line-height: 100%;
		border-radius: 0;
		min-width: 280px;
		font-weight: 500
	}

	.btn-success {
		float: left;
		clear: both;
		margin-top: 10px
	}

	.bg-login {
		background-attachment: fixed;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: top left;
		background-image: url(../assets/images/background/bgr-login.jpg)
	}

	.bg-home {
		background-attachment: fixed;
		background-size: cover;
		background-repeat: no-repeat;
		background-position: top left;
		background-image: none
	}

	#WaitDiv {
		overflow: hidden;
		display: none;
		height: 60px!important
	}

	.container {
		min-height: calc(100% - 100px);
		min-height: -moz-calc(100% - 100px);
		min-height: -webkit-calc(100% - 100px)
	}

	.navbar-inverse {
		background-color: transparent;
		border-color: transparent
	}

	#top {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		width: 100%;
		height: 60px
	}

	.loader {
		border: 10px solid #f3f3f3;
		border-top: 10px solid #010602;
		border-radius: 50%;
		width: 70px;
		height: 70px;
		animation: spin 2s linear infinite
	}

	#loginform {
		width: 100%
	}

	.logo {
		margin: 0 auto;
		display: table;
		max-width: 100px;
		max-height: 50px
	}

	.logo img {
		max-height: 100%;
		margin-top: 5px;
		max-width: 100%
	}

	#page-content-wrapper {
		min-height: 800px
	}

	.copyright {
		background: #000;
		padding: 15px 0;
		color: #fff
	}

	.pagination {
		display: block;
		margin: 20px 0 40px
	}

	.pagination a {
		float: none;
		padding: 8px 20px;
		text-decoration: none;
		margin-left: 0
	}

	.btnNavigaton i.fa {
		vertical-align: middle;
		font-size: 20px;
		line-height: 100%
	}

	.loadercenter {
		text-align: -webkit-center
	}

	.panel-loginform {
		width: 90%;
		max-width: 400px;
		margin: 1em auto
	}

	.login-page img.header-logo {
		max-width: 300px;
		max-height: 60px
	}

	.login-page {
		padding-top: 3em;
		height: 100vh;
		font-family: "Segoe UI",Helvetica,Arial,sans-serif;
	}

	.login-page .footer {
		position: fixed;
		right: 0;
		bottom: 0;
		left: 0;
		padding: 1rem;
		text-align: center
	}

	.login-page .footer img {
		max-width: 100px;
		margin: 0 auto
	}

	.panel-loginform .log-sec {
		padding: 2em
	}

	.log-sec label,.login-page .log-sec a {
		font-size: 12px;
		font-weight: normal
	}

	.login-page .log-sec a {
		text-decoration: underline
	}

	.log-sec .field-validation-error {
		padding: 5px 0;
		font-size: .9em;
		display: block
	}

	.login-page .panel {
		border: none
	}

	.login-page .form-group {
		margin-left: 0;
		margin-right: 0
	}

	.login-page .form-control {
		border: none;
		box-shadow: none
	}

	.log-sec .btn {
		width: 100%;
		padding: 1em .5em;
		cursor: pointer
	}

	.log-sec .validation-summary-errors ul {
		list-style: none;
		text-align: center;
		padding: 0;
		font-weight: 500
	}

	.home-page #Noticias-home {
		margin: 0 auto 32px
	}

	.home-page #Noticias-home h2 {
		text-align: center;
		border-bottom: 2px solid #000;
		padding-bottom: 1rem
	}

	.home-page h1,.home-page ul.menu-circles {
		padding-left: 0!important
	}

	.home-page ul.menu-circles {
		margin: 20px auto 20px
	}

	.home-page ul.menu-circles li {
		list-style: none;
		float: left;
		margin-bottom: 10px
	}

	.home-page ul.menu-circles li>div.circle {
		font-size: 1em;
		line-height: 100%;
		text-align: center;
		display: block;
		margin-left: auto;
		margin-right: auto;
		-moz-transform: scale(1,1);
		-webkit-transform: scale(1,1);
		-o-transform: scale(1,1);
		-ms-transform: scale(1,1);
		transform: scale(1,1);
		-webkit-transition: all 150ms ease;
		-moz-transition: all 150ms ease;
		-ms-transition: all 150ms ease;
		-o-transition: all 150ms ease;
		transition: all 150ms ease;
		position: relative;
		border-radius: 0;
		-moz-border-radius: 0;
		-webkit-border-radius: 0
	}

	.home-page ul.menu-circles li a {
		display: block;
		height: 100%;
		opacity: 1;
		font-style: normal;
		text-align: center;
		padding-top: 0;
		font-weight: 400;
		line-height: 100%;
		width: 100%
	}

	.home-page ul.menu-circles li a em,.home-page ul.menu-circles li a i {
		position: absolute;
		font-style: normal;
		font-size: 12px;
		left: 0;
		width: 100%;
		bottom: 8px;
		line-height: 120%;
		padding: 0 8px;
		text-transform: uppercase;
		text-align: left;
		margin-bottom: 0
	}

	.home-page ul.menu-circles li a img {
		margin: 0 auto;
		position: absolute;
		top: 50%;
		left: 50%
	}

	.home-page .header-clear {
		height: 60px
	}

	.daynum {
		position: absolute;
		width: 30px;
		height: 30px;
		overflow: hidden;
		line-height: 30px;
		right: 8px;
		top: 8px
	}

	.daynum span {
		display: block;
		border-radius: 50%;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		height: 30px;
		line-height: 26px
	}

	.countbadge {
		left: 8px;
		top: 8px
	}

	.btn-circle {
		width: 30px;
		height: 30px;
		text-align: center;
		font-size: 12px;
		line-height: 30px;
		border-radius: 50%;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		margin-top: 0;
		margin-left: 0
	}

	.btn-circle.btn-lg {
		width: 50px;
		height: 50px;
		padding: 0;
		font-size: 18px;
		line-height: 50px;
		border-radius: 50%;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%
	}

	.home-page ul.menu-circles::after {
		content: " ";
		height: 0;
		clear: both;
		display: block
	}

	@media(min-width: 480px) {
	}

	@media(min-width: 769px) {
		.home-page ul.menu-circles {
			width:720px
		}

		.home-page #Noticias-home {
			width: 710px
		}

		.home-page ul.menu-circles {
			margin-top: 40px
		}

		.home-page ul.menu-circles li {
			width: 25%
		}

		.home-page ul.menu-circles li>div.circle {
			width: 170px;
			height: 170px
		}

		.home-page ul.menu-circles li a img {
			height: 76.5px;
			width: 76.5px;
			margin-top: -48.25px;
			margin-left: -38.25px
		}

		.home-page ul.menu-circles li>div.circle:hover {
			-moz-transform: scale(1.1,1.1);
			-webkit-transform: scale(1.1,1.1);
			-o-transform: scale(1.1,1.1);
			-ms-transform: scale(1.1,1.1);
			transform: scale(1.1,1.1);
			-webkit-transition: all 150ms ease;
			-moz-transition: all 150ms ease;
			-ms-transition: all 150ms ease;
			-o-transition: all 150ms ease;
			transition: all 150ms ease
		}
	}

	@media(min-width: 400px)and (max-width:768px) {
		.home-page ul.menu-circles li {
			width:33.3%
		}
	}

	@media(min-width: 498px)and (max-width:768px) {
		.home-page ul.menu-circles {
			width:468px
		}

		.home-page #Noticias-home {
			width: 448px
		}

		.home-page ul.menu-circles li>div.circle {
			width: 140px;
			height: 140px
		}

		.home-page ul.menu-circles li a img {
			height: 56px;
			width: 56px;
			margin-top: -38px;
			margin-left: -31.5px
		}
	}

	@media(min-width: 430px)and (max-width:497px) {
		.home-page ul.menu-circles {
			width:400px
		}

		.home-page #Noticias-home {
			width: 400px
		}

		.home-page ul.menu-circles li>div.circle {
			width: 120px;
			height: 120px
		}

		.home-page ul.menu-circles li a img {
			height: 40px;
			width: 40px;
			margin-top: -30px;
			margin-left: -20px
		}

		.home-page ul.menu-circles li a em,.home-page ul.menu-circles li a i {
			font-size: 12px
		}
	}

	@media(max-width: 429px) {
		.home-page ul.menu-circles {
			width:280px
		}

		.home-page #Noticias-home {
			width: 280px
		}

		.home-page ul.menu-circles li {
			width: 50%
		}

		.home-page ul.menu-circles li>div.circle {
			border-radius: 0;
			height: 130px;
			width: 130px
		}

		.home-page ul.menu-circles li a img {
			height: 40px;
			width: 40px;
			margin-top: -30px;
			margin-left: -20px
		}
	}

	@media(max-width: 350px) {
	}

	#terms-condition {
		background: #fff;
		padding: 1em 0;
		margin: 2em 0 150px;
		font-size: 15px;
		line-height: 140%
	}

	#terms-condition>div {
		width: 90%;
		margin-left: auto;
		margin-right: auto
	}

	#terms-condition>div.header-tac {
		margin-bottom: 2em
	}

	#terms-condition h2 {
		color: #494949;
		border-bottom: 1px dashed #555;
		padding-bottom: 8px;
		margin-bottom: 12px
	}

	#divTopNews img {
		max-width: 100%
	}

	.news-list img {
		max-width: 100%
	}

	.news-list>div {
		margin: 20px 0 0
	}

	.news-list>div:not(:first-child) {
		border-top: 1px solid #e5e5e5;
		padding-top: 20px
	}

	p.readmore {
		margin: 24px 0 20px
	}

	.news-list .readmore>a {
		display: inline-block;
		border-bottom: 1px solid
	}

	.waitMsg {
		text-align: center;
		font-weight: bold
	}

	.preloader.clear-both {
		text-align: center;
		margin: 20px auto 8px
	}

	.preloader img {
		display: inline-block
	}

	.NotFound {
		font-weight: 500;
		font-size: 1.2em
	}

	#divMessage.alert {
		font-weight: bold
	}

	.form-check-input {
		position: absolute;
		margin-top: .3rem!important;
		margin-left: -1.25rem!important
	}

	.form-check {
		position: relative;
		display: block;
		padding-left: 1.25rem
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg)
		}

		100% {
			transform: rotate(360deg)
		}
	}

	@media screen and (min-width: 769px) {
		.modal-lg {
			width:900px
		}

		.modal-sm {
			width: 300px
		}
	}

	@media(max-width: 768px) {
		.table-responsive>.table {
			margin-bottom:0;
			background-color: transparent!important
		}

		.icon-respon img {
			width: 50px
		}

		.btn-lg,.btn-group-lg>.btn {
			width: 100%;
			min-width: 0
		}

		.form-group>.col-xs-12,.form-group>.col-sm-6 {
			margin-bottom: 15px
		}

		.form-group>.col-xs-12:last-child {
			margin-bottom: 0
		}
	}

	#itemList table thead tr th {
		text-align: center
	}

	#itemList tbody tr td:last-child a {
		display: inline-block!important;
		border-radius: 50%;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		width: 32px;
		height: 32px;
		line-height: 32px;
		margin: 3px
	}

	#itemList hr {
		background-color: transparent
	}

	#itemList .table>tbody>tr>td {
		vertical-align: middle;
		min-height: 32px
	}

	#itemList .itemList-controls .controls-left {
		position: absolute;
		left: 0;
		top: 0
	}

	#itemList .itemList-controls .controls-right {
		position: absolute;
		right: 0;
		top: 0
	}

	#itemList .itemList-controls {
		height: 40px
	}

	#itemList .itemList-controls .btn {
		line-height: 40px;
		padding: 0;
		margin: 0
	}

	#itemList .itemList-controls .btn i.fa {
		line-height: 100%;
		display: inline-block
	}

	#itemList .itemList-controls .title {
		margin: auto;
		text-align: center;
		max-width: 33%
	}

	#itemList .itemList-controls .title h3,#itemList .itemList-controls .title h2,#itemList .itemList-controls .title h1 {
		margin: 0
	}

	#itemList .itemList-controls .title,#itemList .itemList-controls .title>* {
		line-height: 40px
	}

	.itemList-header h1 {
		margin: 0 0 8px;
		padding: 12px 8px
	}

	@media screen and (min-width: 769px) {
		#itemList .table>tbody>tr>td {
			padding:8px 3px
		}
	}

	@media(max-width: 768px) {
		#no-more-tables table,#no-more-tables thead,#no-more-tables tbody,#no-more-tables th,#no-more-tables td,#no-more-tables tr {
			display:block
		}

		#no-more-tables thead tr {
			position: absolute;
			top: -9999px;
			left: -9999px
		}

		#no-more-tables tbody>tr {
			border-bottom: 1px solid #000
		}

		#no-more-tables td {
			border: none;
			border-bottom: 1px solid #eee;
			position: relative;
			padding-left: 50%;
			white-space: normal;
			text-align: left
		}

		#no-more-tables td:before {
			position: absolute;
			top: 6px;
			left: 4px;
			width: 45%;
			padding-right: 5px;
			white-space: nowrap;
			text-align: left;
			font-weight: 600;
			font-size: 11px;
			content: attr(data-title)
		}

		#no-more-tables td.colAction {
			padding-left: 0;
			padding-right: 0;
			text-align: center
		}

		#no-more-tables td.colAction:before {
			display: none
		}

		#itemList .itemList-controls {
			position: absolute;
			width: 100%;
			z-index: 100
		}

		#itemList .itemList-controls .controls-right,#itemList .itemList-controls .controls-left {
			position: relative
		}

		#itemList .itemList-controls .title {
			display: none
		}

		#itemList .itemList-header {
			padding-top: 40px
		}

		#itemList .itemList-controls .btn {
			width: 100%
		}

		.itemList-header h1 {
			text-align: center
		}

		#itemList tbody tr td:last-child a {
			width: 40px;
			height: 40px;
			line-height: 40px;
			margin: 3px 8px
		}
	}

	.f-iconfolder i {
		font-size: 75px;
		color: #ffa500
	}

	.f-iconfile i {
		font-size: 70px;
		color: #fff
	}

	.thumbnail,.img-thumbnail {
		background-color: transparent
	}

	.container-folderlist ul.folder-brows {
		display: table;
		list-style: none;
		padding: 0
	}

	.container-folderlist ul.folder-brows li {
		display: inline-block;
		padding: 4px 0
	}

	.container-folderlist ul.folder-brows li>a {
		display: inline-block
	}
	/*
	.container-folderlist ul.folder-brows li:first-child:before {
		content: "";
		font-size: 18px;
		display: inline-block;
		font-family: 'FontAwesome';
		margin-right: 8px
	}
	*/
	.container-folderlist ul.folder-brows li:after {
		display: inline-block;
		content: "/";
		margin: 0 5px
	}

	.container-folderlist ul.folder-brows li:last-child:after {
		display: none
	}

	.documentList-content {
		margin-top: 2em
	}

	.documentList-content .thumbnail img {
		max-height: 100px;
		max-width: 100px;
		margin: 0 auto;
		padding-top: 0
	}

	.documentList-content .thumbnail {
		text-align: center;
		padding: 30px 0 10px;
		border: none
	}

	.documentList-content a {
		text-decoration: none!important
	}

	.documentList-content .thumbnail .caption {
		padding: 0;
		margin: 12px auto 0;
		width: 90%;
		overflow: hidden
	}

	.documentList-content .thumbnail .caption p {
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		width: 100%
	}

	.documentList-item {
		padding: .8em;
		border-bottom: 1px solid #e5e5e5
	}

	.documentList-item .document-date {
		padding-left: 18px;
		font-size: 12px;
		margin-bottom: 0
	}

	.kbw-signature {
		max-width: 100%
	}

	.kbw-signature canvas {
		max-width: 100%;
		height: 100%
	}

	@media(max-width: 768px) {
		.documentList-item .document-date {
			padding-left:0
		}

		.documentList-item a {
			display: block;
			width: 100%;
			max-width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap
		}

		.documentList-item .btn {
			margin-top: 1em
		}
	}

	.fileattached {
		border: 1px dashed #ccc;
		padding: 0;
		width: 100%
	}

	.fileattached>a {
		display: block;
		width: calc(100% - 42px);
		height: 32px;
		padding: 0 5px;
		line-height: 32px
	}

	.fileattached>button {
		padding: 0;
		width: 32px;
		height: 32px;
		position: absolute;
		right: 0;
		top: 0;
		background: none;
		font-size: 18px;
		color: #d00;
		border: 0
	}

	.bg-primary-color,.btn-primary {
		background-color: #e63331;
		border-color: #e63331;
		border-radius: 0
	}

	.btn-primary:hover {
		background: #292929
	}

	.btn-primary {
		color: #fff
	}

	.primary-color {
		color: #e63331
	}

	#WaitDiv {
		background: transparent!important
	}

	.waitmsg {
		color: #148fb0
	}

	.active {
		color: #fff!important;
		border: none!important;
		background-color: #e63331!important
	}

	h .breadcrumb1 a {
		color: #000
	}

	.hiddenDiv {
		display: none
	}

	.back-to-top-badge {
		border-radius: 0;
		font-size: 14px;
		width: 100%;
		height: 40px;
		background: #e63331;
		color: #fff;
		line-height: 40px
	}

	.back-to-top-badge i {
		line-height: 40px;
		width: 20px
	}

	.back-to-top-badge:hover {
		color: #fff;
		background: #000
	}

	.login-page .footer {
		background-color: #efefef
	}

	.login-page .footer-dark {
		background-color: #212429;
		color: #fff
	}

	.log-sec .field-validation-error {
		color: #d00
	}

	.login-page .panel {
		background: rgba(255,255,255,.92);
		border: none
	}

	.login-page .admin .panel {
		background-color: #fff;
		border: 1px solid #000
	}

	.login-page .input-group-addon {
		background-color: #e5e5e5;
		border: none;
		border-radius: 0
	}

	.login-page .form-control {
		background: transparent;
		border-bottom: 1px solid #ccc;
		border-radius: 0;
		color: #000
	}

	.login-page .form-control::-webkit-input-placeholder,.login-page .form-control::-moz-placeholder,.login-page .form-control:-ms-input-placeholder,.login-page .form-control:-moz-placeholder {
		color: #000
	}

	.log-sec .btn {
		border-radius: 0;
		background: #e63331;
		border: none;
		color: #fff;
		text-transform: uppercase
	}

	.log-sec .btn:hover {
		background: #000
	}

	.header-home {
		color: #000
	}

	.daynum span {
		background: #009765;
		color: #fff;
		border: 2px solid #fff
	}

	.home-page ul.menu-circles li a {
		color: #fff
	}

	.home-page ul.menu-circles li>div.circle {
		background-color: #000
	}

	.home-page ul.menu-circles li>div.circle:hover {
		background: #000!important
	}

	.btn-circle {
		background: #d00;
		border-color: #d00;
		color: #fff
	}

	.btn-circle:hover {
		background: #d00;
		border-color: #d00;
		color: #fff
	}

	.bg-absences {
		background-color: #e63331!important
	}

	.bg-news {
		background-color: #e63331!important
	}

	.bg-senddocument {
		background-color: #e63331!important
	}

	.bg-paysheet {
		background-color: #e63331!important
	}

	.bg-taxcertificate {
		background-color: #e63331!important
	}

	.bg-documents {
		background-color: #e63331!important
	}

	.bg-documentreadconfirmation {
		background-color: #e63331!important
	}

	.bg-personaldocument {
		background-color: #e63331!important
	}

	.bg-certificaterequest {
		background-color: #e63331!important
	}

	.bg-paysheetreviewrequest {
		background-color: #e63331!important
	}

	.bg-lblhome {
		background-color: #e63331!important
	}

	.bg-socialbenefits {
		background-color: #e63331!important
	}

	.bg-frequentquestions {
		background-color: #e63331!important
	}

	.bg-history {
		background-color: #e63331!important
	}

	.bg-Generals {
		background-color: #e63331!important
	}

	.bg-generalleave {
		background-color: #e63331!important
	}

	.bg-holidays {
		background-color: #e63331!important
	}

	.bg-holidayleave {
		background-color: #e63331!important
	}

	.bg-expense {
		background-color: #e63331!important
	}

	.bg-jobcomplementrequest {
		background-color: #e63331!important
	}

	.bg-JobComplementRequest {
		background-color: #e63331!important
	}

	.bg-travelrequest {
		background-color: #e63331!important
	}

	.bg-TravelRequest {
		background-color: #e63331!important
	}

	.bg-advancerequest {
		background-color: #e63331!important
	}

	.bg-AdvanceRequest {
		background-color: #e63331!important
	}

	.bg-jobreport {
		background-color: #e63331!important
	}

	.bg-new-jobreport {
		background-color: #e63331!important
	}

	.bg-formacion {
		background-color: #e63331!important
	}

	.bg-fichajejornada {
		background-color: #e63331!important
	}

	.bg-evaluaciondesempeno {
		background-color: #e63331!important
	}

	.bg-EvaluacionDesempeno {
		background-color: #e63331!important
	}

	a.btn-primary {
		color: #fff
	}

	.JornadaColorFondo0 {
		background: #f1f1f1!important
	}

	.JornadaColorFondo1 {
		background: #fff!important
	}

	.LinkButtonDoc {
		color: #e5e5e5
	}

	.sitetitle {
		color: #292929
	}

	.sitetitle :hover {
		color: #292929
	}

	#top {
		background-color: transparent;
		border-color: transparent
	}

	#terms-condition h1 {
		color: #e63331
	}

	.generaldocuments-icon-bg,.evaluaciondesempenodocuments-icon-bg {
		background-color: #e63331
	}

	.generaldocuments-icon-bg:hover,.evaluaciondesempenodocuments-icon-bg:hover {
		background-color: #000
	}

	.generaldocuments-icon-bg {
		background-color: #e63331
	}

	.generaldocuments-icon-bg:hover {
		background-color: #000
	}

	.personaldocuments-icon-bg {
		background-color: #e63331
	}

	.documentList-content .img-thumbnail p {
		color: #fff;
		margin: 5px
	}

	#documentItemList .documentread>a:hover {
		color: #e63331!important
	}

	.greentrasperant {
		background-color: #267c39!important;
		border: none
	}

	.lnkAcknowledgment,.btnFirma {
		background-color: #e63331;
		border-color: #e63331;
		color: #fff;
		font-weight: 600
	}

	.lnkAcknowledgment:hover,.btnFirma:hover {
		background: #000;
		border-color: #000;
		color: #fff
	}

	.lnkAcknowledgmentDisable,.lnkAcknowledgmentDisable:hover {
		background-color: #e5e5e5!important;
		border-color: #e5e5e5!important;
		color: #fff
	}

	.snap-content .title h1 {
		font-weight: 300
	}

	.pagination a {
		color: #000;
		border: none;
		font-weight: bold;
		font-size: 16px
	}

	.pagination a:hover {
		color: #e63331
	}

	#Detail h3 {
		color: #e63331;
		border-bottom: 1px solid #e63331;
		padding-bottom: 5px
	}

	.file-curso a {
		padding: 16px 8px;
		border-bottom: 1px solid #e5e5e5
	}

	.file-curso a:hover {
		background: #f4f4f4
	}

	.formActionsbottom {
		margin-top: 1em;
		margin-bottom: 2em
	}

	.list-question-item {
		margin-bottom: 1em;
		border-bottom: 1px solid #000
	}

	.list-question-item .enunciado {
		margin-bottom: 8px
	}

	label.form-check-label {
		font-weight: 400;
		margin-left: 8px
	}

	p.ready {
		font-size: 20px;
		color: #119b23;
		font-weight: 600;
		margin: 1em 0
	}

	ul.ready-info li span {
		font-weight: 600
	}

	ul.ready-info li {
		display: inline-block;
		padding: 0 16px
	}

	ul.ready-info {
		margin: 0;
		padding: 0;
		list-style: none
	}

	.exam-realizado {
		margin-bottom: 2em
	}

	.comentario-rrhh label {
		margin-bottom: 8px
	}

	@media(max-width: 768px) {
		ul.ready-info li {
			display:block;
			padding: 8px
		}
	}

	#MyProfile .form-group {
		padding-bottom: 15px;
		border-bottom: 1px solid #e5e5e5
	}

	#MyProfile .form-group:last-child {
		border-bottom: none
	}

	#itemList hr {
		border-top: 1px solid #e5e5e5;
		margin: 10px 0
	}

	#itemList table thead tr th {
		color: #292929;
		font-weight: 300
	}

	#itemList table thead tr td {
		font-weight: 400;
		color: #292929
	}

	#itemList table>thead>tr {
		border-bottom: 1px solid #000
	}

	#itemList table>tbody>tr {
		border-bottom: 1px solid #e5e5e5
	}

	#itemList table>tbody>tr:nth-child(even) {
		background: #f1f1f1
	}

	#itemList .itemList-controls {
		height: 40px;
		border-bottom: 1px dashed #777
	}

	#itemList .itemList-controls .btn {
		background: none;
		font-weight: 600;
		font-size: 16px
	}

	#itemList .itemList-controls .btn i.fa {
		font-size: 20px
	}

	.itemList-header h1 {
		color: #000;
		border-bottom: 2px solid #000
	}

	#itemList .itemList-controls .btn {
		color: #e63331
	}

	#itemList .itemList-controls .btn:hover {
		color: #292929
	}

	#tblFormacion .colName {
		text-align: left
	}

	#tblGeneralLeave tbody tr td:last-child a {
		color: #fff;
		background-color: #292929!important
	}

	#tblExpense tbody tr td:last-child a {
		color: #fff;
		background-color: #292929!important
	}

	#tblAdvanceRequest tbody tr td:last-child a {
		color: #fff;
		background-color: #292929!important
	}

	#tblHolidayLeave tbody tr td:last-child a {
		color: #fff;
		background-color: #292929!important
	}

	#tblHolidayLeave-Resume>tbody>tr:nth-child(even) {
		background: transparent!important
	}

	#itemList #tblHolidayLeave-Resume thead tr th {
		color: #e63331;
		font-weight: 600
	}

	#itemList #tblHolidayLeave-Resume>tbody>tr td {
		font-weight: bold
	}

	#itemList #tblHolidayLeave-Resume>tbody>tr:last-child {
		border-bottom: 2px solid #000
	}

	#tblFichajeJornada tbody tr td:last-child a {
		color: #fff;
		background-color: #292929!important
	}

	#btnInicio,#btnReanudar {
		float: none!important;
		margin-top: 20px
	}

	@media screen and (min-width: 769px) {
		.itemList-header h1 {
			font-size:18px
		}

		#itemList .itemList-controls .title,#itemList .itemList-controls .title * {
			font-size: 18px;
			font-weight: 300
		}

		#itemList td.colAction {
			width: 180px
		}

		#itemList #tblExpense td.colAction {
			width: 220px
		}
	}

	@media(max-width: 768px) {
		#itemList .itemList-controls {
			background:#fff
		}

		#itemList .itemList-controls .btn {
			background: #e63331;
			color: #fff
		}

		.itemList-header h1 {
			font-size: 16px
		}

		#itemList tbody tr td:last-child a {
			font-size: 18px
		}
	}

	.news-list .title {
		font-size: 24px;
		font-weight: 300
	}

	.news-list .title>a {
		text-decoration: none
	}

	.news-list .title>a:hover {
		color: #e63331
	}

	.news-list .publish {
		color: #666;
		margin: 10px 0
	}

	.news-list .readmore>a {
		color: #e63331
	}

	#calendarItem div#calendar {
		max-width: 350px;
		margin: 0 auto;
		width: 100%
	}

</style>
